/* fitment.js - built-in vehicle fitment runtime (CONTRACT v1 + v1.1 submodel, PDP parity 2026-09-10). One IIFE, ES2019, no framework, no eval,
   no external URLs, defer-loaded after theme.js. The pure core runs without a DOM (node harness); the rest is browser only. */
(function (W) {
  'use strict';
  var theme = W.theme = W.theme || {}, cfg = theme.fitment = theme.fitment || {};
  var S = cfg.settings || {}, T = cfg.strings || {}, R = cfg.routes || {};
  var D = W.document && typeof W.document === 'object' ? W.document : null;
  var KEY = 'theme:fitment', FROM = 'theme:fitment:from', YEAR_MS = 365 * 864e5, MAX = S.maxVehicles || 10;
  var USER = ['select', 'add', 'change'], REPLACE = /^(url|restore|storage|prune)$/;
  /* header parity 2026-09-10: the only reasons that let the PDP verify widget verdict (and route). Live's
     Convermax widget re-reads the vehicle on a page load and nowhere else. */
  var LOADR = /^(url|restore)$/;
  var noop = () => {}, numAsc = (a, b) => a - b;

  /* ---------- pure helpers (twins of common.py / resolve.py / verify_pdp.py) ---------- */
  var slugMake = s => String(s).toLowerCase().replace(/\s+/g, '-');
  var slugModel = s => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  var slugBed = b => { var m = String(b || '').match(/^(\d+)'(?:(\d{1,2})")?$/); return m ? m[1] + '-' + (m[2] || '0') : ''; };
  /* bed-tolerance 2026-09-18 */
  /* one physical bed is carried under two labels by different brands (F-150 6.5 ft = 6'6" on the Revolver X4s,
     6'7" on the BAKFlip MX4; 8' / 8'2"; 5'7" / 5'8"). Within 2" = same bed; 3" apart can be two generations (Silverado HD 6'6"/6'9", Ram 6'1"/6'4"). */
  var bedIn = s => { var p = String(s || '').split('-'); return (+p[0] || 0) * 12 + (+p[1] || 0); };
  var bedEq = (a, b) => !!a && !!b && Math.abs(bedIn(a) - bedIn(b)) <= 2;
  var bedGroups = slugs => { var n = 0, last = -99; slugs.map(bedIn).sort(numAsc).forEach(x => { if (x - last > 2) n++; last = x; }); return n; };
  /* v1.1: an optional 5th segment carries the submodel slug; 3- and 4-part ids stay valid and identical.
     CAB-ENGINE 2026-10-21 (order #1060): optional 6th / 7th segments carry the cab and engine slugs; trailing empty
     segments are dropped, so every id without a cab or an engine is byte-identical to before. */
  var vehicleId = v => {
    var id = v.y + '|' + slugMake(v.mk) + '|' + slugModel(v.md) + '|' + (v.bed ? slugBed(v.bed) : ''), t = [v.sub, v.cab, v.eng].map(x => x ? slugModel(x) : '');
    while (t.length && !t[t.length - 1]) t.pop();
    return t.length ? id + '|' + t.join('|') : id;
  };
  var label = v => v ? [v.y, v.mk, v.md, v.sub, v.cab, v.eng, v.bed].filter(Boolean).join(' ') : '';
  var F_CAB = T.cab || 'Cab', F_ENG = T.engine || 'Engine', LEVELS = ['year', 'make', 'model', 'submodel', 'cab', 'engine', 'bed'], DETAIL = /^(submodel|cab|engine|bed)$/;
  /* REALTRUCK LOOK 2026-10-24: realtruck.com's site-wide Make list puts the truck makes first, a divider, then every
     other make; SEP marks the divider (a disabled option) */
  var TOP_MAKES = ['Chevrolet', 'Dodge', 'Ford', 'GMC', 'Jeep', 'Nissan', 'Ram', 'Toyota'], SEP = '\u0000sep';
  var topFirst = list => { var top = TOP_MAKES.filter(m => list.indexOf(m) >= 0), rest = list.filter(m => TOP_MAKES.indexOf(m) < 0); return top.length && rest.length ? top.concat([SEP], rest) : list; };
  /* a fitment.rows row's cab / engine (slots 7 + 8, present only when the product names one); '' = every cab / engine */
  var rowCab = r => r.length > 8 ? r[7] || '' : '', rowEng = r => r.length > 8 ? r[8] || '' : '';
  var decode = s => String(s == null ? '' : s).replace(/&#39;|&#x27;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&');
  var runSub = r => r.length > 4 ? r[4] : -1; /* index run [pid, y0, y1, bedIdx, subIdx]; a v1.0 run has no subIdx */
  var fmt = (s, map) => { s = String(s == null ? '' : s); for (var k in map) s = s.split(k).join(String(map[k])); return s; };
  var emit = (name, detail) => { if (D) D.dispatchEvent(new CustomEvent(name, { detail: detail })); };
  /* search parity 2026-09-10: a Convermax path-style URL (`?Year/2021/Make/Ford/Model/F-150[/Submodel/XLT][/Bed/5'7"]`, with or
     without a leading `Facet=`) reads as one id, so a forwarded /pages/search query still lands on the vehicle. The
     Submodel segment rides along as the id's 5th part; parseId() degrades a trim this index does not carry to
     no-submodel rather than pruning the whole vehicle. */
  var cmPathId = () => {
    var s, m;
    try { s = decodeURIComponent(W.location.search.slice(1).replace(/\+/g, ' ')); } catch (e) { return null; }
    m = s.match(/(?:^|[?&])(?:Facet=)?Year\/(\d{4})\/Make\/([^\/&]+)\/Model\/([^\/&]+)(?:\/Submodel\/([^\/&]+))?(?:\/Bed\/([^\/&]+))?/);
    return m ? m[1] + '|' + slugMake(m[2]) + '|' + slugModel(m[3]) + '|' + (m[5] ? slugBed(m[5]) : '') + (m[4] ? '|' + slugModel(m[4]) : '') : null;
  };
  var urlIds = () => { var q = D && new URLSearchParams(W.location.search).get('vehicle'), c; if (q) return q.split(',').map(s => s.trim()).filter(Boolean); c = D ? cmPathId() : null; return c ? [c] : []; };
  var inRun = (r, y) => r[1] <= y && y <= r[2];
  /* PDP verdict from the embedded rows (CONTRACT 9.6, v1.1): v2 rows [y0, y1, make, model, bed|"", sub|"", note|null];
     a v1 row [y0, y1, make, model, bed|"", note|null] reads as sub "" (wildcard) */
  /* CAB-ENGINE 2026-10-21 (order #1060: "Fits your 2018 GMC Sierra 3500 HD" on a gas-only step, diesel truck). Bed, cab and
     engine are judged the same way: a value the vehicle names narrows the rows (none left = nofit); a value it does not name
     only counts as fitting through a row that fits EVERY bed / cab / engine, and when no such row is left the shopper is
     asked for each missing one that the remaining rows depend on. With no cab / engine anywhere in the rows this is
     exactly the 2026-09-10 bed rule. Twins: verdict() in fitment-boot.liquid, verify_pdp.py. */
  function verdict(rows, v) {
    var mk = slugMake(v.mk), md = slugModel(v.md), bs = slugBed(v.bed), sbs = v.sub ? slugModel(v.sub) : '', cs = v.cab ? slugModel(v.cab) : '', es = v.eng ? slugModel(v.eng) : '', seen = new Set(), missing = [], ok, hit;
    var sub = r => r.length > 6 ? r[5] || '' : '', note = r => r.length > 6 ? r[6] : r[5], no = { state: 'nofit', notes: [], fields: [] };
    var cand = rows.filter(r => slugMake(r[2]) === mk && slugModel(r[3]) === md && +r[0] <= v.y && v.y <= +r[1]);
    if (!cand.length) return no;
    if (sbs) { cand = cand.filter(r => !sub(r) || slugModel(sub(r)) === sbs); if (!cand.length) return no; }
    else if (!cand.some(r => !sub(r))) missing.push(T.submodel);
    ok = cand.filter(r => (!v.bed || !r[4] || bedEq(slugBed(r[4]), bs)) && (!cs || !rowCab(r) || slugModel(rowCab(r)) === cs) && (!es || !rowEng(r) || slugModel(rowEng(r)) === es));
    if (!ok.length) return no;
    hit = ok.filter(r => (v.bed || !r[4]) && (cs || !rowCab(r)) && (es || !rowEng(r)));
    if (!hit.length) {
      if (!v.bed && ok.some(r => r[4])) missing.push(T.bed);
      if (!cs && ok.some(r => rowCab(r))) missing.push(F_CAB);
      if (!es && ok.some(r => rowEng(r))) missing.push(F_ENG);
    }
    if (missing.length) return { state: 'inexact', notes: [], fields: missing };
    /* FIT OPTIONS 2026-10-28: `hit` = the rows that fit, so fitCheck() can read each one's note against its own slots */
    return { state: 'fits', notes: hit.map(note).filter(n => n && !seen.has(n) && seen.add(n)), fields: [], hit: hit };
  }

  /* PDP parity 2026-09-10: does an INCOMPLETE selection (a year, optionally a make / model / submodel / bed)
     ALREADY rule this product out? Live writes properties[Fitment]="Doesn't fit your 2019 Ford" the moment it
     does and writes nothing while the partial could still fit (2021 Ford on a 2021-2026 product). */
  function misses(rows, p) {
    var y = +p.y, mk = p.mk ? slugMake(p.mk) : '', md = p.md ? slugModel(p.md) : '', sb = p.sub ? slugModel(p.sub) : '', bd = p.bed ? slugBed(p.bed) : '';
    var cs = p.cab ? slugModel(p.cab) : '', es = p.eng ? slugModel(p.eng) : '', sub = r => r.length > 6 ? r[5] || '' : '';
    if (!y || !rows || !rows.length) return false;
    return !rows.some(r => +r[0] <= y && y <= +r[1] && (!mk || slugMake(r[2]) === mk) && (!md || slugModel(r[3]) === md)
      && (!sb || !sub(r) || slugModel(sub(r)) === sb) && (!bd || !r[4] || bedEq(slugBed(r[4]), bd))
      && (!cs || !rowCab(r) || slugModel(rowCab(r)) === cs) && (!es || !rowEng(r) || slugModel(rowEng(r)) === es));
  }

  /* ---------- the group's own routing table (fitment.siblings), so a PDP never downloads the index ---------- */
  /* S = {mk, md, bd, sb, p:[[handle, sku, flags, [[y0, y1, mkIdx, mdIdx, bdIdx|-1, subIdx|-1]]]]}, members in
     index pid order; flags 1 = group master, 2 = runs omitted because the group hit the 64 kB metafield cap.
     sibRoute / sibRoutePartial are twins of FitmentIndex.routeSibling / routeSiblingPartial and MUST stay so:
     tests/test_siblings_parity.py compares them over every (member, vehicle) pair the index can express. */
  var sibUsable = (m, sku, handle) => !(m[2] & 3) && !!m[0] && !!m[1] && m[1] !== sku && m[0] !== handle;
  /* CAB-ENGINE 2026-10-21: a run's cab / engine slug in the group table (elements 6 + 7, only in a group that names one) */
  var sibCab = (S, r) => r.length > 7 && r[6] !== -1 && S.cb ? slugModel(S.cb[r[6]]) : '', sibEng = (S, r) => r.length > 7 && r[7] !== -1 && S.en ? slugModel(S.en[r[7]]) : '';
  /* the group members that carry v, each with: exact (its bed is v's bed), sure (it fits whatever cab / engine v leaves
     unnamed), and the cab / engine values its matching runs depend on */
  function sibCands(S, v, sku, handle) {
    var mk = slugMake(v.mk), md = slugModel(v.md), bs = v.bed ? slugBed(v.bed) : '', sb = v.sub ? slugModel(v.sub) : '', cs = v.cab ? slugModel(v.cab) : '', es = v.eng ? slugModel(v.eng) : '', out = [];
    S.p.forEach(m => {
      if (!sibUsable(m, sku, handle)) return;
      var any = false, bed = false, sure = false, dc = false, de = false;
      m[3].forEach(r => {
        if (v.y < r[0] || v.y > r[1] || slugMake(S.mk[r[2]]) !== mk || slugModel(S.md[r[3]]) !== md) return;
        var rb = r[4] === -1 ? '' : slugBed(S.bd[r[4]]), rs = r[5] === -1 ? '' : slugModel(S.sb[r[5]]), rc = sibCab(S, r), re = sibEng(S, r);
        if (bs && bedEq(rb, bs)) bed = true;                   /* index parity: the bed tie-break ignores the submodel */
        if ((sb && rs && rs !== sb) || (bs && rb && !bedEq(rb, bs)) || (cs && rc && rc !== cs) || (es && re && re !== es)) return;
        any = true;
        if (!cs && rc) dc = true;
        if (!es && re) de = true;
        if ((cs || !rc) && (es || !re)) sure = true;
      });
      if (any) out.push({ h: m[0], exact: bed, opt: !!(m[2] & 4), sure: sure, dc: dc, de: de });
    });
    return out;
  }
  function sibRoute(S, v, sku, handle) {
    /* CAB-ENGINE 2026-10-21: only a member that fits whatever cab / engine v leaves unnamed is a route target; when none
       does, the caller has already asked for them (sibQualNeed), so null here means nothing in the group fits for sure */
    var c = sibCands(S, v, sku, handle).filter(x => x.sure), ex;
    if (v.bed && (ex = c.filter(x => x.exact)).length) c = ex;
    /* 2026-09-16 (owner action B): a factory-option version (RamBox, Deck Rail, Multifunction Tailgate, CarbonPro)
       only wins when no plain sibling fits. Twins: FitmentIndex.routeSibling(), routeSib() in fitment-boot.liquid */
    var plain = c.filter(x => !x.opt);
    return plain.length ? plain[0].h : c.length ? c[0].h : null;
  }
  /* CAB-ENGINE 2026-10-21: the cab / engine the group needs before it can route v - members carry v, but every one of
     them depends on a cab or an engine v does not name (the N-Fab Crew Cab step vs its Double Cab sibling). [] = route. */
  function sibQualNeed(S, v, sku, handle) {
    if (!S || (v.cab && v.eng)) return [];
    var c = sibCands(S, v, sku, handle), out = [];
    if (!c.length || c.some(x => x.sure)) return out;
    if (c.some(x => x.dc)) out.push(F_CAB);
    if (c.some(x => x.de)) out.push(F_ENG);
    return out;
  }
  /* the incomplete Year/Make/Model twin (judge item 14): no bed / submodel narrowing, `bed` only tie-breaks */
  function sibRoutePartial(S, p, sku, handle, bed) {
    var mk = slugMake(p.mk), md = slugModel(p.md), bs = bed ? slugBed(bed) : '', hit = [], exact = [];
    S.p.forEach(m => {
      if (!sibUsable(m, sku, handle)) return;
      var any = false, be = false;
      m[3].forEach(r => {
        if (p.y < r[0] || p.y > r[1] || slugMake(S.mk[r[2]]) !== mk || slugModel(S.md[r[3]]) !== md) return;
        any = true;
        if (bs && r[4] !== -1 && bedEq(slugBed(S.bd[r[4]]), bs)) be = true;
      });
      if (any) { hit.push(m[0]); if (be) exact.push(m[0]); }
    });
    if (bs && exact.length) hit = exact;
    return hit.length ? hit[0] : null;
  }

  /* 2026-09-14 (owner, action A): a vehicle with no bed is never routed while the group members carrying its
     year/make/model differ by bed; the widget asks for the bed instead of guessing. Twin: bedAmbig() in fitment-boot.liquid. */
  function sibBedAmbiguous(S, v, sku, handle) {
    if (!S || v.bed) return false;
    var mk = slugMake(v.mk), md = slugModel(v.md), beds = new Set();
    S.p.forEach(m => {
      if (!sibUsable(m, sku, handle)) return;
      m[3].forEach(r => { if (r[4] !== -1 && v.y >= r[0] && v.y <= r[1] && slugMake(S.mk[r[2]]) === mk && slugModel(S.md[r[3]]) === md) beds.add(slugBed(S.bd[r[4]])); });
    });
    return bedGroups(Array.from(beds)) > 1;
  }

  /* ---------- FIT OPTIONS 2026-10-28 (owner: "match RealTruck word for word") ----------
     realtruck.com asks for every detail a part depends on beyond the truck (RamBox, body style, 4WD, trim, lift height) as
     a required "Option" pick under the vehicle, and its Add to Cart stays off until it is answered. Here that detail sat in
     grey text under a green "Fits Your Vehicle" on 4,022 products, and it was the top return cause (owner 10-28: a classic
     vs a new body of the same model and year, a diesel vs a gas truck). A note is now ASKED unless the truck's own levels
     already settle it:
       - an info clause ("with or without ...", "... not included") is shown, never asked;
       - a Cab / Engine / Bed clause on a row that carries that level is already matched by verdict();
       - a body word ("New Body", "Legacy (2018 Body Style)", "JK") only matters in a year that sold two bodies under one
         name, and there the Body Style question (TWINS) settles it;
       - anything else is a condition: the shopper picks the one that matches the truck, or "None of these".
     The Option list holds every version of the product line that carries the truck (a sibling's rows come from
     sections/fitment-rows.liquid), so a pick lands on the right version, as RealTruck's drill resolves a SKU. RealTruck
     auto-fills a lone option; we never do (its BedStep 75323-01A auto-filled "New Body" is the owner's classic-vs-new case). */
  var FO_INFO = /\bwith or without\b|\bw\/ or w\/o\b|\bor without\b|\bnot included\b|\bsold separately\b|^incl(?:\.|udes?|uding)?\b|\bmay (?:restrict|require)\b|^super duty$/i;
  var FO_GEN = /^(?:new body(?: style)?|legacy(?:\s*\(20\d\d body style\))?|(?:limited|ltd)\s*\(20\d\d body style\)|ltd|classic(?: body)?|heritage|old body(?: style)?|previous body(?: style)?|d[st] body(?:\s*\(w\/ [56]-lug wheels\))?|[56]-lug(?: wheels)?|jk|jl|jt|tj|tj\s*\/\s*lj|\d(?:st|nd|rd|th) gen(?:eration)?|20\d\d\+? gen(?:eration)?)$/i;
  var FO_STYLE = /^(?:styleside|fleetside|flareside|stepside|sportside)(?: (?:bed|box))?$/i;
  var FO_CAB = /\b(?:(?:regular|reg\.?|standard|extended|ext\.?|double|crew|quad|mega|access|king|club)\s*-?\s*cabs?|super\s?cab|super\s?crew|crew\s?max|[24]-door)\b/gi;
  var FO_ENG = /\b\d{1,2}\.\d\s*l\b|\bduramax\b|\bpower\s?stroke\b|\bcummins\b|\becodiesel\b|\bdiesel\b|\bgas(?:oline)?\b|\bhemi\b|\becoboost\b|\bpowerboost\b/gi;
  var FO_FILL = /\b(?:only|and|or|models?|trucks?|engines?|w\/o?|with|without|not|for|no|non|except|v\d{1,2}|[il]\d|turbo)\b|[\/&,.()+'"-]/gi;
  /* a clause that only names a bed ("5'7\" Bed", "Bed: 8' Long Box", "6.5 ft bed"): its length in inches, 0 = a bed with
     no length ("Long Box"), null = not a bed clause. Some covers keep their bed in the note, not in the Bed level. */
  var FO_BEDLEN = /(\d{1,2})'\s*(?:(\d{1,2})")?|(\d{1,2}(?:\.\d)?)\s*(?:ft|foot|feet)\b/;
  var bedOfClause = c => {
    var m = c.match(FO_BEDLEN), rest;
    if (!m && !/\b(?:bed|box)\b/i.test(c)) return null;
    rest = c.replace(new RegExp(FO_BEDLEN.source, 'g'), ' ').replace(/\bbed\b\s*:?|\b(?:long|short|standard|regular|full)\s+(?:box|bed)\b|\bbox\b/gi, ' ').replace(FO_FILL, ' ').trim();
    if (rest) return null;
    return m ? (m[3] ? Math.round(parseFloat(m[3]) * 12) : +m[1] * 12 + +(m[2] || 0)) : 0;
  };
  /* a row whose note names a bed the truck does not have (more than 2" off, the storefront's bed tolerance) */
  var bedOff = (r, v) => { var vi = v.bed ? bedIn(slugBed(v.bed)) : 0; return !!vi && clauses(rowNote(r)).some(c => { var b = bedOfClause(c); return b > 0 && Math.abs(b - vi) > 2; }); };
  var NONE = '__none__';
  /* TWINS: [make, base model (the new body, as our data names it), the old body's model, first year, last year,
     RealTruck's labels for the new / old body, the words a base-model row's note uses for the old body, a model name that
     covers both bodies (Jeep's plain "Wrangler"), the one-line help under the question]. Years from config/vehicle-universe.json. */
  var CLASSIC = /classic|old body/i;
  var TWINS = [
    ['Chevrolet', 'Silverado 1500', 'Silverado 1500 LD', 2019, 2019, 'New Body', 'Legacy (2018 Body Style)', /legacy|\bld\b|2018 body/i, '', 'The Legacy (2018 Body Style) Silverado 1500 LD was sold new alongside the new body in 2019.', 'New Body', 'Legacy, 2018 Body Style'],
    ['Chevrolet', 'Silverado 1500', 'Silverado 1500 LTD', 2022, 2022, 'New Body', 'LTD (2021 Body Style)', /\bltd\b|limited|2021 body/i, '', 'The LTD (2021 Body Style) was sold new alongside the new body in 2022.', 'New Body', '2021 Body Style'],
    ['GMC', 'Sierra 1500', 'Sierra 1500 Limited', 2019, 2019, 'New Body', 'Limited (2018 Body Style)', /limited|legacy|2018 body/i, '', 'The Limited (2018 Body Style) was sold new alongside the new body in 2019.', 'New Body', '2018 Body Style'],
    ['GMC', 'Sierra 1500', 'Sierra 1500 Limited', 2022, 2022, 'New Body', 'Limited (2021 Body Style)', /limited|2021 body/i, '', 'The Limited (2021 Body Style) was sold new alongside the new body in 2022.', 'New Body', '2021 Body Style'],
    ['Chevrolet', 'Silverado 1500', 'Silverado 1500 Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['Chevrolet', 'Silverado 2500 HD', 'Silverado 2500 HD Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['Chevrolet', 'Silverado 3500 HD', 'Silverado 3500 Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['GMC', 'Sierra 1500', 'Sierra 1500 Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['GMC', 'Sierra 1500 HD', 'Sierra 1500 HD Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['GMC', 'Sierra 2500 HD', 'Sierra 2500 HD Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['GMC', 'Sierra 3500 HD', 'Sierra 3500 Classic', 2007, 2007, 'New Body', 'Classic', CLASSIC, '', 'The Classic (2006 Body Style) was sold new alongside the new body in 2007.', 'New Body', '2006 Body Style'],
    ['Ford', 'F-150', 'F-150 Heritage', 2004, 2004, 'New Body', 'Heritage', /heritage|old body/i, '', 'The F-150 Heritage (2003 Body Style) was sold new alongside the new body in 2004.', 'New Body', '2003 Body Style'],
    ['Ram', '1500', '1500 Classic', 2019, 2024, 'New Body (DT)', 'Classic (DS)', /classic|\bds\b|5-lug/i, '', 'The Ram 1500 Classic (DS, 5-lug wheels) was sold new alongside the new body (DT, 6-lug wheels) from 2019 to 2024.', 'New Body, DT', 'Old Body, DS'],
    ['Jeep', 'Wrangler JL', 'Wrangler JK', 2018, 2018, 'JL', 'JK', /\bjk\b/i, 'Wrangler', 'The JK (2007 to 2018 body) was sold new alongside the new JL in 2018.', 'New Body', 'Old Body'],
  ];
  var FO_NEWB = /new body|\bdt\b|6-lug|\bjl\b/i;
  var rowNote = r => (r.length > 6 ? r[6] : r[5]) || '';
  var twinFor = v => {
    if (!v || !v.mk || !v.md) return null;
    var mk = slugMake(v.mk), md = slugModel(v.md), y = +v.y;
    return TWINS.find(e => slugMake(e[0]) === mk && y >= e[3] && y <= e[4] && (md === slugModel(e[1]) || md === slugModel(e[2]) || (!!e[8] && md === slugModel(e[8])))) || null;
  };
  /* which body a row of the twin family names: 'new' | 'old' | 'both', null = not this family (base-model rows are the new
     body unless their note names the old one: realtruck.com writes "Legacy (2018 Body Style)" on its own Silverado 1500) */
  /* a body word that the note names in order to EXCLUDE it ("Excludes 2019 Chevrolet LD & GMC Limited", "Except 2004
     F150 Heritage Edition", "Not for Ram 1500 Classic"): the row is the other body */
  var FO_NEG = /\b(?:except|excludes?|excluding|not(?:\s+for|\s+compatible\s+with)?|w\/o|without|no|non)\b[^,;.]*$/i;
  var names = (re, n) => { var m = n.match(re); return !!m && !FO_NEG.test(n.slice(0, m.index)); };
  var rowBody = (e, r) => {
    var md = slugModel(r[3]), n = rowNote(r);
    if (slugMake(r[2]) !== slugMake(e[0])) return null;
    if (md === slugModel(e[2])) return 'old';
    if (md === slugModel(e[1])) return names(e[7], n) ? 'old' : 'new';
    if (e[8] && md === slugModel(e[8])) return names(e[7], n) ? 'old' : names(FO_NEWB, n) ? 'new' : 'both';
    return null;
  };
  /* the body the vehicle itself names: the old body's model is explicit, so is Jeep's "Wrangler JL"; a plain base model is
     only known once the shopper has answered (the LD owner who picked "Silverado 1500" is the case this exists for) */
  var vBody = (e, v, a) => { var md = slugModel(v.md); if (md === slugModel(e[2])) return 'old'; if (e[8] && md === slugModel(e[1])) return 'new'; return a === 'new' || a === 'old' ? a : null; };
  /* the twin family's rows re-written onto the base / old model by the body they name ('both' = one of each) */
  var twinRows = (e, rows) => {
    var out = [];
    rows.forEach(r => {
      var b = rowBody(e, r), c;
      if (!b) { out.push(r); return; }
      if (b !== 'old') { c = r.slice(); c[3] = e[1]; out.push(c); }
      if (b !== 'new') { c = r.slice(); c[3] = e[2]; out.push(c); }
    });
    return out;
  };
  /* a note's clauses (";", ", " outside brackets, and sentences: "Not compatible with the CarbonPro bed. Works with or
     without the rails." is one condition and one info line) */
  var clauses = n => String(n || '').replace(/\b(incl|approx|vs|no)\./gi, '$1').split(/\s*;\s*|,\s+(?![^(]*\))|\.\s+(?=[A-Z])/).map(s => s.trim()).filter(Boolean);
  /* does this clause of row r still need the shopper's answer for vehicle v? */
  var askClause = (c, v, r) => {
    var b;
    if (FO_INFO.test(c) || FO_GEN.test(c)) return false;
    if (FO_STYLE.test(c)) return +v.y <= 2009;                                 /* Flareside / Stepside beds ended in 2009 */
    if ((b = bedOfClause(c)) !== null) return !r[4] && !(b && v.bed && Math.abs(b - bedIn(slugBed(v.bed))) <= 2);
    if (c.match(FO_CAB) && !c.replace(FO_CAB, ' ').replace(FO_FILL, ' ').trim()) return !rowCab(r);
    if (c.match(FO_ENG) && !c.replace(FO_ENG, ' ').replace(FO_FILL, ' ').trim()) return !rowEng(r);
    return true;
  };
  var needsAsk = (r, v) => clauses(rowNote(r)).some(c => askClause(c, v, r));
  /* RealTruck's wording: "w/" and "w/o", clauses joined with ", "; never a dash */
  var noteText = n => String(n || '').replace(/\s*[–—]\s*/g, ', ').replace(/\bwithout\b/gi, 'w/o').replace(/\bwith\b(?!\s+or\b)/gi, 'w/').replace(/\s*;\s*/g, ', ').replace(/\s{2,}/g, ' ').replace(/[.\s]+$/, '').trim()
    .split(', ').map(c => /^w\//.test(c) ? c : c.charAt(0).toUpperCase() + c.slice(1)).join(', ');   /* "4WD, Diesel"; "w/o RamBox" stays */
  var optKey = n => noteText(n).toLowerCase().replace(/[^a-z0-9/]+/g, ' ').trim();
  /* one product's answer for vehicle v (body = the shopper's Body Style answer for v, if any):
     {state: fits | nofit | inexact | body, fields, sure (fits with nothing to confirm), ask: [notes to confirm],
      info: [notes to show], tw: the twin family or null, only: the one body this product fits ('new' | 'old' | null)} */
  function fitCheck(rows, v, body) {
    var tw = twinFor(v), only = null, r, vv = v, b, tr, vN, vO, rN, rO, okN, okO, ask = [], info = [], sure = false;
    var out = (st, f) => ({ state: st, fields: f || [], sure: false, ask: [], info: [], tw: tw, only: only });
    if (tw) {
      tr = twinRows(tw, rows); vN = Object.assign({}, v, { md: tw[1] }); vO = Object.assign({}, v, { md: tw[2] });
      rN = verdict(tr, vN); rO = verdict(tr, vO); okN = rN.state !== 'nofit'; okO = rO.state !== 'nofit';
      if (okN !== okO) only = okN ? 'new' : 'old';
      b = vBody(tw, v, body);
      if (b) { r = b === 'old' ? rO : rN; vv = b === 'old' ? vO : vN; }
      else if (okN && okO) { r = rN; vv = vN; }                                  /* fits either body: the body does not matter */
      else if (okN || okO) return out('body');
      else return out('nofit');
    } else r = verdict(rows, v);
    if (r.state !== 'fits') return out(r.state, r.fields);
    r.hit = r.hit.filter(row => !bedOff(row, vv));
    if (!r.hit.length) return out('nofit');
    r.hit.forEach(row => {
      var n = rowNote(row);
      if (!needsAsk(row, vv)) { sure = true; if (n && info.indexOf(n) < 0) info.push(n); }
      else if (ask.indexOf(n) < 0) ask.push(n);
    });
    return { state: 'fits', fields: [], sure: sure, ask: sure ? [] : ask, info: info, tw: tw, only: only };
  }
  /* the levels (Bed / Cab / Engine / Submodel) this product needs for v; in a two-body year over the body or bodies the
     truck can be, so a Silverado 1500 LD shopper is asked the bed of a "Silverado 1500 ... Legacy (2018 Body Style)" row */
  var fitFields = (rows, v) => {
    var e = twinFor(v), tr, b, f = [];
    if (!e) return verdict(rows, v).fields || [];
    tr = twinRows(e, rows); b = vBody(e, v, fitAns.body(v));
    (b === 'old' ? [e[2]] : b === 'new' ? [e[1]] : [e[1], e[2]]).forEach(md => (verdict(tr, Object.assign({}, v, { md: md })).fields || []).forEach(x => { if (f.indexOf(x) < 0) f.push(x); }));
    return f;
  };
  /* the Option list over the product line: members = [{h, d: fitCheck()}] (this page first). A pick of one note lands on
     the member that carries it; "None of these" on a member that fits with nothing to confirm (this page first), else on
     nothing (= Does Not Fit). [] = nothing to ask. */
  function fitOptions(members) {
    var list = [], keys = new Set(), none = null;
    members.forEach(m => {
      if (!m || !m.d || m.d.state !== 'fits') return;
      if (m.d.sure) { if (none == null) none = m.h; return; }
      m.d.ask.forEach(n => { var k = optKey(n); if (k && !keys.has(k)) { keys.add(k); list.push({ k: k, t: noteText(n), h: m.h }); } });
    });
    return { list: list, none: none };
  }

  /* ---------- FitmentIndex: schema v1, derived maps, cascade, resolve(), routeSibling() ---------- */
  class FitmentIndex {
    constructor(url) { this.url = url; this.data = null; this.promise = null; }
    load() {
      if (this.data) return Promise.resolve(this);
      return this.promise || (this.promise = fetch(this.url, { credentials: 'omit' })
        .then(r => { if (!r.ok) throw new Error('index ' + r.status); return r.json(); })
        .then(j => this.setData(j))
        .catch(e => { this.promise = null; emit('fitment:index-error', { error: e }); throw e; }));
    }
    setData(j) {
      if (!j || j.v !== 1 || !Array.isArray(j.products) || (typeof j.fits !== 'object' && typeof j.fitg !== 'object')) throw new Error('bad index');
      var d = this.data = j, m = this.modelBySlug = new Map(), b = this.bedBySlug = new Map(), sb = this.subBySlug = new Map(), ys = new Set();
      var cb = this.cabBySlug = new Map(), en = this.engBySlug = new Map();
      this.collIdxById = new Map(); this.collIdxByHandle = new Map(); this.groupIdxByName = new Map();
      d.models.forEach((md, i) => { var k = slugMake(d.makes[md[0]]) + '|' + slugModel(md[1]); if (!m.has(k)) m.set(k, i); });
      d.beds.forEach((bd, i) => { var k = slugBed(bd); if (!b.has(k)) b.set(k, i); });
      (d.subs || []).forEach((sn, i) => { var k = slugModel(sn); if (k && !sb.has(k)) sb.set(k, i); });
      /* CAB-ENGINE 2026-10-21: `cabs` / `engines` vocabularies, `fitq` (the full runs of every product flagged 64, which
         replace that product's cab/engine-less `fitg` runs) and `vx` (each truck's own cab + engine list, per year) */
      (d.cabs || []).forEach((c, i) => { var k = slugModel(c); if (k && !cb.has(k)) cb.set(k, i); });
      (d.engines || []).forEach((e, i) => { var k = slugModel(e); if (k && !en.has(k)) en.set(k, i); });
      (d.collections || []).forEach((c, i) => { this.collIdxById.set(String(c.id), i); this.collIdxByHandle.set(c.h, i); });
      (d.groups || []).forEach((n, i) => this.groupIdxByName.set(n, i));
      this.runCache = new Map(); this._fk = null;
      /* the year list comes straight off the signature rows, so a fitg index never expands a single
         run just to boot: [y0, y1, bedIdx, subIdx, pid0, dpid...] */
      if (d.fitg) { for (var k in d.fitg) d.fitg[k].forEach(g => { for (var y = g[0]; y <= g[1]; y++) ys.add(y); }); }
      else for (var k2 in d.fits) d.fits[k2].forEach(r => { for (var y2 = r[1]; y2 <= r[2]; y2++) ys.add(y2); });
      this.yearList = Array.from(ys).sort((a, c) => c - a);
      if (D) D.documentElement.classList.add('fitment-ready');
      emit('fitment:index-ready', { built: d.built, products: d.products.length });
      return this;
    }
    /* speed 2026-09-11: `fitg` collapses the 40,879 flat runs into the 3,811 DISTINCT
       (y0, y1, bedIdx, subIdx) signatures they fall into and delta-codes the pids that share one,
       which takes the served index from 103.6 KB to ~53 KB and its text from 4.0 MB to 389 KB.
       A model's flat runs are rebuilt on first use and cached; the legacy flat `fits` still reads. */
    fkeys() { return this._fk || (this._fk = Object.keys(this.data.fitg || this.data.fits)); }
    /* a run is [pid, y0, y1, bedIdx, subIdx, cabIdx, engIdx]; -1 = every bed / submodel / cab / engine. A flag-64
       product's runs come from `fitq` (with its cabs and engines); everyone else's from `fitg` (cab + engine -1). */
    runs(mi) {
      var d = this.data, k = String(mi), P = d.products, c, g, out, pid, i, j;
      if ((c = this.runCache.get(k))) return c;
      if (!d.fitg) out = (d.fits[k] || []).map(r => [r[0], r[1], r[2], r[3], r.length > 4 ? r[4] : -1, -1, -1]);
      else {
        g = d.fitg[k] || []; out = [];
        for (i = 0; i < g.length; i++) {
          pid = g[i][4];
          out.push([pid, g[i][0], g[i][1], g[i][2], g[i][3], -1, -1]);
          for (j = 5; j < g[i].length; j++) { pid += g[i][j]; out.push([pid, g[i][0], g[i][1], g[i][2], g[i][3], -1, -1]); }
        }
      }
      if (d.fitq) {
        out = out.filter(r => !(P[r[0]][1] & 64));
        g = d.fitq[k] || [];
        for (i = 0; i < g.length; i++) {
          pid = g[i][6];
          out.push([pid, g[i][0], g[i][1], g[i][2], g[i][3], g[i][4], g[i][5]]);
          for (j = 7; j < g[i].length; j++) { pid += g[i][j]; out.push([pid, g[i][0], g[i][1], g[i][2], g[i][3], g[i][4], g[i][5]]); }
        }
      }
      this.runCache.set(k, out);
      return out;
    }
    hasYear(mi, y) { return this.runs(mi).some(r => inRun(r, y)); }
    years() { return this.yearList; }
    makes(y) {
      var d = this.data, set = new Set();
      this.fkeys().forEach(k => { if (this.hasYear(k, y)) set.add(d.models[k][0]); });
      return Array.from(set).sort((a, b) => d.makes[a].localeCompare(d.makes[b]));
    }
    models(y, makeIdx) {
      var d = this.data, out = [];
      this.fkeys().forEach(k => { if (d.models[k][0] === makeIdx && this.hasYear(k, y)) out.push(+k); });
      return out.sort((a, b) => d.models[a][1].localeCompare(d.models[b][1]));
    }
    /* subIdx of every trim-specific run of mi covering y, sorted by name; [] = the Submodel level is dropped (live) */
    submodels(y, mi) {
      var d = this.data, set = new Set();
      this.runs(mi).forEach(r => { var s = runSub(r); if (s !== -1 && inRun(r, y)) set.add(s); });
      return Array.from(set).sort((a, b) => d.subs[a].localeCompare(d.subs[b]));
    }
    /* PDP parity 2026-09-10: with a make but no model yet, live keeps a level only while SOME model of that make
       offers it (2019 Polaris drops Submodel and Bed and the widget falls to three rows). Counts, per make/year. */
    levelsForMake(y, makeIdx) {
      var d = this.data, sub = 0, bed = 0, cab = 0, eng = 0;
      this.fkeys().forEach(k => {
        if (d.models[k][0] !== makeIdx) return;
        this.runs(k).forEach(r => { if (!inRun(r, y)) return; if (runSub(r) !== -1) sub++; if (r[3] !== -1) bed++; if (r[5] !== -1) cab++; if (r[6] !== -1) eng++; });
      });
      return { sub: sub, bed: bed, cab: cab, eng: eng };
    }
    /* CAB-ENGINE 2026-10-21: the Cab / Engine choices for (y, mi) - the truck's own list (`vx`, RealTruck's) plus any value a
       run names - offered only when some run of mi covering y names one ([] = the level is dropped, as for Submodel) */
    quals(y, mi, slot) {
      var d = this.data, set = new Set(), named = false, names = slot === 5 ? d.cabs : d.engines;
      if (!names) return [];
      this.runs(mi).forEach(r => { if (r[slot] !== -1 && inRun(r, y)) { named = true; set.add(r[slot]); } });
      if (!named) return [];
      ((d.vx || {})[String(mi)] || []).forEach(x => { if (x[0] <= y && y <= x[1]) (slot === 5 ? x[2] : x[3]).forEach(i => set.add(i)); });
      return Array.from(set).sort((a, b) => names[a].localeCompare(names[b]));
    }
    cabs(y, mi) { return this.quals(y, mi, 5); }
    engines(y, mi) { return this.quals(y, mi, 6); }
    /* bedIdx of every bed-specific run of mi covering y that applies to sub (a wildcard run applies to every submodel; sub null = every run) */
    beds(y, mi, sub) {
      var d = this.data, set = new Set(), si = this.subIdx(sub), key = i => { var p = slugBed(d.beds[i]).split('-'); return p[0] * 100 + (+p[1] || 0); };
      this.runs(mi).forEach(r => { var s = runSub(r); if (r[3] !== -1 && inRun(r, y) && (si === null || s === -1 || s === si)) set.add(r[3]); });
      var last = -99; /* collapse labels within 3" to one entry (bed-tolerance) */
      return Array.from(set).sort((a, b) => key(a) - key(b)).filter(i => { var x = bedIn(slugBed(d.beds[i])); if (x - last <= 2) return false; last = x; return true; });
    }
    modelIdx(mk, md) { var i = this.modelBySlug.get(slugMake(mk) + '|' + slugModel(md)); return i == null ? null : i; }
    bedIdx(bed) { var i = this.bedBySlug.get(slugBed(bed)); return i == null ? -2 : i; }
    bedSet(bed) { var s = slugBed(bed), out = new Set(); if (s) this.data.beds.forEach((b, i) => { if (bedEq(slugBed(b), s)) out.add(i); }); return out; }
    subIdx(sub) { var k = sub ? slugModel(sub) : '', i; if (!k) return null; i = this.subBySlug.get(k); return i == null ? -2 : i; } /* null = wildcard, -2 = unknown (matches wildcard runs only) */
    cabIdx(cab) { var k = cab ? slugModel(cab) : '', i; if (!k) return null; i = this.cabBySlug.get(k); return i == null ? -2 : i; }
    engIdx(eng) { var k = eng ? slugModel(eng) : '', i; if (!k) return null; i = this.engBySlug.get(k); return i == null ? -2 : i; }
    /* does run r carry v on bed / sub / cab / engine (year already checked)? bi = bedSet or null; si / ci / ei = idx or null */
    runOk(r, bi, si, ci, ei) { return (bi === null || r[3] === -1 || bi.has(r[3])) && (si === null || runSub(r) === -1 || runSub(r) === si) && (ci === null || r[5] === -1 || r[5] === ci) && (ei === null || r[6] === -1 || r[6] === ei); }
    makeIdxOf(mi) { return this.data.models[mi][0]; }
    collIdx(id, handle) {
      var i = id ? this.collIdxById.get(String(id)) : undefined;
      if (i == null && handle) i = this.collIdxByHandle.get(handle);
      return i == null ? undefined : i;
    }
    featuredPos(pid, ci) { var c = this.data.products[pid][3].find(x => x[0] === ci); return c ? c[1] : null; }
    parseId(id) {
      var p = String(id || '').split('|'), d = this.data;
      if (p.length < 3 || p.length > 7 || !/^\d{4}$/.test(p[0])) return null;
      var mi = this.modelBySlug.get(p[1] + '|' + p[2]), bi = p[3] ? this.bedBySlug.get(p[3]) : -1, si = p[4] ? this.subBySlug.get(p[4]) : -1;
      var ci = p[5] ? this.cabBySlug.get(p[5]) : -1, ei = p[6] ? this.engBySlug.get(p[6]) : -1;
      if (si == null) si = -1; /* a trim this index does not carry drops the SUBMODEL, not the vehicle */
      if (ci == null) ci = -1; /* likewise a cab / engine (CAB-ENGINE 2026-10-21) */
      if (ei == null) ei = -1;
      if (mi == null || bi == null) return null;
      var md = d.models[mi], v = { y: +p[0], mk: d.makes[md[0]], md: md[1], sub: si >= 0 ? d.subs[si] : null, bed: bi >= 0 ? d.beds[bi] : null, t: Date.now() };
      if (ci >= 0) v.cab = d.cabs[ci];
      if (ei >= 0) v.eng = d.engines[ei];
      v.id = vehicleId(v);
      return v;
    }
    /* Map<pid, Vehicle|null> after every scope rule (null = universal-only member); resolve() = its sorted keys. */
    match(vehicles, scope) {
      scope = scope || {};
      var P = this.data.products, hit = new Map(), out = new Map(), ci = scope.collIdx;
      (vehicles || []).forEach(v => {
        var mi = this.modelIdx(v.mk, v.md), bi = v.bed ? this.bedSet(v.bed) : null, si = this.subIdx(v.sub), ci = this.cabIdx(v.cab), ei = this.engIdx(v.eng);
        if (mi != null) this.runs(mi).forEach(r => { if (inRun(r, v.y) && this.runOk(r, bi, si, ci, ei) && !hit.has(r[0])) hit.set(r[0], v); });
      });
      if (scope.includeUniversal) P.forEach((p, i) => { if ((p[1] & 2) && !hit.has(i)) hit.set(i, null); });
      Array.from(hit.keys()).sort(numAsc).forEach(pid => {
        var p = P[pid];
        if ((ci != null && !p[3].some(c => c[0] === ci)) || (p[1] & 1) || !p[0] || (scope.strictGroups && p[2] !== -1 && !(p[1] & 4))) return;
        out.set(pid, hit.get(pid));
      });
      return out;
    }
    resolve(vehicles, scope) { return Array.from(this.match(vehicles, scope).keys()); }
    /* in-page widget before the vehicle is complete (live filters on every select change): every model of the chosen make
       (or just the chosen model) over the year, bed narrowing when chosen. Map<pid, null> after the same scope rules as match(). */
    matchPartial(p, scope) {
      scope = scope || {};
      var d = this.data, P = d.products, hit = new Map(), out = new Map(), ci = scope.collIdx, y = +p.y;
      var mk = p.mk ? d.makes.indexOf(p.mk) : -1, mi = p.md ? this.modelIdx(p.mk, p.md) : null, bi = p.bed ? this.bedSet(p.bed) : null, si = this.subIdx(p.sub), ci = this.cabIdx(p.cab), ei = this.engIdx(p.eng);
      if (!y || (p.mk && mk < 0) || (p.md && mi == null)) return out;
      this.fkeys().forEach(k => {
        if (mi != null ? +k !== mi : (mk >= 0 && d.models[k][0] !== mk)) return;
        this.runs(k).forEach(r => { if (inRun(r, y) && this.runOk(r, bi, si, ci, ei) && !hit.has(r[0])) hit.set(r[0], null); });
      });
      if (scope.includeUniversal) P.forEach((q, i) => { if ((q[1] & 2) && !hit.has(i)) hit.set(i, null); });
      Array.from(hit.keys()).sort(numAsc).forEach(pid => {
        var q = P[pid];
        if ((ci != null && !q[3].some(c => c[0] === ci)) || (q[1] & 1) || !q[0] || (scope.strictGroups && q[2] !== -1 && !(q[1] & 4))) return;
        out.set(pid, null);
      });
      return out;
    }
    /* Browse (no vehicle) = what Convermax shows: masters + ungrouped products, never children. Map<pid, null>. */
    browseSet(ci) {
      var out = new Map();
      this.data.products.forEach((p, pid) => {
        if (!p[0]) return;
        if (p[2] !== -1 && !(p[1] & 1)) return;
        if (ci != null && !p[3].some(c => c[0] === ci)) return;
        out.set(pid, null);
      });
      return out;
    }
    /* PDP parity 2026-09-10 (judge item 14): live swaps a child page for its sibling as soon as an INCOMPLETE
       Year/Make/Model rules the open product out - no vehicle is stored and the sibling opens idle. `bed` is the
       bed the shopper is already looking at, which live keeps (2019/Ford/F-150 on the 5'7" Lightning lands on the
       5'7" 2015-2020 F-150, not on the 6'5" one). */
    routeSiblingPartial(groupIdx, p, currentSku, bed) {
      var P = this.data.products, mi = this.modelIdx(p.mk, p.md), bi = bed ? this.bedSet(bed) : null, runs, exact;
      if (mi == null) return null;
      runs = this.runs(mi);
      var cands = Array.from(this.matchPartial({ y: p.y, mk: p.mk, md: p.md }, { includeUniversal: false, strictGroups: false }).keys())
        .filter(pid => P[pid][2] === groupIdx && P[pid][4] !== '' && P[pid][0] !== currentSku);
      if (bi && bi.size) { exact = cands.filter(pid => runs.some(r => r[0] === pid && bi.has(r[3]) && inRun(r, p.y))); if (exact.length) cands = exact; }
      return cands.length ? P[cands[0]][4] : null;
    }
    /* CAB-ENGINE 2026-10-21: true when pid carries v whatever cab / engine v leaves unnamed (a run matching v that is
       -1 on each of them). A product without cab / engine runs is always sure. */
    sure(pid, v) {
      var mi = this.modelIdx(v.mk, v.md), bi = v.bed ? this.bedSet(v.bed) : null, si = this.subIdx(v.sub), ci = this.cabIdx(v.cab), ei = this.engIdx(v.eng);
      if (mi == null || !(this.data.products[pid][1] & 64)) return true;
      return this.runs(mi).some(r => r[0] === pid && inRun(r, v.y) && this.runOk(r, bi, si, ci, ei) && (ci !== null || r[5] === -1) && (ei !== null || r[6] === -1));
    }
    /* the cab / engine fields pid needs before it can say "fits" v ([] = none) */
    needs(pid, v) {
      var mi = this.modelIdx(v.mk, v.md), bi = v.bed ? this.bedSet(v.bed) : null, si = this.subIdx(v.sub), ci = this.cabIdx(v.cab), ei = this.engIdx(v.eng), out = [], c = false, e = false;
      if (mi == null || this.sure(pid, v)) return out;
      this.runs(mi).forEach(r => { if (r[0] === pid && inRun(r, v.y) && this.runOk(r, bi, si, ci, ei)) { if (ci === null && r[5] !== -1) c = true; if (ei === null && r[6] !== -1) e = true; } });
      if (c) out.push(F_CAB);
      if (e) out.push(F_ENG);
      return out;
    }
    routeSibling(groupIdx, v, currentSku) {
      var P = this.data.products, runs = this.runs(this.modelIdx(v.mk, v.md)), bi = this.bedSet(v.bed);
      var cands = this.resolve([v], { includeUniversal: false, strictGroups: false })
        .filter(pid => P[pid][2] === groupIdx && P[pid][4] !== '' && P[pid][0] !== currentSku && this.sure(pid, v)); /* CAB-ENGINE: twin of sibRoute() */
      if (v.bed) { var exact = cands.filter(pid => runs.some(r => r[0] === pid && bi.has(r[3]) && inRun(r, v.y))); if (exact.length) cands = exact; }
      var plain = cands.filter(pid => !(P[pid][1] & 32)); if (plain.length) cands = plain; /* action B: plain beats a factory-option version */
      return cands.length ? P[cands[0]][4] : null;
    }
    /* CAB-ENGINE 2026-10-21: index twin of sibQualNeed() - the group carries v only through members that depend on a cab /
       engine v does not name, so routing waits for them */
    qualNeed(groupIdx, v, currentSku) {
      var P = this.data.products, out = [], cands;
      if (v.cab && v.eng) return out;
      cands = this.resolve([v], { includeUniversal: false, strictGroups: false }).filter(pid => P[pid][2] === groupIdx && P[pid][4] !== '' && P[pid][0] !== currentSku);
      if (!cands.length || cands.some(pid => this.sure(pid, v))) return out;
      cands.forEach(pid => this.needs(pid, v).forEach(f => { if (out.indexOf(f) < 0) out.push(f); }));
      return out.sort((a, b) => (a === F_CAB ? 0 : 1) - (b === F_CAB ? 0 : 1));
    }
  }

  /* ---------- FitmentStore: localStorage `theme:fitment` (in-memory fallback), URL precedence ---------- */
  class FitmentStore {
    constructor() { this.state = this.blank(); this.mem = null; this.pending = null; this.unknown = []; }
    blank() { return { v: 1, active: null, mode: S.garageMode === 'all' ? 'all' : 'active', vehicles: [], exp: 0 }; }
    read() {
      var raw = null, st = this.blank();
      try { raw = W.localStorage.getItem(KEY); } catch (e) { raw = this.mem; }
      try {
        var s = JSON.parse(raw || 'null'), seen = new Set();
        if (s && s.v === 1 && (!s.exp || s.exp > Date.now()) && Array.isArray(s.vehicles)) {
          st.vehicles = s.vehicles.filter(v => v && v.id && v.y && !seen.has(v.id) && seen.add(v.id)).slice(-MAX);
          st.active = this.byId(s.active, st) ? s.active : null;
          st.mode = s.mode === 'all' ? 'all' : 'active';
        }
      } catch (e) {}
      return st;
    }
    /* boot: storage, then the URL. Returns 'url' | 'restore' | 'pending' (URL ids that need the index). */
    load() {
      this.state = this.read();
      var ids = urlIds(), known = ids.map(id => this.byId(id));
      if (!ids.length) return 'restore';
      if (known.every(Boolean)) { this.applyList(known); this.write(); return 'url'; }
      this.pending = ids;
      return 'pending';
    }
    applyIds(ids, reason) {
      var have = ids.map(id => this.byId(id));
      if (have.every(Boolean)) { this.pending = null; this.applyList(have); this.write(reason); return Promise.resolve(have); }
      this.pending = ids;
      return index.load().then(ix => {
        var list = [], unknown = [];
        ids.forEach((id, i) => { var v = have[i] || ix.parseId(id); if (v) list.push(v); else unknown.push(id); });
        this.pending = null; this.unknown = unknown;
        unknown.forEach(id => this.drop(id));
        if (list.length) this.applyList(list);
        this.write(reason);
        return list;
      }, () => { this.pending = null; this.write(reason); return []; });
    }
    applyList(list) { list.forEach(v => this.upsert(v)); this.state.active = list[0].id; this.state.mode = list.length > 1 ? 'all' : 'active'; }
    upsert(v) {
      var st = this.state, vs = st.vehicles;
      if (this.byId(v.id)) return;
      vs.push(v);
      while (vs.length > MAX) { var i = vs.findIndex(x => x.id !== st.active); vs.splice(i < 0 ? 0 : i, 1); }
    }
    /* live: removing the active vehicle leaves NO active vehicle (pill back to "Select Your Vehicle"); it never auto-switches to another garage entry */
    drop(id) { var st = this.state; st.vehicles = st.vehicles.filter(x => x.id !== id); if (st.active === id) st.active = null; }
    /* CAB-ENGINE 2026-10-21: answering "which cab / engine?" for the ACTIVE truck refines that garage entry instead of
       adding a second one ("2018 GMC Sierra 3500 HD" becomes "... Crew Cab 6.0L V8"): same year / make / model, and
       every detail the old entry named is unchanged */
    select(v, reason) {
      var a = this.active(), vs = this.state.vehicles, i;
      if (a && a.id !== v.id && !this.byId(v.id) && a.y === v.y && slugMake(a.mk) === slugMake(v.mk) && slugModel(a.md) === slugModel(v.md)
          && ['sub', 'bed', 'cab', 'eng'].every(k => !a[k] || a[k] === v[k]) && (v.cab || v.eng) && (v.cab !== a.cab || v.eng !== a.eng)) {
        i = vs.indexOf(a);
        if (i >= 0) vs.splice(i, 1, v);
      }
      this.upsert(v); this.state.active = v.id; this.write(reason || 'select');
    }
    /* FIT OPTIONS 2026-10-28: the shopper said the saved truck is the other body of a two-body year ("2019 Silverado 1500"
       is really the Legacy 1500 LD): that garage entry becomes the right truck, in its place, and stays the active one */
    swap(oldId, v, reason) {
      var vs = this.state.vehicles, i = vs.findIndex(x => x.id === oldId);
      if (this.byId(v.id)) vs.splice(i, i < 0 ? 0 : 1); else if (i >= 0) vs.splice(i, 1, v); else this.upsert(v);
      this.state.active = v.id; this.write(reason || 'select');
    }
    setActive(id, reason) { if (this.byId(id)) { this.state.active = id; this.write(reason || 'switch'); } }
    remove(id, reason) { this.drop(id); this.write(reason || 'remove'); }
    clear(reason) { this.state.active = null; this.state.mode = 'active'; this.write(reason || 'clear'); }
    clearGarage(reason) { this.state.vehicles = []; this.clear(reason || 'clear-garage'); }
    setMode(m, reason) { this.state.mode = m === 'all' ? 'all' : 'active'; this.write(reason || 'mode'); }
    prune(id) { this.drop(id); this.write('prune'); }
    byId(id, st) { return (st || this.state).vehicles.find(v => v.id === id) || null; }
    vehicleById(id) { return this.byId(id); }
    active() { return this.byId(this.state.active); }
    selected() { var st = this.state, a = this.active(); return this.pending ? [] : st.mode === 'all' ? st.vehicles.slice() : a ? [a] : []; }
    ids() { return this.selected().map(v => v.id); }
    idsParam() { return this.ids().join(','); }
    write(reason) {
      var st = this.state;
      st.exp = Date.now() + YEAR_MS;
      try { W.localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) { this.mem = JSON.stringify(st); }
      if (reason) this.emit(reason);
    }
    reload(reason) { this.state = this.read(); this.emit(reason); }
    emit(reason) {
      var sel = this.selected();
      if (D && !this.pending) D.documentElement.classList.toggle('fitment-has-vehicle', sel.length > 0);
      emit('fitment:change', { active: this.active(), vehicles: this.state.vehicles.slice(), mode: this.state.mode, selected: sel, reason: reason });
    }
  }

  /* FIT OPTIONS 2026-10-28: the shopper's answers, localStorage `theme:fitment:ans` = {v:1, b:{vehicleId: 'new'|'old'},
     o:{"vehicleId>handle": option key | "__none__"}}. A Body Style answer belongs to the truck; an Option answer to one
     product for one truck (RealTruck re-asks per product line too). The newest 300 product answers are kept. */
  var fitAns = {
    K: 'theme:fitment:ans',
    read() { var j; try { j = JSON.parse(W.localStorage.getItem(this.K) || 'null'); } catch (e) { j = null; } return j && j.v === 1 && j.b && j.o ? j : { v: 1, b: {}, o: {} }; },
    write(j) { var ks = Object.keys(j.o); if (ks.length > 300) ks.slice(0, ks.length - 300).forEach(k => { delete j.o[k]; }); try { W.localStorage.setItem(this.K, JSON.stringify(j)); } catch (e) {} },
    /* the body belongs to the truck's year / make / model: adding its bed, cab or engine later keeps the answer */
    bk(v) { return v.y + '|' + slugMake(v.mk) + '|' + slugModel(v.md); },
    body(v) { return v && v.mk && v.md ? this.read().b[this.bk(v)] || null : null; },
    setBody(v, b) { var j = this.read(); j.b[this.bk(v)] = b; this.write(j); },
    opt(v, h) { return v ? this.read().o[v.id + '>' + h] || null : null; },
    setOpt(v, h, k) { var j = this.read(), key = v.id + '>' + h; delete j.o[key]; j.o[key] = k; this.write(j); }
  };
  var store = new FitmentStore(), index = new FitmentIndex(cfg.indexUrl);
  /* the <pt-vehicle-select> whose submit caused the store write in flight (null at every other moment).
     The PDP verify widget uses it to tell its OWN pick apart from one made in the header pill or a band. */
  var origin = null;
  var openDialog = (intent, opener, prefill, lock) => emit('fitment:open', { intent: intent || 'select', opener: opener || null, prefill: prefill || undefined, lock: !!lock }); /* lock: TRUCK PAGE 2026-10 */
  theme.fitment.api = {
    store, getIndex: () => index.load(), open: openDialog,
    resolve: (v, s) => index.resolve(v, s), routeSibling: (g, v, s) => index.routeSibling(g, v, s),
    label, vehicleId, parseId: (id, ix) => (ix || index).parseId(id), slugMake, slugModel, slugBed,
    verdict, misses, sibRoute, sibRoutePartial, sibQualNeed, FitmentIndex, FitmentStore,
    /* FIT OPTIONS 2026-10-28: the same answer the product page gives (pt-upgrade.js sends a part that needs one to its page) */
    fitCheck, fitOptions, fitFields, twinFor, twinRowBody: (e, r) => rowBody(e, r), noteText, optKey,
    needsOption: (rows, v) => { var a = fitCheck(rows, v, fitAns.body(v)); return a.state === 'body' || (a.state === 'fits' && !a.sure); }
  };
  if (!D) return;

  /* ---------- DOM helpers ---------- */
  var html = D.documentElement, H = n => '[data-fitment-' + n + ']';
  var $ = (el, sel) => el ? el.querySelector(sel) : null;
  var $$ = (el, sel) => el ? Array.from(el.querySelectorAll(sel)) : [];
  var isDesign = () => !!(W.Shopify && W.Shopify.designMode);
  var root = (R.collections || '/collections').replace(/collections\/?$/, '') || '/';
  var setText = (el, sel, text) => { var n = $(el, sel); if (n) n.textContent = text == null ? '' : text; };
  var hide = (el, sel, b) => { var n = $(el, sel); if (n) n.hidden = !!b; return n; };
  var clear = el => { while (el && el.firstChild) el.removeChild(el.firstChild); };
  var withVehicle = base => {
    var u = new URL(base || R.all || '/', W.location.href), ids = store.idsParam();
    if (ids) u.searchParams.set('vehicle', ids); else u.searchParams.delete('vehicle');
    return u.pathname + u.search;
  };
  var ss = (k, v) => { try { if (v === undefined) return W.sessionStorage.getItem(k); if (v === null) W.sessionStorage.removeItem(k); else W.sessionStorage.setItem(k, v); } catch (e) {} return null; };
  /* 2026-10-28 (owner: on the AMP PowerStep page the "Truck Option" buttons, Non-Hybrid / PowerBoost Hybrid, would not
     switch): true when this page was opened from another version of the same product (FD's Version / Truck Option buttons,
     or any link between versions). That is the shopper's own pick: the truck active when it opened never routes it back.
     Twin of picked() in fitment-boot.liquid. */
  var fromVersion = (sib, me) => {
    var r, h;
    if (!D || !sib || !(sib.p instanceof Array)) return false;
    try { r = new URL(D.referrer); h = r.origin === W.location.origin && r.pathname.match(/\/products\/([^\/?#]+)\/?$/); h = h && decodeURIComponent(h[1]); } catch (e) { return false; }
    return !!h && h !== me && sib.p.some(m => m[0] === h);
  };
  var focusables =el => $$(el, 'a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])').filter(n => !n.closest('[hidden]'));
  /* text '' is deliberate: live carries an EMPTY properties[Fitment] on a product with no fitment data */
  var inject = (form, text) => {
    if (!form || text == null) return;
    var i = $(form, 'input.fitment-property');
    if (!i) { i = D.createElement('input'); i.type = 'hidden'; i.name = 'properties[Fitment]'; i.className = 'fitment-property'; form.appendChild(i); }
    i.value = decode(text); /* Liquid's interpolated | t: strings arrive HTML-escaped (Doesn&#39;t) */
  };
  var removeProp = form => { var i = $(form, 'input.fitment-property'); if (i) i.remove(); };
  /* FIT OPTIONS 2026-10-28: another version's fitment.rows, through sections/fitment-rows.liquid (a few hundred bytes),
     kept for the tab in sessionStorage; null when it cannot be read (that version is then left out of the list) */
  var rowsMemo = new Map();
  var fetchRows = h => {
    var k = 'fitment:rows:' + h, c = ss(k), p;
    if (rowsMemo.has(h)) return rowsMemo.get(h);
    if (c) { try { p = Promise.resolve(JSON.parse(c)); rowsMemo.set(h, p); return p; } catch (e) { ss(k, null); } }
    p = Promise.race([fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=fitment-rows', { credentials: 'same-origin' })
      .then(r => r.ok ? r.text() : null)
      .then(t => {
        var m = t && t.match(/<script[^>]*data-fitment-rows[^>]*>([\s\S]*?)<\/script>/), j = m ? JSON.parse(m[1]) : null;
        if (j) ss(k, JSON.stringify(j));
        return j;
      }), new Promise(ok => W.setTimeout(() => ok(null), S.timeoutMs || 6000))])   /* a stalled request never holds the box */
      .catch(() => null);
    rowsMemo.set(h, p);
    p.then(j => { if (!j) rowsMemo.delete(h); });   /* a failed or slow version is asked for again on the next check */
    return p;
  };
  var selLabel = (sel, mode) => mode === 'all' && sel.length >= 2 ? T.allMyVehicles : label(sel[0]);
  var curLabel = () => selLabel(store.selected(), store.state.mode);

  /* ---------- SEARCH DROPDOWN 2026-10-13 (owner: "no fitment selected = just the master products in the search
     bar; a vehicle selected = only that vehicle's stuff") ----------
     The header dropdown is Shopify predictive search, which knows nothing about fitment. Same rules as the /search
     grid: no truck = masters + single products (a child row becomes its master); a truck = what fits it (a master
     or a wrong-truck child becomes the sibling that fits, anything else is dropped). theme.js runs every panel
     through panelFilter() before painting it; swapped-in rows come from ONE variants.sku: search rendered by
     sections/predictive-search-skus. Any failure leaves the panel as Shopify sent it. */
  var dd = { ix: null, bySku: null, master: null, rows: new Map() };
  var ddMaps = ix => {
    if (dd.ix === ix) return;
    var bySku = new Map(), master = new Map();
    ix.data.products.forEach((p, pid) => {
      if (p[0] && !bySku.has(p[0])) bySku.set(p[0], pid);
      if (p[2] !== -1 && (p[1] & 1) && !master.has(p[2])) master.set(p[2], pid);
    });
    dd.ix = ix; dd.bySku = bySku; dd.master = master;
  };
  var ddPid = a => { var s = (a.getAttribute('data-skus') || '').split('|'); for (var i = 0; i < s.length; i++) if (s[i] && dd.bySku.has(s[i])) return dd.bySku.get(s[i]); return null; };
  var ddRows = skus => {
    var miss = skus.filter(s => !dd.rows.has(s));
    if (!miss.length) return Promise.resolve();
    var q = '(' + miss.map(s => 'variants.sku:"' + s.replace(/["\\]/g, '') + '"').join(' OR ') + ')';
    return fetch((R.search || '/search') + '?type=product&options[prefix]=none&section_id=predictive-search-skus&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
      .then(r => r.ok ? r.text() : Promise.reject(new Error('rows ' + r.status)))
      .then(t => {
        $$(new DOMParser().parseFromString(t, 'text/html'), 'a[data-skus]').forEach(a => {
          (a.getAttribute('data-skus') || '').split('|').forEach(s => { if (s && miss.indexOf(s) !== -1 && !dd.rows.has(s)) dd.rows.set(s, a.closest('li').outerHTML); });
        });
      });
  };
  theme.fitment.panelKey = () => store.selected().map(v => v.id).join(',');
  theme.fitment.panelFilter = box => {
    var lists = $$(box, 'ul[data-search-fit]');
    if (!lists.length) return Promise.resolve(box);
    return index.load().then(ix => {
      var P = ix.data.products, sel = store.selected(), fits = null, gfit = new Map(), plan = [], need = [];
      ddMaps(ix);
      if (sel.length) {
        fits = ix.match(sel, { includeUniversal: !!S.includeUniversal, strictGroups: !!S.strictGroups });
        /* the group's fitting sibling; a plain one beats a factory-option version (routeSibling's action B) */
        fits.forEach((v, pid) => { var g = P[pid][2], c = gfit.get(g); if (g !== -1 && (c == null || ((P[c][1] & 32) && !(P[pid][1] & 32)))) gfit.set(g, pid); });
      }
      /* pid to show instead of this row: itself, another pid, -1 = keep the row (not in the index, no truck), null = drop */
      var pick = pid => {
        if (pid == null) return sel.length ? null : -1;
        var p = P[pid];
        if (!sel.length) return p[2] === -1 || (p[1] & 1) ? pid : dd.master.has(p[2]) ? dd.master.get(p[2]) : null;
        if (fits.has(pid)) return pid;
        return p[2] !== -1 && gfit.has(p[2]) ? gfit.get(p[2]) : null;
      };
      lists.forEach(ul => {
        var max = +ul.getAttribute('data-search-max') || 5, seen = new Set(), out = [];
        $$(ul, 'a[data-skus]').forEach(a => {
          if (out.length >= max) return;
          var own = ddPid(a), t = pick(own), k;
          if (t === null) return;
          k = t === -1 ? 'h:' + a.getAttribute('href') : P[t][2] !== -1 ? 'g' + P[t][2] : t;   /* one row per product line */
          if (seen.has(k)) return;
          seen.add(k);
          if (t === -1 || t === own) out.push({ li: a.closest('li') });
          else { out.push({ sku: P[t][0] }); need.push(P[t][0]); }
        });
        plan.push({ ul: ul, out: out });
      });
      return ddRows(need).catch(() => {}).then(() => {
        plan.forEach(pl => {
          var ul = pl.ul, nov = ul.hasAttribute('data-search-novendor'), pre = ul.getAttribute('data-search-fit') || 'search-opt-fit-', kept = [];
          pl.out.forEach(o => {
            var li = o.li, tmp;
            if (!li) { if (!dd.rows.has(o.sku)) return; tmp = D.createElement('ul'); tmp.innerHTML = dd.rows.get(o.sku); li = tmp.firstElementChild; }
            li.hidden = false;
            if (nov) $$(li, '.search-panel__product-vendor').forEach(n => n.remove());
            kept.push(li);
          });
          clear(ul);
          kept.forEach((li, i) => { var a = $(li, 'a'); if (a) a.id = pre + (i + 1); ul.appendChild(li); });
          if (!kept.length) { var g = ul.closest('.search-panel__group'); if (g) g.remove(); }
        });
        return box;
      });
    });
  };
  /* ---------- TRUCK PAGE 2026-10 (SEO programme): a collection that IS one truck ----------
     main-collection.liquid renders <script type="application/json" data-fitment-page> inside <pt-fitment-grid> on a
     collection whose handle is listed in shop.metafields.fitment.truck_pages:
       {"key":"ford-f-150","name":"Ford F-150","models":[["Ford","F-150"],["Ford","F-150 Raptor"],...],
        "fallback":"/collections/tonneau-covers","links":[[make, model, url, page name], ...]}
     It locks the page's own band to those make/model pairs (VehicleSelect.lockOn) and keeps the grid in browse mode while
     the garage holds no truck the page is about (Grid.vsel, Band.mismatch). Every other page: null, nothing changes. */
  var pageMemo = { el: undefined, v: null };
  var pageKey = (mk, md) => slugMake(mk) + '|' + slugModel(md);
  var pageLock = () => {
    var el = D.querySelector('pt-fitment-grid[data-scope="collection"] script[data-fitment-page]'), j, keys, links;
    if (el === pageMemo.el) return pageMemo.v;
    pageMemo.el = el; pageMemo.v = null;
    try { j = el ? JSON.parse(el.textContent) : null; } catch (e) { j = null; }
    if (!j || !Array.isArray(j.models) || !j.models.length) return null;
    keys = new Set(j.models.map(m => pageKey(m[0], m[1])));
    links = new Map();
    (j.links || []).forEach(l => { var k = l && l[2] ? pageKey(l[0], l[1]) : null; if (k && !links.has(k)) links.set(k, { url: l[2], name: l[3] || '' }); });
    return (pageMemo.v = { key: j.key || '', name: j.name || '', models: j.models, links: links,
      fallback: j.fallback || (R.collections || '/collections') + '/tonneau-covers',
      has: v => !!v && keys.has(pageKey(v.mk, v.md)) });
  };

  /* ---------- OWNER 2026-10-25: a select's list always opens BELOW it (desktop) ----------
     Chrome's own list opened over the select, half above and half below, when the select sat low on the screen. With a
     mouse, the vehicle selects now open this list instead: always under the select, the buy box (or page) scrolled up
     first when there is not enough room. Phones and tablets keep their own picker; a closed select's keyboard use is the
     browser's own. The <select> stays the source of truth: a pick sets its value and fires input + change. */
  var FINE = W.matchMedia ? W.matchMedia('(hover: hover) and (pointer: fine)') : null;
  var dd = { el: null, sel: null, hi: -1, typed: '', tt: 0, quiet: 0 };
  var ddItems = () => dd.el ? Array.from(dd.el.querySelectorAll('[role="option"]')) : [];
  function ddClose(refocus) {
    var s = dd.sel;
    if (!dd.el) return;
    dd.el.remove(); dd.el = null; dd.sel = null; dd.hi = -1;
    if (s) { s.removeAttribute('aria-expanded'); if (refocus) s.focus({ preventScroll: true }); }
  }
  function ddMark(i, scroll) {
    var it = ddItems(), n, b = dd.el;
    if (!it.length) return;
    i = Math.max(0, Math.min(it.length - 1, i));
    it.forEach((x, k) => { x.classList.toggle('is-hi', k === i); });
    dd.hi = i; n = it[i];
    if (dd.sel) dd.sel.setAttribute('aria-activedescendant', n.id);
    if (scroll) { if (n.offsetTop < b.scrollTop) b.scrollTop = n.offsetTop; else if (n.offsetTop + n.offsetHeight > b.scrollTop + b.clientHeight) b.scrollTop = n.offsetTop + n.offsetHeight - b.clientHeight; }
  }
  function ddPick(i) {
    var s = dd.sel, n = ddItems()[i], v;
    if (!s || !n) return;
    v = n.dataset.value;
    ddClose(true);
    if (s.value !== v) { s.value = v; s.dispatchEvent(new Event('input', { bubbles: true })); s.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  /* the nearest ancestor that scrolls vertically (the wide buy box), or null for the page */
  function ddScroller(n) {
    for (var p = n.parentElement; p && p !== D.body; p = p.parentElement) {
      var o = W.getComputedStyle(p).overflowY;
      if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
    }
    return null;
  }
  function ddPlace() {
    var s = dd.sel, b = dd.el, r = s.getBoundingClientRect(), room = W.innerHeight - r.bottom - 14, got;
    b.style.top = (r.bottom + 2) + 'px'; b.style.left = r.left + 'px'; b.style.width = r.width + 'px';
    b.style.maxHeight = Math.max(120, Math.min(320, room)) + 'px';
    /* a transformed ancestor (the fallback dialog) moves a fixed box: measure and correct */
    got = b.getBoundingClientRect();
    if (Math.abs(got.top - (r.bottom + 2)) > 1 || Math.abs(got.left - r.left) > 1) { b.style.top = (2 * (r.bottom + 2) - got.top) + 'px'; b.style.left = (2 * r.left - got.left) + 'px'; }
  }
  function ddOpen(s) {
    var n = Array.from(s.options).filter(o => o.value || o.hasAttribute('data-sep')).length, want = Math.min(320, 34 * Math.max(1, n) + 10);
    var r = s.getBoundingClientRect(), need = want - (W.innerHeight - r.bottom - 14), sc, was, b, host, it, si;
    if (need > 0) {   /* not enough room under the select: bring it up first, as a shopper would scroll */
      dd.quiet = Date.now() + 500;
      sc = ddScroller(s);
      /* jump, never glide (a smooth-scroll style would leave the list where the select used to be) */
      var jump = (el, fn) => { var b0 = el.style.scrollBehavior; el.style.scrollBehavior = 'auto'; try { fn(); } finally { el.style.scrollBehavior = b0; } };
      if (sc) { was = sc.scrollTop; jump(sc, () => { sc.scrollTop = was + need; }); need -= sc.scrollTop - was; }
      if (need > 0) jump(D.documentElement, () => W.scrollBy(0, need));
    }
    b = dd.el = D.createElement('div');
    b.className = 'fitment-dd'; b.id = 'fitment-dd'; b.setAttribute('role', 'listbox');
    if (s.closest('[data-fitment-ask]')) b.classList.add('fitment-dd--wrap');   /* FIT OPTIONS: an option can be a sentence */
    if (s.labels && s.labels[0]) b.setAttribute('aria-label', s.labels[0].textContent.trim());
    Array.from(s.options).forEach(o => {
      var x;
      if (o.hasAttribute('data-sep')) { x = D.createElement('div'); x.className = 'fitment-dd__sep'; x.setAttribute('role', 'separator'); b.appendChild(x); return; }
      if (!o.value) return;   /* the placeholder */
      x = D.createElement('div');
      x.className = 'fitment-dd__opt'; x.setAttribute('role', 'option'); x.id = 'fitment-dd-' + b.children.length;
      x.dataset.value = o.value; x.textContent = o.textContent;
      if (o.value === s.value) { x.classList.add('is-sel'); x.setAttribute('aria-selected', 'true'); }
      b.appendChild(x);
    });
    dd.sel = s;
    host = s.closest('dialog') || D.body;   /* inside a modal <dialog> (top layer) the list must live in it */
    host.appendChild(b);
    s.setAttribute('aria-expanded', 'true'); s.setAttribute('aria-controls', 'fitment-dd');
    ddPlace();
    it = ddItems(); si = it.findIndex(x => x.classList.contains('is-sel'));
    ddMark(si < 0 ? 0 : si, true);
  }
  if (FINE) {
    D.addEventListener('mousedown', e => {
      var t = e.target, s = t && t.closest ? t.closest('pt-vehicle-select select, [data-fitment-ask] select') : null;
      if (dd.el && dd.el.contains(t)) { e.preventDefault(); return; }   /* keep the select focused while picking */
      if (dd.el && t !== dd.sel) ddClose(false);
      if (!s || e.button !== 0 || s.disabled || !FINE.matches) return;
      if (dd.sel === s) { e.preventDefault(); ddClose(true); return; }
      /* the native list is stopped only once ours is open: if anything fails, the browser's own list still works */
      try { ddOpen(s); } catch (err) { ddClose(false); return; }
      e.preventDefault();
      s.focus({ preventScroll: true });
    }, true);
    D.addEventListener('click', e => { var n = dd.el && e.target.closest ? e.target.closest('.fitment-dd__opt') : null; if (n && dd.el.contains(n)) ddPick(ddItems().indexOf(n)); });
    D.addEventListener('mousemove', e => { var n = dd.el && e.target.closest ? e.target.closest('.fitment-dd__opt') : null; if (n && dd.el.contains(n) && !n.classList.contains('is-hi')) ddMark(ddItems().indexOf(n), false); });
    D.addEventListener('keydown', e => {
      var k = e.key, it, j;
      if (!dd.el || e.target !== dd.sel) return;
      if (k === 'Escape' || k === 'Tab') { if (k === 'Escape') { e.preventDefault(); e.stopPropagation(); } ddClose(k === 'Escape'); return; }
      e.stopPropagation();
      it = ddItems();
      if (/^(ArrowDown|ArrowUp|PageDown|PageUp|Home|End)$/.test(k)) {
        e.preventDefault();
        ddMark(k === 'Home' ? 0 : k === 'End' ? it.length - 1 : dd.hi + (k === 'ArrowDown' ? 1 : k === 'ArrowUp' ? -1 : k === 'PageDown' ? 8 : -8), true);
      } else if (k === 'Enter' || k === ' ') { e.preventDefault(); ddPick(dd.hi); }
      else if (k.length === 1 && /\S/.test(k)) {   /* type-ahead: "20" jumps to the first 20xx year */
        e.preventDefault();
        dd.typed = (Date.now() - dd.tt < 800 ? dd.typed : '') + k.toLowerCase(); dd.tt = Date.now();
        j = it.findIndex(x => x.textContent.trim().toLowerCase().indexOf(dd.typed) === 0);
        if (j >= 0) ddMark(j, true);
      }
    }, true);
    D.addEventListener('focusout', e => { if (dd.el && e.target === dd.sel) W.setTimeout(() => { if (dd.el && D.activeElement !== dd.sel) ddClose(false); }, 0); });
    W.addEventListener('resize', () => ddClose(false));
    W.addEventListener('scroll', e => { if (dd.el && e.target !== dd.el && Date.now() > dd.quiet) ddClose(false); }, true);
  }

  class Base extends HTMLElement {
    connectedCallback() { this.off = []; this.bind(); }
    disconnectedCallback() { (this.off || []).forEach(f => f()); this.off = []; }
    listen(el, ev, fn, opts) { if (el) { el.addEventListener(ev, fn, opts); this.off.push(() => el.removeEventListener(ev, fn, opts)); } }
    onChange(fn) { this.listen(D, 'fitment:change', e => fn(e.detail)); }
    $(sel) { return $(this, sel); }
    set(sel, text) { setText(this, sel, text); }
    hide(sel, b) { return hide(this, sel, b); }
    bind() {}
  }

  /* ---------- <pt-vehicle-select> ---------- */
  class VehicleSelect extends Base {
    bind() {
      var s = this.sel = {};
      LEVELS.forEach(l => { s[l] = this.$('[data-fitment-level="' + l + '"]'); });
      this.goBtn = this.$(H('go')); this.clearBtn = this.$(H('clear-select')); this.status = this.$(H('status'));
      this.bedField = s.bed && s.bed.closest('.fitment-select__field');
      this.subField = s.submodel && s.submodel.closest('.fitment-select__field'); /* index v1.1 carries submodels: the level is offered only when the chosen YMM has trim-specific runs (live) */
      /* CAB-ENGINE 2026-10-21: Cab + Engine levels (RealTruck's "body" and "engine"), offered only when this page's
         products depend on them for the chosen truck; an older selector snippet without them simply never shows them */
      this.cabField = s.cab && s.cab.closest('.fitment-select__field');
      this.engField = s.engine && s.engine.closest('.fitment-select__field');
      this.column = this.getAttribute('layout') === 'column';
      /* REALTRUCK LOOK 2026-10-24: each level's placeholder ("Select Year") as fitment-selector.liquid rendered it */
      this.phText = {};
      LEVELS.forEach(l => { var o = s[l] && s[l].options[0]; this.phText[l] = o && o.value === '' ? o.textContent : T[l] || ''; });
      ['pointerenter', 'focusin', 'touchstart'].forEach(ev => this.listen(this, ev, () => { if (!index.data) this.ensure(); }, { passive: true }));
      this.listen(this, 'change', e => { var lv = e.target.dataset.fitmentLevel; if (lv) this.cascade(lv, true); });
      this.listen(this, 'keydown', e => {
        if (e.key === 'Enter' && e.target.matches('select') && this.goBtn && !this.goBtn.hasAttribute('disabled')) { e.preventDefault(); this.submit(); return; }
        /* GO / CLEAR are <div role="button"> (live's markup), so their keyboard activation is ours to do */
        var b = (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && e.target.closest('[role="button"]');
        if (b && this.contains(b) && !b.hasAttribute('disabled')) { e.preventDefault(); b.click(); }
      });
      this.listen(this, 'click', e => { if (e.target.closest(H('go'))) this.submit(); else if (e.target.closest(H('clear-select'))) this.reset(true); });
      this.listen(D, 'fitment:index-ready', () => this.ready());
      this.listen(D, 'fitment:index-error', () => this.setState('error'));
      if (index.data) this.ready(); else { /* eager-index */ this.setState(index.promise ? 'loading' : 'idle'); this.ensure(); }
    }
    ensure() { if (index.data) return Promise.resolve(); this.setState('loading'); return index.load().catch(noop); }
    setState(st) {
      this.dataset.state = st;
      if (this.status) this.status.textContent = st === 'loading' ? T.loading || '' : st === 'error' ? T.error || '' : '';
      if (st !== 'ready') this.sel.year.disabled = st !== 'idle';
    }
    ready() {
      var y = this.sel.year;
      if (!index.data) return;
      this.toggleAttribute('data-page-locked', !!this.lockOn());
      this.fill(y, (this.lockOn() ? this.lockYears() : this.optYears()).map(String), y.value);
      y.disabled = false;
      if (this.lockOn() && !this.sel.model.value) this.lockFill(+y.value || 0); /* TRUCK PAGE 2026-10: Make + Model show the page truck before the Year */
      if (!this.sel.model.value || !y.value) { this.showLevel(this.subField, false); this.showLevel(this.bedField, false); this.showLevel(this.cabField, false); this.showLevel(this.engField, false); } /* SELECTOR 2026-10-10 */
      this.setState('ready'); this.level();
    }
    /* Convermax semantics: a level keeps its placeholder until a value is chosen, then the placeholder goes; a refill brings it back. */
    ph(sel) { var o = sel.options[0], l = sel.dataset.fitmentLevel; if (!o || o.value !== '') { o = D.createElement('option'); o.value = ''; o.textContent = (this.phText && this.phText[l]) || T[l] || ''; sel.insertBefore(o, sel.firstChild); } }
    fill(sel, values, keep) {
      if (!sel) return;
      this.ph(sel);
      while (sel.options.length > 1) sel.remove(1);
      values.forEach(v => { var o = D.createElement('option'); if (v === SEP) { o.value = ''; o.disabled = true; o.dataset.sep = ''; o.textContent = '──────────'; } else o.value = o.textContent = v; sel.appendChild(o); });
      sel.value = keep && keep !== SEP && values.indexOf(keep) >= 0 ? keep : '';
      sel.disabled = !values.length;
      /* FIT OPTIONS 2026-10-28 (owner: "a classic versus an updated model with the same name and the same year"): in a year
         that sold two bodies under one name the Model list says which is which ("Silverado 1500 LD (Legacy, 2018 Body
         Style)", "Silverado 1500 (New Body)"); the value stays the model */
      if (sel === this.sel.model) Array.from(sel.options).forEach(o => {
        var e = o.value && twinFor({ y: +this.sel.year.value, mk: this.sel.make.value, md: o.value }), md = slugModel(o.value);
        if (e && (md === slugModel(e[1]) || md === slugModel(e[2]))) o.textContent = o.value + ' (' + (md === slugModel(e[2]) ? e[11] : e[10]) + ')';
      });
    }
    has(l) { var s = this.sel[l]; return !!s && Array.from(s.options).some(o => o.value); }
    hasBeds() { return this.has('bed'); }
    hasSubs() { return this.has('submodel'); }
    hasCabs() { return this.has('cab'); }
    hasEngs() { return this.has('engine'); }
    /* 2026-09-14 (action A): when the vehicle offers beds, the bed completes it and the Submodel is optional.
       CAB-ENGINE 2026-10-21: an offered Cab / Engine is required (the page's products depend on it), and like the bed it
       makes the Submodel optional. */
    complete() {
      var s = this.sel;
      if (!(s.year.value && s.model.value)) return false;
      if ((this.hasCabs() && !s.cab.value) || (this.hasEngs() && !s.engine.value)) return false;
      if (this.hasBeds()) return !!s.bed.value;
      return this.hasCabs() || this.hasEngs() || !this.hasSubs() || !!s.submodel.value;
    }
    /* every level stays rendered (disabled until reached) like Convermax's five selects; Submodel and Bed drop out
       as soon as NOTHING still on the table offers them - after the model when that model has none, and already
       after the make when no model of that make has any (live: 2019 Polaris falls to three rows) */
    showLevel(field, has) {
      if (!field) return;
      field.hidden = !has;
      /* live REMOVES a dropped level from the DOM; emptying the select is the same thing to anything that reads it */
      var sel = !has && field.querySelector('select');
      if (sel) { while (sel.options.length) sel.remove(0); sel.disabled = true; }
    }
    /* SELECTOR 2026-10-10 (owner, RealTruck): does THIS page need the Bed / Submodel for this truck? The host is the
       PDP's verify block, else the page's collection grid; the home hero, search and a page with neither never do,
       so the vehicle completes at the Model there. A missing bed / submodel matches "any" everywhere downstream. */
    /* REALTRUCK LOOK 2026-10-24: `pick` carries the trim / cab / engine already chosen, so a level the chosen cab makes
       irrelevant (every row of that cab fits every engine) drops out instead of asking for nothing */
    need(y, mk, md, mi, pick) {
      var no = { bed: false, sub: false, cab: false, eng: false }, v = { y: y, mk: mk, md: md, sub: null, bed: null }, h, r, S, P, ci, beds, sub, wild, g, q, cab, eng, fl;
      if (pick) { if (pick.sub) v.sub = pick.sub; if (pick.cab) v.cab = pick.cab; if (pick.eng) v.eng = pick.eng; }
      if (this.closest('[data-variant="hero"]')) return no;
      h = this.closest('pt-fitment-verify') || D.querySelector('pt-fitment-verify:not([hidden])');
      if (h && h.dataset.role !== 'none' && h.dataset.role !== 'universal') {
        S = h.sibs; sub = false; wild = false;
        if (h.rows && Array.isArray(h.rows.r)) {
          /* CAB-ENGINE 2026-10-21: the product's own rows say whether it depends on the cab / engine (the verdict's
             missing fields with nothing chosen yet), and its group table whether a sibling route would */
          fl = fitFields(h.rows.r, v); q = S ? sibQualNeed(S, v, '', '') : [];   /* FIT OPTIONS: twin-year aware */
          return { bed: fl.indexOf(T.bed) >= 0 || (!!S && sibBedAmbiguous(S, v, '', '')), sub: fl.indexOf(T.submodel) >= 0,
                   cab: fl.indexOf(F_CAB) >= 0 || q.indexOf(F_CAB) >= 0, eng: fl.indexOf(F_ENG) >= 0 || q.indexOf(F_ENG) >= 0 };
        }
        if (S) {
          S.p.forEach(m => { if (!(m[2] & 1)) m[3].forEach(x => { if (y >= x[0] && y <= x[1] && slugMake(S.mk[x[2]]) === slugMake(mk) && slugModel(S.md[x[3]]) === slugModel(md)) { if (x[5] === -1) wild = true; else sub = true; } }); });
          q = sibQualNeed(S, v, '', '');
          return { bed: sibBedAmbiguous(S, v, '', ''), sub: sub && !wild, cab: q.indexOf(F_CAB) >= 0, eng: q.indexOf(F_ENG) >= 0 };
        }
        q = typeof h.ixQualNeed === 'function' ? h.ixQualNeed(index, v, '') : [];
        return { bed: typeof h.ixBedAmbiguous === 'function' && h.ixBedAmbiguous(index, v, ''), sub: false, cab: q.indexOf(F_CAB) >= 0, eng: q.indexOf(F_ENG) >= 0 };
      }
      g = D.querySelector('pt-fitment-grid');
      if (!g || g.dataset.scope === 'search' || mi == null) return no;
      ci = index.collIdx(g.dataset.collectionId, g.dataset.collectionHandle);
      if (ci == null) return no;
      P = index.data.products; beds = new Set(); sub = false; cab = false; eng = false;
      index.runs(mi).forEach(x => {
        var p = P[x[0]];
        if (!inRun(x, y) || !p || (p[1] & 1) || !p[3].some(c => c[0] === ci)) return;
        if (x[3] !== -1) beds.add(slugBed(index.data.beds[x[3]]));
        if (runSub(x) !== -1) sub = true;
        if (x[5] !== -1) cab = true;   /* CAB-ENGINE: some product on this page fits only some cabs / engines of the truck */
        if (x[6] !== -1) eng = true;
      });
      return { bed: bedGroups(Array.from(beds)) > 1, sub: sub, cab: cab, eng: eng };
    }
    /* TRUCK PAGE 2026-10: the page truck this selector is locked to, or null. The page's own band always is; the dialog only
       when the page itself opened it (fitment:open with lock, i.e. a [data-fitment-open-page] button). */
    lockOn() { var p = pageLock(); return p && (this.dataset.pageLock === 'true' || (!!this.closest(H('band')) && !!this.closest('pt-fitment-grid'))) ? p : null; }
    /* run filter: a non-master product of THIS collection (any product while the index does not carry the collection yet) */
    lockScope() {
      var g = D.querySelector('pt-fitment-grid'), d = index.data, P = d && d.products, ci = g && d ? index.collIdx(g.dataset.collectionId, g.dataset.collectionHandle) : undefined;
      return r => ci == null || (!!P[r[0]] && !(P[r[0]][1] & 1) && P[r[0]][3].some(c => c[0] === ci));
    }
    /* the page's pairs as [make, model, modelIdx] in the INDEX's own spelling and the page's order, keeping a pair only
       when one of its in-scope runs covers year y (0 = any year) */
    lockPairs(y) {
      var p = this.lockOn(), d = index.data, inC, out = [];
      if (!p || !d) return out;
      inC = this.lockScope();
      p.models.forEach(m => {
        var mi = index.modelIdx(m[0], m[1]);
        if (mi == null || out.some(x => x[2] === mi)) return;
        if (index.runs(mi).some(r => (!y || inRun(r, y)) && inC(r))) out.push([d.makes[d.models[mi][0]], d.models[mi][1], mi]);
      });
      return out;
    }
    lockYears() {
      var inC = this.lockScope(), ys = new Set();
      this.lockPairs(0).forEach(x => index.runs(x[2]).forEach(r => { if (inC(r)) for (var y = r[1]; y <= r[2]; y++) ys.add(y); }));
      return Array.from(ys).sort((a, b) => b - a);
    }
    /* Make + Model restricted to the page's pairs and PREFILLED with the first that fits (RealTruck: Year, Make=Ford,
       Model=F-150, Bed). A level with one choice, and every level before the Year, is disabled = locked. */
    lockFill(y, keepMk, keepMd) {
      var s = this.sel, pairs = this.lockPairs(y), makes = [], models;
      pairs.forEach(x => { if (makes.indexOf(x[0]) < 0) makes.push(x[0]); });
      this.fill(s.make, makes, keepMk);
      if (!s.make.value && makes.length) s.make.value = makes[0];
      models = pairs.filter(x => x[0] === s.make.value).map(x => x[1]);
      this.fill(s.model, models, keepMd);
      if (!s.model.value && models.length) s.model.value = models[0];
      s.make.disabled = !y || makes.length < 2;
      s.model.disabled = !y || models.length < 2;
      [s.make, s.model].forEach(x => { var o = x.value && x.querySelector('option[value=""]'); if (o) o.remove(); });
    }
    /* the level whose pick completes AND submits the vehicle (live: bed, else submodel, else model). On a truck page a
       prefilled Make / Model counts as picked, so a one-bed truck (Maverick, Gladiator) completes on the Year. */
    lastLevel() { var s = this.sel; if (this.hasBeds()) return 'bed'; if (this.hasEngs()) return 'engine'; if (this.hasCabs()) return 'cab'; if (this.hasSubs()) return 'submodel'; if (this.lockOn()) return !s.model.disabled ? 'model' : !s.make.disabled ? 'make' : 'year'; return 'model'; }
    /* the vehicle the selects currently describe (cab / engine only when chosen), or null while incomplete */
    vehicle() {
      var s = this.sel, v = { y: +s.year.value, mk: s.make.value, md: s.model.value, sub: (s.submodel && s.submodel.value) || null, bed: (s.bed && s.bed.value) || null };
      if (s.cab && s.cab.value) v.cab = s.cab.value;
      if (s.engine && s.engine.value) v.eng = s.engine.value;
      v.id = vehicleId(v);
      return v;
    }
    current() { return this.complete() ? this.vehicle() : null; }
    partial(done) { var s = this.sel; this.dispatchEvent(new CustomEvent('fitment:partial', { bubbles: true, composed: true, detail: { y: +s.year.value || 0, mk: s.make.value, md: s.model.value, sub: (s.submodel && s.submodel.value) || '', bed: (s.bed && s.bed.value) || '', cab: (s.cab && s.cab.value) || '', eng: (s.engine && s.engine.value) || '', complete: !!done, element: this } })); }
    /* refill every level below lv, keeping a lower value that still exists and resetting from the first invalid one down; a user change that leaves every level filled submits by itself (live: nothing is ever clicked) */
    /* REALTRUCK LOOK 2026-10-24 (owner: "only show the options that fit"): inside a product page's verify box the
       selects list only the trucks this product, or another live version of it (the page routes there), fits - as
       realtruck.com does. The scope is the index's runs of this product and of its group's live members; null =
       every truck (header box, collection band, a product the index does not carry, an index not loaded yet). */
    pdpScope() {
      var h = this.closest('pt-fitment-verify'), d = index.data, P, pid = -1, gi, sku, hd, role, i;
      if (this._scope !== undefined) return this._scope;
      if (!h || !d) return null;
      role = h.dataset.role;
      if (role !== 'child' && role !== 'standalone' && role !== 'master') return (this._scope = null);
      P = d.products; sku = (h.dataset.sku || '').trim().toLowerCase(); hd = h.dataset.handle || '';
      gi = h.dataset.group ? index.groupIdxByName.get(h.dataset.group) : undefined;
      if (role !== 'master') for (i = 0; i < P.length; i++) if (P[i][0] && ((sku && String(P[i][0]).trim().toLowerCase() === sku) || (hd && P[i][4] === hd))) { pid = i; break; }
      if (gi == null && pid < 0) return (this._scope = null);
      return (this._scope = r => { var p = P[r[0]]; return r[0] === pid || (gi != null && !!p && p[2] === gi && !(p[1] & 1) && !!p[4]); });
    }
    /* the scope's runs per model index, built once (null = unscoped) */
    cov() {
      var sc = this.pdpScope(), m;
      if (!sc) return null;
      if (this._cov !== undefined) return this._cov;
      m = new Map();
      index.fkeys().forEach(k => { var rs = index.runs(k).filter(sc); if (rs.length) m.set(+k, rs); });
      return (this._cov = m.size ? m : null);
    }
    /* the scope's runs of mi covering y that agree with the trim / cab / engine already chosen (null = unscoped) */
    covRuns(y, mi, pick) {
      var c = this.cov(), si = index.subIdx(pick.sub), ci = index.cabIdx(pick.cab), ei = index.engIdx(pick.eng);
      return c ? (c.get(mi) || []).filter(r => inRun(r, y) && index.runOk(r, null, si, ci, ei)) : null;
    }
    optYears() { var c = this.cov(), ys = new Set(); if (!c) return index.years(); c.forEach(rs => rs.forEach(r => { for (var y = r[1]; y <= r[2]; y++) ys.add(y); })); return index.years().filter(y => ys.has(y)); }
    optMakes(y) { var c = this.cov(), d = index.data, set = new Set(); if (!c) return index.makes(y); c.forEach((rs, mi) => { if (rs.some(r => inRun(r, y))) set.add(d.models[mi][0]); }); return index.makes(y).filter(i => set.has(i)); }
    optModels(y, mk) { var c = this.cov(); return c ? index.models(y, mk).filter(mi => (c.get(mi) || []).some(r => inRun(r, y))) : index.models(y, mk); }
    /* a detail level lists every value of the truck when some covering run fits all of them (-1), else the named ones */
    optDetail(all, rs, slot) { var set; if (!rs || rs.some(r => (slot === 4 ? runSub(r) : r[slot]) === -1)) return all; set = new Set(rs.map(r => slot === 4 ? runSub(r) : r[slot])); return all.filter(i => set.has(i)); }
    optSubs(y, mi) { return this.optDetail(index.submodels(y, mi), this.covRuns(y, mi, {}), 4); }
    optCabs(y, mi, pick) { return this.optDetail(index.cabs(y, mi), this.covRuns(y, mi, { sub: pick.sub }), 5); }
    optEngs(y, mi, pick) { return this.optDetail(index.engines(y, mi), this.covRuns(y, mi, { sub: pick.sub, cab: pick.cab }), 6); }
    optBeds(y, mi, pick) {
      var all = index.beds(y, mi, pick.sub || null), rs = this.covRuns(y, mi, pick), d = index.data;
      if (!rs || rs.some(r => r[3] === -1)) return all;
      return all.filter(i => rs.some(r => bedEq(slugBed(d.beds[r[3]]), slugBed(d.beds[i]))));
    }
    /* refill every level below lv. A user change clears every level after it (REALTRUCK LOOK 2026-10-24, owner: a new
       Year starts the truck over, as on realtruck.com; a truck page keeps its locked Make / Model); a programmatic
       cascade (prefill) keeps a lower value that still exists. A user change that leaves every level filled submits by
       itself (live: nothing is ever clicked). */
    cascade(lv, user) {
      var wasDone = !!this._done;
      var d = index.data, s = this.sel, prev ={ make: s.make.value, model: s.model.value, sub: s.submodel ? s.submodel.value : '', bed: s.bed ? s.bed.value : '', cab: s.cab ? s.cab.value : '', eng: s.engine ? s.engine.value : '' }, y = +s.year.value, mk, mi, subs, beds, lvl, pick, at = LEVELS.indexOf(lv), lk = !!this.lockOn();
      if (!d) return;
      if (user) LEVELS.forEach((l, i) => { if (i > at && !(lk && (l === 'make' || l === 'model'))) prev[l === 'submodel' ? 'sub' : l === 'engine' ? 'eng' : l] = ''; });
      if (lk && (lv === 'year' || lv === 'make')) this.lockFill(y, lv === 'year' ? prev.make : s.make.value, prev.model); /* TRUCK PAGE 2026-10 */
      else {
      if (lv === 'year') { mk = y ? this.optMakes(y).map(i => d.makes[i]) : []; this.fill(s.make, this.cov() ? mk : topFirst(mk), prev.make); }
      if (lv === 'year' || lv === 'make') { mk = d.makes.indexOf(s.make.value); this.fill(s.model, mk < 0 ? [] : this.optModels(y, mk).map(i => d.models[i][1]), prev.model); }
      }
      mi = s.model.value ? index.modelIdx(s.make.value, s.model.value) : null;
      /* no model yet: a level survives while ANY model of the chosen make offers it (none chosen = every level shows) */
      if (mi == null) { mk = s.make.value ? d.makes.indexOf(s.make.value) : -1; lvl = y && mk >= 0 ? index.levelsForMake(y, mk) : null; }
      var NO = { bed: false, sub: false, cab: false, eng: false }, nd = mi == null ? NO : this.need(y, s.make.value, s.model.value, mi); /* SELECTOR 2026-10-10 */
      if (lv !== 'submodel' && lv !== 'bed' && lv !== 'cab' && lv !== 'engine') { subs = mi == null ? [] : this.optSubs(y, mi).map(i => d.subs[i]); this.fill(s.submodel, subs, prev.sub); this.showLevel(this.subField, mi != null && subs.length > 0 && nd.sub); }
      /* CAB-ENGINE 2026-10-21: the truck's cabs / engines (its own list, not only what some product names); since
         REALTRUCK LOOK 2026-10-24 the Engine list follows the chosen Cab and the Bed list both (realtruck.com: Body,
         then Engine), and each is asked only while what is chosen above it still leaves it open */
      pick = { sub: (s.submodel && s.submodel.value) || null };
      if (lv === 'year' || lv === 'make' || lv === 'model' || lv === 'submodel') {
        var cabs = mi == null ? [] : this.optCabs(y, mi, pick).map(i => d.cabs[i]);
        this.fill(s.cab, cabs, prev.cab); this.showLevel(this.cabField, mi != null && cabs.length > 0 && nd.cab);
      }
      pick.cab = (s.cab && s.cab.value) || null;
      if (lv !== 'engine' && lv !== 'bed') {
        var engs = mi == null ? [] : this.optEngs(y, mi, pick).map(i => d.engines[i]), ne = mi == null ? NO : pick.cab ? this.need(y, s.make.value, s.model.value, mi, pick) : nd;
        this.fill(s.engine, engs, prev.eng); this.showLevel(this.engField, mi != null && engs.length > 0 && nd.eng && ne.eng);
      }
      pick.eng = (s.engine && s.engine.value) || null;
      if (lv !== 'bed') {
        /* 2026-09-14 (owner, action A): Bed no longer waits for the Submodel. Holding it behind an optional trim left
           355 year/make/model combinations with an empty Bed list (2021 Silverado 1500 offered one trim, "WT"). */
        beds = mi == null ? [] : this.optBeds(y, mi, pick).map(i => d.beds[i]);
        var nb = mi == null ? NO : (pick.cab || pick.eng) ? this.need(y, s.make.value, s.model.value, mi, pick) : nd;
        this.fill(s.bed, beds, prev.bed); this.showLevel(this.bedField, mi != null && beds.length > 0 && nd.bed && nb.bed);
      }
      LEVELS.forEach(l => { var o = s[l] && s[l].value && s[l].querySelector('option[value=""]:not([data-sep])'); if (o) o.remove(); });
      this.level();
      /* live: the grid follows every user change (fitment:partial); the vehicle is stored the moment it is complete, no GO needed */
      /* 2026-09-18: editing an earlier level of a filled form waits for the last level or GO.
         CAB-ENGINE 2026-10-23 (owner found it stuck): Cab and Engine are on screen together and get picked in either
         order, so the pick that COMPLETES the vehicle submits whichever level it is, and so does any change to a
         detail level (submodel / cab / engine / bed) of a complete form. Year / Make / Model edits of a complete form
         still wait (the 2026-09-18 rule). */
      /* The PDP buy box has no GO (owner 10-12, pt-wide-pdp.js): there ANY change that leaves the vehicle complete checks
         it, and a Cab / Engine pick that already rules this product out answers at once ("6.6L V8 Duramax" on a gas-only
         step needs no cab to say no). */
      if (user) {
        var done = this.complete(), buy = !!this.closest('pt-fitment-verify');
        this.partial(done);
        if (done ? (buy || lv === this.lastLevel() || DETAIL.test(lv) || !wasDone) : (buy && this.earlyNo())) this.submit();
      }
    }
    level() {
      var s = this.sel, n = s.year.value ? s.make.value ? s.model.value ? 3 : 2 : 1 : 0;
      if (n === 3) { if (s.submodel && s.submodel.value) n++; if (s.bed && s.bed.value) n++; if (s.cab && s.cab.value) n++; if (s.engine && s.engine.value) n++; }
      this.dataset.level = n;
      this.gate();
      this._done = this.complete();
      if (this.goBtn) this.goBtn.toggleAttribute('disabled', !this._done);
      if (this.clearBtn) this.clearBtn.toggleAttribute('disabled', n === 0);
    }
    /* REALTRUCK LOOK 2026-10-24: a Cab / Engine / Bed select opens only once every offered one above it is chosen
       (realtruck.com: Engine waits for Body); the optional Submodel gates nothing */
    gate() {
      var s = this.sel, open = !!(s.year.value && s.make.value && s.model.value);
      [['cab', this.cabField], ['engine', this.engField], ['bed', this.bedField]].forEach(x => {
        var sel = s[x[0]];
        if (!sel || !x[1] || x[1].hidden) return;
        sel.disabled = !open || !Array.from(sel.options).some(o => o.value);
        if (!sel.value) open = false;
      });
    }
    /* CAB-ENGINE 2026-10-23: only a Cab / Engine is still empty, one of them is chosen, and with what is chosen this
       buy box's own product already cannot fit (misses()). A product with no rows of its own (a series page) waits. */
    earlyNo() {
      var h = this.closest('pt-fitment-verify'), s = this.sel, miss = this.missing();
      if (!h || !h.rows || !Array.isArray(h.rows.r) || !miss.length || miss.some(f => f !== F_CAB && f !== F_ENG)) return false;
      if (!(s.cab && s.cab.value) && !(s.engine && s.engine.value)) return false;
      return misses(h.rows.r, this.vehicle());
    }
    /* CAB-ENGINE 2026-10-23: the offered levels still empty once Year / Make / Model are chosen, in screen order */
    missing() {
      var s = this.sel, out = [];
      if (!(s.year.value && s.make.value && s.model.value)) return out;
      if (this.hasSubs() && !s.submodel.value && !this.hasBeds() && !this.hasCabs() && !this.hasEngs()) out.push(T.submodel);
      if (this.hasCabs() && !s.cab.value) out.push(F_CAB);
      if (this.hasEngs() && !s.engine.value) out.push(F_ENG);
      if (this.hasBeds() && !s.bed.value) out.push(T.bed);
      return out;
    }
    reset(user) { var s = this.sel, lk = !!this.lockOn(); this.toggleAttribute('data-page-locked', lk); if (s.year) { if (index.data && (lk || this.wasLocked)) this.fill(s.year, (lk ? this.lockYears() : index.years()).map(String), ''); this.ph(s.year); s.year.value = ''; } this.wasLocked = lk; this.fill(s.make, []); this.fill(s.model, []); this.fill(s.submodel, []); this.fill(s.cab, []); this.fill(s.engine, []); this.fill(s.bed, []); if (lk && index.data) this.lockFill(0); this.showLevel(this.subField, false); this.showLevel(this.cabField, false); this.showLevel(this.engField, false); this.showLevel(this.bedField, false); this.level(); if (user) this.partial(false); }
    submit() {
      var s = this.sel, intent = this.dataset.intent || 'select';
      if (!s.model.value || !s.year.value) return;
      var v = this.vehicle();
      v.t = Date.now();
      /* pt-wide-pdp.js (buy box, owner 10-12) re-submits a completed pick on the next tick; the same vehicle again
         within 400 ms is that echo, not a new pick */
      if (this._sent && this._sent.id === v.id && v.t - this._sent.t < 400) return;
      this._sent = { id: v.id, t: v.t };
      /* FIT OPTIONS 2026-10-28: a two-body year picked from a Model list that offered BOTH bodies, each with its hint ("Silverado
         1500 (New Body)" next to "Silverado 1500 LD (Legacy, 2018 Body Style)"), answers the Body Style question; a list
         that offered one body (a product page that fits only that one) does not */
      var tw = twinFor(v), have = tw && !tw[8] ? Array.from(s.model.options).map(o => slugModel(o.value)) : [];
      if (have.indexOf(slugModel(tw && tw[1])) >= 0 && have.indexOf(slugModel(tw && tw[2])) >= 0) fitAns.setBody(v, slugModel(v.md) === slugModel(tw[2]) ? 'old' : 'new');
      origin = this;
      try { store.select(v, intent); } finally { origin = null; }
      this.dispatchEvent(new CustomEvent('fitment:submit', { bubbles: true, composed: true, detail: { vehicle: v, intent: intent, element: this } }));
    }
    /* pre-fill (Change): cascades without auto-submit and with the placeholders stripped (live), so GO + CLEAR are enabled and the widget waits for the user; nothing is focused */
    /* REALTRUCK LOOK 2026-10-24: a product page lists only the trucks it fits, so the stored truck may not be on the list;
       each level is set only when its value is offered (bed within the 2" tolerance), and the prefill stops at the first
       one that is not, leaving that select on its placeholder instead of a blank select */
    setValue(v) {
      return this.ensure().then(() => {
        /* `locked`: a truck page's Make / Model may be disabled because it is prefilled, and is still set */
        var s = this.sel, put = (x, want, bed, locked) => {
          var o = x && want && (locked || !x.disabled) ? Array.from(x.options).find(q => q.value && (bed ? bedEq(slugBed(q.value), slugBed(want)) : slugModel(q.value) === slugModel(want))) : null;
          if (o) x.value = o.value;
          return !!o;
        };
        if (!index.data) return;
        this.reset();
        if (!put(s.year, String(v.y), false, true)) return;
        this.cascade('year');
        if (!put(s.make, v.mk, false, true)) return;
        this.cascade('make');
        if (!put(s.model, v.md, false, true)) return;
        this.cascade('model');
        if (v.sub && put(s.submodel, v.sub)) this.cascade('submodel');
        if (v.cab && put(s.cab, v.cab)) this.cascade('cab');
        if (v.eng && put(s.engine, v.eng)) this.cascade('engine');
        if (v.bed && put(s.bed, v.bed, true)) this.cascade('bed');
      });
    }
  }

  /* ---------- <pt-vehicle-dialog> (cloned from #FitmentDialogTemplate on first fitment:open) ---------- */
  class VehicleDialog extends Base {
    bind() {
      var dlg = this.dlg = this.$(H('dialog'));
      this.selector = this.$('pt-vehicle-select');
      this.native = !!(dlg && typeof dlg.showModal === 'function');
      this.listen(this, 'click', e => { if (e.target.closest(H('dialog-close')) || e.target === dlg) this.close('dismiss'); });
      this.listen(dlg, 'cancel', e => e.preventDefault()); /* Convermax: only the X, the backdrop or a submit close it, never Escape */
      this.listen(dlg, 'close', () => this.after());
      this.listen(this, 'fitment:submit', () => this.close('submit'));
      this.listen(this, 'keydown', e => {
        if (this.native) return;
        var f = focusables(dlg), first = f[0], last = f[f.length - 1];
        if (e.key === 'Tab' && f.length && D.activeElement === (e.shiftKey ? first : last)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      });
    }
    open(d) {
      var intent = d.intent || 'select', sel = this.selector, dlg = this.dlg;
      this.dataset.intent = intent;
      this.set(H('dialog-title'), T.selectYourVehicle);
      this.opener = d.opener || null;
      if (!dlg.open) { if (this.native) dlg.showModal(); else { dlg.setAttribute('open', ''); this.classList.add('fitment-dialog--fallback'); } }
      try { dlg.focus(); } catch (e) {} /* nothing inside is focused on open (no ring on Year), as on the live widget */
      html.classList.add('fitment-dialog-open');
      this.dataset.state = 'open';
      if (!sel) return;
      sel.dataset.intent = intent;
      sel.dataset.pageLock = d.lock && pageLock() ? 'true' : 'false'; /* TRUCK PAGE 2026-10: header pill / garage opens stay free */
      if (d.prefill) sel.setValue(d.prefill); else { sel.reset(); sel.ensure(); }
    }
    /* how: 'dismiss' (the X or the backdrop - live closes the garage dropdown with it) or 'submit' (the dropdown stays open) */
    close(how) { this.how = how || 'dismiss'; if (this.native && this.dlg.open) this.dlg.close(); else { this.dlg.removeAttribute('open'); this.after(); } }
    after() {
      var how = this.how || 'dismiss';
      this.dataset.state = 'closed'; this.opener = null; this.how = null;
      html.classList.remove('fitment-dialog-open');
      try { if (D.activeElement && D.activeElement !== D.body) D.activeElement.blur(); } catch (e) {} /* focus lands on body after close, like live */
      emit('fitment:dialog-closed', { reason: how });
    }
  }

  /* ---------- <pt-garage variant="bar|icon"> ---------- */
  class Garage extends Base {
    bind() {
      this.panel = this.$(H('garage-panel')); this.toggle = this.$(H('garage-toggle'));
      this.listen(this, 'click', e => this.onClick(e));
      this.listen(this, 'change', e => { if (e.target.matches(H('mode-toggle'))) store.setMode(e.target.checked ? 'all' : 'active', 'mode'); });
      this.onChange(() => this.render());
      /* the dropdown stays open behind the vehicle dialog (live), so only a click outside both closes it */
      this.listen(D, 'click', e => { if (this.isOpen() && e.target.isConnected && !this.contains(e.target) && !e.target.closest('pt-vehicle-dialog')) this.setOpen(false); });
      /* ...but the dialog's own X and backdrop close the dropdown WITH it (live); an auto-submit leaves it open */
      this.listen(D, 'fitment:dialog-closed', e => { if (this.isOpen() && (!e.detail || e.detail.reason !== 'submit')) this.setOpen(false); });
      this.listen(D, 'keydown', e => { if (e.key === 'Escape' && this.isOpen() && !html.classList.contains('fitment-dialog-open')) { this.setOpen(false); this.toggle.focus(); } });
      this.render();
    }
    isOpen() { return !!(this.panel && !this.panel.hidden); }
    setOpen(b) {
      var p = this.panel, t = this.toggle;
      if (!p || !t || this.isOpen() === b) return;
      p.hidden = !b; t.setAttribute('aria-expanded', b); this.dataset.open = b;
      if (b) t.focus(); else if (p.contains(D.activeElement)) t.focus();
    }
    onClick(e) {
      var t = e.target, b = t.closest(H('open')), row = t.closest('[data-vehicle-id]'), id = row && row.dataset.vehicleId, i;
      if (b) { i = b.dataset.fitmentOpen === 'add' ? 'add' : this.dataset.state === 'active' ? 'change' : 'select'; openDialog(i, b, i === 'change' ? store.active() : undefined); }
      else if (t.closest(H('clear'))) store.clear('clear');
      else if (t.closest(H('garage-toggle'))) this.setOpen(!this.isOpen());
      else if (t.closest(H('select-vehicle'))) { store.setActive(id, 'switch'); W.location.assign(withVehicle(R.all)); } /* a garage row is a link to the results page (live) */
      else if (t.closest(H('remove-vehicle'))) store.remove(id, 'remove');
      else if (t.closest(H('clear-garage'))) { store.clearGarage('clear-garage'); this.setOpen(false); }
    }
    render() {
      var st = store.state, sel = store.selected(), n = st.vehicles.length, act = store.active(), on = sel.length > 0;
      var rows = this.$(H('garage-rows')), tpl = this.$('template[data-fitment-garage-row]'), cnt = this.$(H('count')), tog = this.$(H('mode-toggle'));
      this.dataset.state = on ? 'active' : 'empty'; this.dataset.count = n; this.dataset.mode = st.mode;
      this.set(H('vehicle'), on ? selLabel(sel, st.mode) : '');
      this.hide('.pt-garage__label--empty', on); this.hide('.pt-garage__label--active', !on); this.hide(H('clear'), !on);
      this.hide(H('garage-empty'), n > 0); this.hide(H('garage-list'), !n); this.hide(H('mode'), true); /* no all-my-vehicles toggle on live */
      if (cnt) { cnt.textContent = String(n); cnt.hidden = !n; }
      if (tog) tog.checked = st.mode === 'all';
      if (this.toggle) this.toggle.title = fmt(T.garageTitle || 'Garage: __COUNT__ item(s)', { __COUNT__: n });
      if (!rows || !tpl) return;
      clear(rows);
      st.vehicles.forEach(v => {
        var li = D.importNode(tpl.content, true).firstElementChild, cur = !!act && act.id === v.id, lb = label(v), rm = $(li, H('remove-vehicle'));
        li.dataset.vehicleId = v.id;
        setText(li, '.pt-garage__item-name', lb);
        li.classList.toggle('pt-garage__item--active', cur);
        if (cur) $(li, H('select-vehicle')).setAttribute('aria-current', 'true');
        hide(li, '.pt-garage__active-text', !cur);
        if (rm) rm.setAttribute('aria-label', fmt(T.removeVehicle, { __VEHICLE__: lb }));
        rows.appendChild(li);
      });
    }
  }

  /* ---------- <pt-fitment-band> ---------- */
  class Band extends Base {
    bind() {
      this.selector = this.$('pt-vehicle-select');
      this.onChange(() => this.render());
      this.listen(this, 'click', e => { var b = e.target.closest(H('change')); if (b) openDialog('change', b, store.active()); else if (e.target.closest(H('clear'))) store.clear('clear'); });
      this.listen(this, 'fitment:submit', () => { if (this.dataset.variant === 'hero' || !D.querySelector('pt-fitment-grid')) W.location.assign(withVehicle(this.dataset.target || R.all)); });
      /* unlocked band (collection page = live's SearchVehicleWidget): its CLEAR also drops the stored vehicle; the garage keeps it */
      this.listen(this, 'fitment:partial', e => { if (this.unlocked() && !e.detail.y && store.active() && (!pageLock() || pageLock().has(store.active()))) store.clear('clear'); }); /* TRUCK PAGE 2026-10: guard */
      this.render();
    }
    unlocked() { return this.dataset.lock === 'false'; }
    /* TRUCK PAGE 2026-10: "Showing Ford F-150 covers. Your truck: 2022 Chevrolet Silverado 1500 5'8"" plus a link to that
       truck's own page (else every tonneau cover), while the garage holds no truck this page is about */
    mismatch() {
      var box = this.$(H('mismatch')), p = pageLock(), sel = store.selected(), v, to, a;
      if (!box) return;
      v = p && sel.length && !sel.some(x => p.has(x)) ? (store.active() || sel[0]) : null;
      box.hidden = !v;
      if (!v) return;
      to = p.links.get(pageKey(v.mk, v.md));
      setText(box, H('mismatch-text'), fmt(T.pageMismatch || 'Showing __PAGE__ covers. Your truck: __VEHICLE__', { __PAGE__: p.name, __VEHICLE__: label(v) }));
      if ((a = $(box, H('mismatch-link')))) {
        a.setAttribute('href', to ? to.url : p.fallback);
        a.textContent = to ? fmt(T.pageMismatchLink || 'Shop __PAGE__ covers', { __PAGE__: to.name || v.md }) : (T.pageMismatchAll || 'Shop covers that fit your truck');
      }
    }
    render() {
      var sel = store.selected(), has = sel.length > 0, locked = has && !this.unlocked(), shop = this.$(H('shop')), s = this.selector, act, cur;
      this.dataset.state = locked ? 'locked' : 'active';
      this.classList.toggle('fitment-band--locked', locked);
      this.hide('.fitment-band__active', locked); this.hide('.fitment-band__locked', !locked);
      this.set(H('vehicle'), has ? selLabel(sel, store.state.mode) : '');
      if (shop) shop.setAttribute('href', withVehicle(this.dataset.target || R.all));
      this.mismatch(); /* TRUCK PAGE 2026-10 */
      /* unlocked: the selects mirror the stored vehicle (prefilled after a reload, reset after a clear) unless they already describe it */
      if (!this.unlocked() || !s || typeof s.current !== 'function') return;
      act = store.active(); cur = s.current();
      if (act && typeof s.lockOn === 'function' && s.lockOn() && !s.lockOn().has(act)) act = null; /* TRUCK PAGE 2026-10: another truck is stored - the locked selects stay on the page truck */
      if (act) { if (!cur || cur.id !== act.id) s.setValue(act); }
      else if (s.dataset.level !== '0') s.reset();
    }
  }

  /* ---------- <pt-facet-dialog>: mobile FILTERS slide-in (live #cm_FacetDialog) ---------- */
  /* home-mobile parity 2026-09-10: only DONE and the backdrop close it; Escape does nothing (live) */
  class FacetDialog extends Base {
    bind() {
      this.listen(this, 'click', e => { if (e.target.closest('[data-facet-dialog-close]') || e.target === this) this.close(); });
    }
    /* live moves focus to the PANEL, never to its first control: CLEAR must not come up ringed */
    open(opener) { var f; this.opener = opener || null; this.hidden = false; html.classList.add('fitment-dialog-open'); f = $(this, '[role="dialog"]') || focusables(this)[0]; if (f) try { if (f.getAttribute('role') === 'dialog') f.setAttribute('tabindex', '-1'); f.focus(); } catch (e) {} }
    close() { if (this.hidden) return; this.hidden = true; html.classList.remove('fitment-dialog-open'); if (this.opener) try { this.opener.focus(); } catch (e) {} this.opener = null; }
  }

  /* ---------- <pt-fitment-grid>: resolve -> chunked section fetch -> client sort/page -> swap ---------- */
  var SORTS = ['manual', 'best-selling', 'relevance', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending', 'created-descending', 'created-ascending'];
  /* ---- sort parity 2026-09-10 (rank probe; evidence + scripts in parity/facets/rank) ------------
     Live renders the same eight options in the same order on a collection page and on /pages/search,
     and "Best Match" is the selected default on both. The option VALUES stay Shopify's vocabulary
     because the very same select also drives the server-rendered grid through nativeSwap and
     Liquid's current_sort; what changed is what each one MEANS client-side:

       Best Match  (manual / relevance)  _score DESC, the formula below
       Name A-Z / Z-A (title-*)          title, ICU collation, ties by product id ASC
       Featured    (best-selling)        _docid ASC == Shopify product id ASC. NOT the collection's
                                         manual position (rho = -1.00 against it) and live ignores
                                         the descending form.
       Price L-H / H-L (price-*)         the FIRST variant's price (data-price-first)
       Date Old-New / New-Old (created-*) published_at, NOT created_at

     Best Match:  _score = F + _boost, strictly descending (52/52 live relevance sets, 7,930 items)
       F      = 0 with no vehicle; with a vehicle a constant per Fitment class:
                1.25 Vehicle Specific / 0.688675 Universal / 0.144338 No Fitment Data
       _boost = base + review_score/10 + popularity
       base   = 0.7 in stock, 0.1 out of stock   (sold-out is DEMOTED, never partitioned off)
       review_score = 1 + 4*Wilson95((avg-1)/4, count), 0 unreviewed  (3,877/3,877 exact on live)
       popularity   = Convermax's web-pixel behavioural residual. No Shopify field carries it, so it
                      is snapshotted per SKU in assets/fitment-boost.json; a SKU the table does not
                      carry scores 0 and the rest of the formula still orders it.
     Ties fall back to product id ASC, which is Lucene's _docid ASC on this index (0 inversions in
     1,208 products). */
  var BESTMATCH = s => s === 'manual' || s === 'relevance';   /* collection / search names for live's "Best Match" */
  var FEATURED = s => s === 'best-selling';                   /* live's "Featured" == product id ASC */
  var CMZ = 1.6448536269514722, CMZ2 = CMZ * CMZ;             /* one-sided 95% normal quantile */
  var FTERM = { 'vehicle-specific': 1.25, 'non-vehicle-products': 0.688675, 'no-fitment-data': 0.144338 };
  /* Convermax's review_score, verified to 4.1e-6 against every reviewed row live */
  function reviewScore(average, count) {
    var n = +count || 0, a = +average || 0, p, num;
    if (!n || !a) return 0;
    p = (a - 1) / 4;                                          /* 1..5 stars -> 0..1 */
    num = p + CMZ2 / (2 * n) - CMZ * Math.sqrt((p * (1 - p)) / n + CMZ2 / (4 * n * n));
    return 1 + 4 * (num / (1 + CMZ2 / n));
  }
  /* live collates titles with ICU, so 5'2" and 5'7" do not order by byte value */
  var COLL = (() => { try { return new Intl.Collator('en', { usage: 'sort' }); } catch (e) { return null; } })();
  var cmpTitle = (a, b) => COLL ? COLL.compare(a, b) : (a < b ? -1 : a > b ? 1 : 0);
  /* the popularity snapshot: one small same-origin JSON, fetched once, never fatal */
  var boosts = {
    map: null, promise: null,
    load: function () {
      var url = cfg.boostUrl || '';
      if (this.map) return Promise.resolve(this.map);
      if (!url) { this.map = {}; return Promise.resolve(this.map); }
      return this.promise || (this.promise = fetch(url, { credentials: 'omit' })
        .then(r => (r.ok ? r.json() : null))
        .then(j => (this.map = (j && j.pop) || {}))
        .catch(() => (this.map = {})));
    },
    of: function (sku) { var m = this.map; return (m && m[sku]) || 0; }
  };
  /* facet rail (facets parity 2026-09-10): live's six groups, their URL params and their select modes.
     Measured on the tenant API: vendor / category / price / FitmentType repeat as OR, review and stock are radios. */
  var FKEYS = ['cat', 'br', 'pr', 'rv', 'st', 'ft'];
  var FPARAM = { cat: 'fc', br: 'fb', pr: 'fp', rv: 'fr', st: 'fs', ft: 'ft' };
  var FMULTI = { cat: 1, br: 1, pr: 1, ft: 1 };
  var PRUNG = [[0, 9999], [10000, 24999], [25000, 49999], [50000, 99999], [100000, 249999], [250000, Infinity]];
  var RVRUNG = [5, 4, 3];                                   /* live returns exactly these three rungs */
  var RVMIN = k => k - 0.2;                                 /* live's 5-star rung starts at 4.8: a 4.75 (BAK226146) sits in "4 and up" */
  var FITV = ['vehicle-specific', 'no-fitment-data', 'non-vehicle-products'];
  var STV = ['in', 'avail', 'all'];
  var FLIMIT = 10;                                          /* live AlwaysShowCount */
  var blankSel = () => ({ cat: [], br: [], pr: [], ft: [], rv: '', st: '', min: '', max: '' });
  /* ---------- speed 2026-09-11: the resolved-set cache (a materialised view of the index) ----------
     A collection grid needs exactly four things out of fitment-index.json: which pids match, each
     one's SKU, its universal / vehicle-specific flags, and the store's brand-collection handles.
     All of that is a pure function of (index version, page + filters, vehicle ids), so the real path
     writes it to sessionStorage and a LATER view of the same page with the same vehicle paints
     without the 103 KB download on the critical path at all. The index still loads afterwards, at
     idle, and re-runs the resolve: a view whose pid set no longer matches is dropped and the grid
     re-run from the real index.

     The key function is rendered by fitment-boot.liquid so the <head> prefetch and this file cannot
     drift apart. With no cfg.vkey (an older boot snippet in a cached page) the whole path is off. */
  var VPRE = 'fitment:view:', VMAX = 24;
  var view = {
    key: function (path, search, ids) { try { return cfg.vkey ? cfg.vkey(path, search, ids) : null; } catch (e) { return null; } },
    read: function (k) {
      var raw = k && ss(VPRE + k), j;
      try { j = raw ? JSON.parse(raw) : null; } catch (e) { j = null; }
      if (!j || !(j.s instanceof Array) || !(j.f instanceof Array) || j.s.length !== j.f.length || !j.u0) return null;
      return j;
    },
    /* the brand-collection handle list is identical for every view of one index build, so it is
       stored once, under the index version, instead of in each record */
    handles: function (hs) {
      var k = VPRE + '@h|' + ((cfg.indexUrl || '').split('?')[1] || ''), j;
      if (hs) { try { ss(k, JSON.stringify(hs)); } catch (e) {} return hs; }
      try { j = JSON.parse(ss(k) || 'null'); } catch (e) { j = null; }
      return j instanceof Array ? j : [];
    },
    write: function (k, j) {
      var list = [];
      if (!k) return;
      try {
        list = JSON.parse(ss(VPRE + '@') || '[]');
        if (!(list instanceof Array)) list = [];
        list = list.filter(function (x) { return x !== k; });
        list.push(k);
        while (list.length > VMAX) ss(VPRE + list.shift(), null);
        ss(VPRE + k, JSON.stringify(j));
        ss(VPRE + '@', JSON.stringify(list));
      } catch (e) {
        try { list.forEach(function (x) { ss(VPRE + x, null); }); ss(VPRE + '@', null); } catch (e2) {}
      }
    },
    drop: function (k) { if (k) ss(VPRE + k, null); },
    /* a stand-in for FitmentIndex carrying exactly the surface fetchAll() touches. Pseudo-pids are
       the cached POSITIONS, which are the index's own pid order, so this.order and the chunk split
       come out byte-identical to the real path that wrote the record. */
    ix: function (j) {
      var P = j.s.map(function (sku, i) { return [sku, j.f[i], -1, [], '']; });
      var byH = new Map();
      view.handles().forEach(function (h) { byH.set(h, 1); });
      var mk = function () {
        var m = new Map();
        P.forEach(function (p, i) { var t = (j.m || [])[i]; m.set(i, t == null || t < 0 ? null : store.vehicleById((j.vi || [])[t]) || null); });
        return m;
      };
      return { lite: true, data: { products: P }, collIdxByHandle: byH,
               collIdx: function () { return j.ci == null ? undefined : j.ci; },
               match: mk, matchPartial: mk, browseSet: mk };
    }
  };
  /* SEARCH 2026-09-11 rev 2: the shopper's keywords, made safe to drop inside Shopify's search
     grammar. Parentheses, quotes, a backslash and a field colon would re-parse the whole query, a
     bare AND/OR/NOT would rewrite its shape, and a leading - or + negates or requires a term. Word
     characters, hyphens inside words and digits are left exactly as typed. */
  var qterms = function (s) {
    return String(s == null ? '' : s)
      .replace(/[()"\\:*~^[\]{}]/g, ' ')
      .replace(/(^|\s)[-+]+/g, '$1')
      .replace(/\b(?:AND|OR|NOT)\b/g, ' ')
      .replace(/\s+/g, ' ').trim().slice(0, 120);
  };
  var KSTOP = ['for', 'and', 'the', 'with', 'of', 'to', 'in', 'on', 'my'];
  class Grid extends Base {
    bind() {
      /* SEARCH PARITY 2026-09-11 rev 2: /search runs through this grid exactly like a collection.
         The previous revision handed the page back to Shopify's native search, which ignored the
         stored vehicle (a 2021 F-150 shopper searching "tonneau cover" got 1,000 rows led by a
         2015-2020 Ford cover), listed families child by child and fell back to the two native facet
         groups. Live applied the vehicle on /pages/search and threw the keyword away; we keep both -
         fetchChunk() sends the resolved SKU list AND the keywords - so the vehicle narrows the
         search instead of replacing it. With no vehicle the browse set plays the same part. */
      this.P = this.dataset.scope === 'search' ? 'main-search' : 'main-collection';
      this.main = this.$('.' + this.P + '__main'); this.tpl = this.$('template[data-fitment-chrome]');
      this.perPage = parseInt(this.dataset.perPage, 10) || 24;
      this.seq = 0; this.key = ''; this.chrome = null; this.orig = []; this.pairs = []; this.urlVehicle = urlIds().length > 0; this.partial = null; this.shown = 0;
      this.ftpl = this.$('template[data-fitment-facets]'); this.rails = []; this.cmeta = new Map();
      this.flabels = new Map(); this.fchips = [];
      this.fsel = this.readFacets(); this.rungs = this.priceRungs();
      this.onChange(d => this.onStore(d));
      this.listen(this, 'fitment:partial', e => this.onPartial(e));
      this.listen(W, 'popstate', () => this.onPop());
      this.listen(this, 'click', e => this.onClick(e));
      this.listen(this, 'change', e => {
        if (e.target.matches(H('sort'))) return this.setSort(e.target.value);
        if (e.target.matches('[data-facet-input]')) this.facetToggle(e.target);
      });
      /* live: Enter in either price box submits exactly like GO */
      this.listen(this, 'keydown', e => {
        if (e.key !== 'Enter' || !e.target.matches('[data-facet-price-min],[data-facet-price-max]')) return;
        e.preventDefault(); this.priceGo($(e.target.closest('.' + this.P + '__price'), '[data-facet-price-go]'));
      });
      this.browseSwap = this.dataset.browseSwap === 'true';
      if (!this.main || !this.tpl) html.classList.remove('fitment-pending');
      else if (store.pending || store.selected().length) this.onStore({ selected: store.selected(), reason: 'restore' });
      else if (this.browseSwap) this.runBrowse();
      else html.classList.remove('fitment-pending');
    }
    m(sel) { return $(this.main, sel); }
    /* TRUCK PAGE 2026-10: the stored vehicles this grid filters by - only the page's own trucks on a truck page, so a garage
       holding only other trucks leaves it in browse mode (series cards, no cart notes); Band.mismatch() says why */
    vsel(list) { var p = pageLock(); list = list || store.selected(); return p ? list.filter(v => p.has(v)) : list; }
    setState(s) { this.dataset.state = s; if (/^(vehicle|partial|empty|error|browse|browse-list)$/.test(s)) html.classList.remove('fitment-pending', 'fitment-hold'); }
    /* speed 2026-09-11: the safety timer used to un-dim the ORIGINAL server grid at 6 s while the
       chunk was still coming, leaving seconds of a fully visible un-filtered grid before the swap.
       While a fetch is in flight it re-arms instead; enter() drops the class the moment the server
       grid is actually gone, which is what the dim was protecting against. */
    arm() { clearTimeout(this.tm); this.tm = setTimeout(() => { if (this.ctrl && !this.done() && this.pids) return this.arm(); html.classList.remove('fitment-pending'); }, S.timeoutMs || 6000); }
    url() { return new URL(W.location.href); }
    go(u, replace) { var href = u.toString(); if (!isDesign() && href !== W.location.href) W.history[replace ? 'replaceState' : 'pushState']({ fitment: 1 }, '', href); }
    syncUrl(reason, keepPage, only) {
      var u = this.url(), q = u.searchParams, ids = only != null ? only : store.idsParam();
      if (ids) q.set('vehicle', ids); else q.delete('vehicle');
      Array.from(q.keys()).forEach(k => { if (/^Year\//.test(k) || (k === 'Facet' && /^Year\//.test(q.get(k) || ''))) q.delete(k); }); /* a forwarded Convermax path segment is consumed into vehicle= */
      if (!keepPage) q.delete('page');
      this.urlVehicle = !!ids;
      this.go(u, REPLACE.test(reason));
    }
    readSort() {
      var s = this.url().searchParams.get('sort_by'), def = this.dataset.scope === 'search' ? 'relevance' : 'manual';
      return SORTS.indexOf(s) >= 0 && s !== (def === 'manual' ? 'relevance' : 'manual') ? s : def;
    }
    readPage() { return Math.max(1, parseInt(this.url().searchParams.get('page'), 10) || 1); }
    filterParams() { var out = ''; this.url().searchParams.forEach((v, k) => { if (k.indexOf('filter.') === 0 && v !== '') out += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(v); }); return out; }
    done() { return this.landed.size === this.total; }
    /* fellBack = a keyword search that handed the page back to the server grid (see empty()).
       Its filter form is the server's own, so a filter click has to re-render the section rather
       than re-run a client query that is going to come back empty and hand it back again. */
    rerun() { if (this.fellBack) return this.nativeSwap(this.url()); this.run(this.browse); }
    onStore(d) {
      var ids = this.vsel(d.selected).map(v => v.id), key = ids.join(','), same = key === this.key, wasPartial = !!this.partial, mm = ids.length ? '' : d.selected.map(v => v.id).join(','), mmWas = this.mm; /* TRUCK PAGE 2026-10: mm = stored trucks this page is not about */
      if (!this.main || !this.tpl) return;
      this.partial = null;
      if (store.pending) { this.setState('pending'); this.arm(); return; }
      if (store.unknown.length) { this.message(T.unknownVehicle); store.unknown = []; }
      if (!ids.length) {
        if (this.key || this.urlVehicle) this.syncUrl(d.reason, false, ''); /* '' = no vehicle= (the store is empty here, or holds only other trucks) */
        this.mm = mm;
        if (mm && mm === mmWas && !this.key && !wasPartial && this.dataset.state === 'browse-list') return; /* TRUCK PAGE 2026-10: same other truck again, already browsing */
        this.key = '';
        if (this.browseSwap) this.runBrowse();
        else { this.leave(); if (this.staleSort()) this.nativeSwap(this.url()); } /* live keeps the sort through CLEAR: the server grid comes back sorted */
        return;
      }
      this.key = key; this.mm = '';
      if (same && !wasPartial) { if (this.dataset.state === 'error') this.run(); else this.pills(); return; }
      this.syncUrl(d.reason, REPLACE.test(d.reason)); /* a landing URL keeps its page=N (live: "&page=2" survives a reload); a user pick resets it */
      this.run();
    }
    /* the in-page band's selects drive the grid before the vehicle is complete (live); a complete pick goes through the store instead */
    onPartial(e) {
      var d = e.detail || {};
      if (!this.main || !this.tpl || d.complete || !e.target.closest(H('band'))) return;
      if (d.y) { this.partial = { y: d.y, mk: d.mk, md: d.md, sub: d.sub, bed: d.bed, cab: d.cab, eng: d.eng }; this.syncPartialUrl(this.partial); this.run(); }
      else if (this.partial) { this.partial = null; this.syncPartialUrl(null); if (this.browseSwap) this.runBrowse(); else this.leave(); }
    }
    /* live rewrites the URL at EVERY level, in Convermax's own path form, and only swaps it for
       vehicle= once the pick is complete (syncUrl deletes the Facet key again). */
    syncPartialUrl(p) {
      var u = this.url(), q = u.searchParams, seg = [], qs, href;
      Array.from(q.keys()).forEach(k => { if (/^Year\//.test(k) || k === 'Facet') q.delete(k); });
      q.delete('vehicle'); q.delete('page');
      if (p && p.y) {
        seg.push('Year/' + p.y);
        if (p.mk) seg.push('Make/' + p.mk);
        if (p.md) seg.push('Model/' + p.md);
        if (p.sub) seg.push('Submodel/' + p.sub);
        if (p.bed) seg.push('Bed/' + p.bed);
      }
      qs = q.toString();
      href = u.pathname + (qs ? '?' + qs : '');
      if (seg.length) href += (qs ? '&' : '?') + 'Facet=' + seg.map(x => x.split('/').map(encodeURIComponent).join('/')).join('/');
      this.urlVehicle = false;
      this.go(new URL(href, W.location.href), true);
    }
    onPop() {
      var ids = urlIds(), had = this.urlVehicle, sel;
      this.urlVehicle = ids.length > 0;
      if (ids.join(',') !== store.ids().join(',')) { if (ids.length) store.applyIds(ids, 'url'); else if (had) store.clear('url'); return; }
      if (!ids.length || !this.chrome || !this.pids) return;
      if (this.filterParams() !== this.filters) return this.rerun();
      this.sort = this.readSort(); this.page = this.readPage(); this.fsel = this.readFacets();
      if ((sel = this.m(H('sort')))) sel.value = this.sort;
      this.order = this.orderNow();
      if (this.order.length && this.done()) this.paint(false);
    }
    onClick(e) {
      var t = e.target, lm = t.closest(H('load-more')), pill = t.closest('.fitment-results__pill'), fo = t.closest('[data-facet-dialog-open]'), fc = t.closest('[data-facet-dialog-clear]'), sm = t.closest('[data-facet-show-more]'), pb = t.closest('[data-price-bucket]'), vn = t.closest('.product-card__vendor'), chip = t.closest('[data-facet-chip]'), so = t.closest('[data-facet-start-over]'), pg = t.closest('[data-facet-price-go]'), fd, u;
      if (t.closest(H('band'))) return;
      if (lm) { e.preventDefault(); if (this.chrome) this.nextPage(); else this.nextServer(lm); }
      /* live: the card's vendor line is a link to the brand collection (the card snippet renders a plain span) */
      else if (vn && vn.textContent.trim()) { e.preventDefault(); this.vendor(vn.textContent.trim()); }
      else if (fo) { fd = this.$('pt-facet-dialog'); if (fd && typeof fd.open === 'function') fd.open(fo); }
      /* live CLEAR / Start over: every facet goes, the vehicle stays, the drawer stays open */
      else if ((fc || so) && this.chrome) { e.preventDefault(); this.clearFacets(); this.facetApply(true); }
      else if (fc) { e.preventDefault(); u = this.url(); Array.from(u.searchParams.keys()).forEach(k => { if (k.indexOf('filter.') === 0) u.searchParams.delete(k); }); u.searchParams.delete('page'); this.go(u, false); this.rerun(); }
      else if (chip && this.chrome) { e.preventDefault(); this.chipOff(chip); }
      else if (pg && this.chrome) { e.preventDefault(); this.priceGo(pg); }
      else if (sm) this.showMore(sm);
      else if (pb && this.chrome) this.bucket(pb, e);
      else if (pill) store.setActive(pill.dataset.vehicleId, 'switch');
      else if (t.closest(H('clear'))) { if (t.closest('a')) e.preventDefault(); store.clear('clear'); }
      else if (t.closest(H('retry'))) this.rerun();
    }
    /* the brand collection when the store has one under the handleized vendor (live: /collections/bak-industries; the index lists collections
       that may since have been unpublished, so the handle is HEAD-checked first), else Shopify's automatic /collections/vendors?q= page */
    vendor(name) {
      var base = R.collections || '/collections', h = slugModel(name), brand = base + '/' + h, auto = base + '/vendors?q=' + encodeURIComponent(name);
      var known = ix => !!(ix && ix.collIdxByHandle.has(h)), go = ok => W.location.assign(ok ? brand : auto);
      var check = () => fetch(brand, { method: 'HEAD', credentials: 'same-origin' }).then(r => go(r.ok), () => go(false));
      if (index.data) { if (known(index)) check(); else go(false); }
      else index.load().then(ix => { if (known(ix)) check(); else go(false); }, () => go(false));
    }
    /* live price buckets re-render in place: a bucket click copies its gte/lte pair onto the current URL (clicking the active one removes the pair),
       the checked state is mirrored across the rail + dialog copies, and the results re-run with the vehicle kept */
    bucket(pb, e) {
      var u = this.url(), on = pb.classList.contains('is-active'), key = pb.getAttribute('href'), b = new URL(pb.href, W.location.href);
      e.preventDefault();
      Array.from(u.searchParams.keys()).forEach(k => { if (k.indexOf('filter.v.price') === 0) u.searchParams.delete(k); });
      if (!on) b.searchParams.forEach((v, k) => { if (k.indexOf('filter.v.price') === 0 && v !== '') u.searchParams.set(k, v); });
      this.pairs.forEach(p => $$(p[1], '[data-price-bucket]').forEach(a => {
        var hit = !on && a.getAttribute('href') === key, box = $(a, 'input[type="checkbox"]');
        a.classList.toggle('is-active', hit); if (hit) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); if (box) box.checked = hit;
      }));
      u.searchParams.delete('page'); this.go(u, false); this.rerun();
    }
    /* live facet "Show More": reveals the values past the first ten of that group (rail + the server-rendered form) */
    showMore(btn) {
      var group = btn.closest('.' + this.P + '__filter-group') || btn.parentNode, open = btn.getAttribute('aria-expanded') !== 'true';
      $$(group, '.' + this.P + '__filter-extra').forEach(li => { li.hidden = !open || li.dataset.zero === '1'; });
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? (btn.dataset.less || 'Show Less') : (btn.dataset.more || 'Show More');
      if (group.dataset) group.dataset.more = open ? '1' : '';   /* survives the next repaint */
    }
    setSort(s) {
      var u = this.url(), def = this.dataset.scope === 'search' ? 'relevance' : 'manual';
      if (SORTS.indexOf(s) < 0) return;
      this.sort = s; this.page = 1; this.painted = 0;
      if (s === def) u.searchParams.delete('sort_by'); else u.searchParams.set('sort_by', s); /* live drops the param for the default order */
      u.searchParams.delete('page'); this.go(u, false);
      if (!this.pids) return this.nativeSwap(u); /* plain browse: live re-renders in place, no navigation */
      this.order = this.orderNow();
      if (!this.done()) this.afterChunk(); else if (this.order.length) this.paint(false);
    }
    /* live "Next N": vehicle / browse-list mode appends the next slice in place, no scroll, URL page=N via history */
    nextPage() {
      var u = this.url();
      this.page = (this.painted || 1) + 1;
      u.searchParams.set('page', String(this.page)); this.go(u, false);
      this.paint(true);
    }
    /* the server rendered this page for data-sort; the URL may have moved on since (a sort change, or a
       sort chosen while a vehicle was applied), in which case the restored server grid is in the wrong order */
    staleSort() { return this.readSort() !== (this.dataset.sort || (this.dataset.scope === 'search' ? 'relevance' : 'manual')); }
    /* live: a sort with no vehicle re-renders the results in place - same scroll position, no navigation.
       Section Rendering hands back the whole section, so the swap also refreshes the toolbar and the
       select's own `selected` option; the custom elements inside re-bind on connect. */
    nativeSwap(u) {
      var sid = this.dataset.sectionId, host = this.closest('.shopify-section'), sep;
      if (!sid || !host || this.swapping) { if (!host) W.location.assign(u.pathname + u.search); return; }
      this.swapping = true;
      html.classList.add('fitment-pending');
      sep = u.search ? '&' : '?';
      fetch(u.pathname + u.search + sep + 'section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
        .then(text => {
          var doc = new DOMParser().parseFromString(text, 'text/html'), fresh = $(doc, '.shopify-section'), g, sel;
          if (!fresh) throw new Error('no section');
          if ((g = $(fresh, 'pt-fitment-grid'))) g.dataset.sort = this.sort;
          host.replaceWith(D.adoptNode(fresh));
          /* the swapped-in <pt-fitment-band> upgrades BEFORE the <pt-vehicle-select> inside it, so its
             first render() finds no selector API and skips the prefill: re-render now that both are live */
          $$(fresh, H('band')).forEach(bd => { if (typeof bd.render === 'function') bd.render(); });
          if ((sel = $(fresh, H('sort'))) && sel.value !== this.sort) sel.value = this.sort;
          html.classList.remove('fitment-pending');
        })
        .catch(() => { this.swapping = false; html.classList.remove('fitment-pending'); W.location.assign(u.pathname + u.search); });
    }
    /* server grid (plain browse): fetch the next page of this section (Section Rendering API) and append its cards */
    nextServer(btn) {
      var u = this.url(), page = parseInt(btn.dataset.page, 10) || 2, grid = this.m('.product-grid'), sid = this.dataset.sectionId, wrap = btn.closest(H('load-more-wrap'));
      if (!grid || !sid || btn.disabled) return;
      u.searchParams.set('page', String(page));
      btn.disabled = true;
      fetch(u.pathname + u.search + '&section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw new Error('page ' + r.status); return r.text(); })
        .then(text => {
          var doc = new DOMParser().parseFromString(text, 'text/html'), g = $(doc, '.' + this.P + '__main .product-grid'), nb = $(doc, H('load-more'));
          if (!g) throw new Error('no grid');
          Array.from(g.children).forEach(c => grid.appendChild(D.adoptNode(c)));
          this.go(u, false);
          btn.disabled = false;
          if (nb) { btn.textContent = nb.textContent; btn.dataset.page = nb.dataset.page; } else if (wrap) wrap.hidden = true;
        })
        .catch(() => { btn.disabled = false; W.location.assign(u.pathname + u.search); });
    }
    /* enter vehicle mode: detach .{P}__main originals (not the band), clone the chrome in, clone-swap the filter forms (§6.2) */
    enter() {
      var main = this.main, frag, items, ba, nav;
      html.classList.remove('fitment-pending', 'fitment-hold');   /* speed 2026-09-11: the un-filtered grid is detached below, so the dim is over */
      if (this.chrome) { if (this.origIn) { this.orig.forEach(n => n.remove()); this.origIn = false; } return this.view('results'); }
      this.orig = Array.from(main.childNodes).filter(n => !(n.nodeType === 1 && n.hasAttribute('data-fitment-band')));
      this.orig.forEach(n => main.removeChild(n));
      frag = D.importNode(this.tpl.content, true);
      this.chrome = Array.from(frag.childNodes);
      main.appendChild(frag);
      if ((items = this.m(H('grid-items')))) items.classList.toggle('product-grid--cols-3', this.dataset.cols === '3');
      if ((ba = this.m(H('browse-all')))) ba.setAttribute('href', withVehicle(R.all));
      /* live puts the "No results found" strip ABOVE the widget */
      if ((nav = this.m(H('empty'))) && (ba = this.$(H('band'))) && ba.parentNode === main) main.insertBefore(nav, ba);
      /* facets parity 2026-09-10: the six-group rail REPLACES the theme's Search & Discovery form in every host
         (desktop sidebar + the mobile <pt-facet-dialog> body) so the two filter UIs are never on screen together.
         Without the rail template the native forms are left exactly as the server rendered them. */
      this.rails = !this.ftpl ? [] : $$(this, '.' + this.P + '__sidebar form[data-filter-form], .' + this.P + '__mobile-panel form[data-filter-form], .' + this.P + '__facet-dialog form[data-filter-form]').map(form => {
        var rf = D.importNode($(this.ftpl.content, 'template[data-facet-rail]').content, true), root = $(rf, '[data-facet-rail-root]'), rail;
        form.replaceWith(rf);
        rail = { form: form, root: root, dialog: !!root.closest('pt-facet-dialog'), state: {} };
        return rail;
      });
      this.view('results');
    }
    leave() {
      var main = this.main;
      this.synNote(0);   /* SEARCH SYNONYMS 2026-10-13: native results never carry the note */
      clearTimeout(this.tm); this.seq++;
      if (this.ctrl) this.ctrl.abort();
      if (this.chrome) {
        this.chrome.forEach(n => n.remove());
        if (!this.origIn) this.orig.forEach(n => main.appendChild(n));
        this.rails.forEach(r => { if (r.root.parentNode) r.root.replaceWith(r.form); });
        this.pairs.forEach(p => p[1].replaceWith(p[0]));
        this.rails = []; this.pairs = []; this.chrome = null; this.origIn = false; this.pids = null;
      }
      this.partial = null; this.shown = 0; this.classList.remove('fitment-grid--empty');
      this.setState('browse');
    }
    onFilter(form) {
      var u = this.url(), q = u.searchParams;
      Array.from(q.keys()).forEach(k => { if (k.indexOf('filter.') === 0) q.delete(k); });
      new FormData(form).forEach((v, k) => { if (k.indexOf('filter.') === 0 && v !== '') q.append(k, v); });
      q.delete('page'); this.go(u, false); this.rerun();
    }
    view(mode) {
      var err = mode === 'error', em = mode === 'empty', m = this.main, keep = em && this.facetsOn();
      /* a facet emptied the grid: keep the toolbar + rail so the shopper can undo it (live only ever empties on the vehicle) */
      hide(m, H('toolbar'), err || (em && !keep)); hide(m, H('grid-items'), err);
      hide(m, H('vehicles'), err || em || !!this.partial || this.vsel().length < 2); /* live never shows a vehicle pill row for one vehicle */
      hide(m, H('empty'), !em); hide(m, H('error'), !err);
      if (mode !== 'results') hide(m, H('load-more-wrap'), true);
      this.classList.toggle('fitment-grid--empty', em && !keep); /* live: no facet rail, no toolbar, only the strip + the prefilled widget */
    }
    message(text) {
      var m = this.m(H('message')), lr = $(D, '[data-live-region]');
      if (!m) { if (lr) lr.textContent = text; return; }
      clearTimeout(this.mt); m.textContent = text; m.hidden = false;
      this.mt = setTimeout(() => { m.hidden = true; m.textContent = ''; }, 6000);
    }
    count(text) { var n = this.m(H('count')), s = n && $(n, 'span'); if (n) (s || n).textContent = text == null ? '' : text; } /* live wraps the count in a bold <span> */
    skeleton() {
      var items = this.m(H('grid-items')), tpl = this.m('template[data-fitment-skeleton]');
      clear(items);
      if (items && tpl) for (var i = 0; i < this.perPage; i++) items.appendChild(D.importNode(tpl.content, true));
    }
    runBrowse() { this.browse = true; this.run(true); }
    run(browse) {
      this.fellBack = false;
      this.browse = !!browse;
      if (this.browse) this.partial = null;
      var seq = ++this.seq, loading = () => { this.setState('loading'); this.skeleton(); this.count(this.browse || this.partial ? (T.resultsLoadingBrowse || 'Loading products…') : fmt(T.resultsLoading, { __VEHICLE__: curLabel() })); };
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      this.sort = this.readSort(); this.page = this.readPage(); this.painted = 0; this.shown = 0; this.filters = this.filterParams();
      this.fsel = this.readFacets(); this.cmeta = new Map();   /* live: STOCK defaults to "Available", so sold-out drops out */
      this.pids = null; this.cards = new Map(); this.landed = new Set(); this.total = Infinity; /* not 0: done() must stay false until fetchAll has counted the chunks */
      this.gfits = null; this.ix = null; this.stdef = null;
      /* speed 2026-09-11: a view of this page with this vehicle that has already been resolved once
         this session skips the index entirely - the <head> prefetch has usually already asked for
         the first chunk by now, so the cards are on the wire before fitment.js even parsed. */
      this.vkey = this.partial ? null : view.key(W.location.pathname, W.location.search, this.browse ? '' : this.vsel().map(v => v.id).join(','));
      var lv = this.vkey ? view.read(this.vkey) : null, sel;
      /* the skeleton no longer waits for 103 KB: with a vehicle stored the grid is going to be
         replaced whatever the index says, so the chrome goes in now and the shopper sees a
         skeleton instead of a dimmed grid. Browse mode still waits (the collection may not be in
         the index at all, and leave() would have to put the server grid back). */
      if (this.chrome) loading();
      else if (lv || this.holdServer() || (!this.browse && !this.partial && this.vsel().length)) { this.enter(); loading(); }
      else { this.setState('pending'); if (this.dataset.scope !== 'search') html.classList.add('fitment-pending'); }
      this.arm();
      if (lv) {
        if ((sel = this.m(H('sort')))) sel.value = this.sort;
        var go = () => { if (seq !== this.seq) return; this.fetchAll(view.ix(lv), seq); this.recheck(seq, lv); };
        if (BESTMATCH(this.sort)) boosts.load().then(go, go); else go();
        return;
      }
      /* the popularity snapshot rides along with the index (2% of its size, and it never rejects),
         so Best Match has every term it needs before the first paint */
      Promise.all([index.load(), boosts.load()]).then(r => {
        var ix = r[0], sel2;
        if (seq !== this.seq) return;
        /* SEARCH 2026-09-11 rev 2: a keyword browse does NOT clear the page here. Collapsing the
           whole catalogue against the keywords takes seven chunk requests - about 2.5 s at 1440
           and 9 s on a throttled phone - and a skeleton for that long is worse than the real rows
           the server already rendered. paint() swaps them out in one go when the set is ready. */
        if (!this.holdServer()) { this.enter(); loading(); }
        if ((sel2 = this.m(H('sort')))) sel2.value = this.sort;
        this.fetchAll(ix, seq);
      }, () => { if (seq === this.seq) this.fail(); });
    }
    /* the scope + resolve half of fetchAll(), pure so recheck() can run it against the real index
       without touching the grid that is already painted. undefined = this collection is not in the index. */
    matchSet(ix) {
      var id = this.dataset.collectionId, h = this.dataset.collectionHandle, ci;
      /* the automatic /collections/all (no id, handle "all") is unscoped (CONTRACT 6.3), never "no results": it is where the garage rows and forwarded vehicle-only URLs land */
      /* a collection the index does not carry (an automatic /collections/vendors?q= or /collections/types?q= page, or one added after the last sync): browsing keeps the server grid instead of an empty swap */
      if (this.dataset.scope !== 'search' && (id || (h && h !== 'all')) && (ci = ix.collIdx(id, h)) === undefined) return undefined;
      return { ci: ci, matches: this.browse ? ix.browseSet(ci) : this.partial ? ix.matchPartial(this.partial, { collIdx: ci, includeUniversal: !!S.includeUniversal, strictGroups: !!S.strictGroups }) : ix.match(this.vsel(), { collIdx: ci, includeUniversal: !!S.includeUniversal, strictGroups: !!S.strictGroups }) };
    }
    /* the cached view painted the grid; confirm it against the real index once the page is idle and
       re-run from scratch if the resolve has moved on (a rebuilt catalogue under an unchanged ?v=) */
    recheck(seq, lv) {
      var run = () => index.load().then(ix => {
        var m, pids, ok;
        if (seq !== this.seq) return;
        m = this.matchSet(ix);
        pids = m ? Array.from(m.matches.keys()) : [];
        ok = !!m && pids.length === lv.s.length && pids.every((pid, i) => ix.data.products[pid][0] === lv.s[i]);
        /* CAB-ENGINE 2026-10-21: the cached view painted the cart notes without the index; correct them now it is here */
        if (ok) { this.cards.forEach((card, i) => { var pid = pids[i], v = this.matches && this.matches.get(i); if (pid != null && v && card.isConnected) this.property(card, pid, ix, v); }); return; }
        view.drop(this.vkey);
        this.vkey = null;
        this.rerun();
      }, noop);
      if (W.requestIdleCallback) W.requestIdleCallback(run, { timeout: 4000 }); else W.setTimeout(run, 1500);
    }
    /* the sanitised keywords this page searches on; '' on a collection page and on a /search with
       no query, which is what makes the SKU-list-only request the default everywhere else. */
    terms() { return this.dataset.scope === 'search' ? qterms(this.dataset.terms) : ''; }
    fetchAll(ix, seq) {
      var P = ix.data.products, chunks = [], cur = [], m = this.matchSet(ix), tq = this.terms();
      var base = 120 + (R.search || '').length + this.filters.length + (tq ? encodeURIComponent(' AND (' + tq + ')').length : 0), len = base, max = S.urlMax || 7500, size = S.chunk || 200, next = 0, active = 0;
      if (m === undefined) return this.browse || pageLock() ? this.leave() : this.empty(); /* TRUCK PAGE 2026-10: not indexed yet = server grid */
      this.ix = ix; this.gfits = null;
      this.ci = m.ci;
      this.matches = m.matches;
      this.pids = Array.from(this.matches.keys());
      /* a collection too big to hold in memory keeps the server grid (and its own filters) rather than firing a dozen chunk fetches.
         2026-09-11: the cap has to clear the whole catalogue, because /collections/all IS a browse
         surface on live - its STOCK "All" rung reads 1,208, the same number browseSet() returns
         unscoped - and the nav's first item ("Shop All") landed on the native grid at 600. */
      if (this.browse && this.pids.length > (S.browseMax || 3000)) return this.leave();
      if (!this.pids.length) return this.empty();
      this.order = this.orderNow();
      this.order.forEach(pid => {
        var piece = encodeURIComponent('variants.sku:"' + P[pid][0] + '" OR ').length;
        if (cur.length && (cur.length >= size || len + piece > max)) { chunks.push(cur); cur = []; len = base; }
        cur.push(pid); len += piece;
      });
      if (cur.length) chunks.push(cur);
      this.chunkOf = new Map();
      chunks.forEach((c, i) => c.forEach(pid => this.chunkOf.set(pid, i)));
      this.total = chunks.length;
      var pump = () => {
        while (active < 4 && next < chunks.length) {
          let i = next++;
          active++;
          this.fetchChunk(chunks[i], i, ix, seq).then(() => { if (seq !== this.seq) return; active--; this.landed.add(i); this.afterChunk(); pump(); }, () => { if (seq === this.seq) this.fail(); });
        }
      };
      pump();
      this.saveView(ix);
    }
    /* write the resolved set for the NEXT view of this page. Only the real index writes one: a run
       fed by view.ix() would just rewrite what it was given. */
    saveView(ix) {
      var P, vi, byId, m;
      if (ix.lite || !this.vkey || !this.u0 || this.partial) return;
      P = ix.data.products; vi = []; byId = new Map(); m = [];
      this.pids.forEach(pid => {
        var v = this.matches.get(pid), k;
        if (!v || !v.id) { m.push(-1); return; }
        k = byId.get(v.id);
        if (k == null) { k = vi.length; vi.push(v.id); byId.set(v.id, k); }
        m.push(k);
      });
      view.handles(Array.from(ix.collIdxByHandle.keys()));
      view.write(this.vkey, {
        s: this.pids.map(pid => P[pid][0]),
        f: this.pids.map(pid => P[pid][1] | (P[pid][2] !== -1 ? 8 : 0)),
        m: m, vi: vi, ci: this.ci == null ? null : this.ci, u0: this.u0
      });
    }
    fetchChunk(chunk, i, ix, seq) {
      var P = ix.data.products, want = new Map();
      var t = this.terms();
      var q = '(' + chunk.map(pid => 'variants.sku:"' + P[pid][0].replace(/["\\]/g, '') + '"').join(' OR ') + ')';
      /* SEARCH 2026-09-11 rev 2: on /search the keywords are ANDed onto the SKU list, so the result
         is the intersection of "fits this truck" (or "is a browse master") and "matches what the
         shopper typed". options[prefix]=last keeps Shopify's own partial-word match on the LAST
         word typed; with no keywords the last token is a SKU, which has to stay exact, so the
         request falls back to prefix=none. Only the cards the response carries survive orderNow(),
         so the count, the facet counts and the paging are the intersection with no extra work. */
      if (t) q += ' AND (' + t + ')';
      chunk.forEach(pid => want.set(P[pid][0].trim().toLowerCase(), pid));
      var url = (R.search || '/search') + '?type=product&options[prefix]=' + (t ? 'last' : 'none') + '&section_id=' + encodeURIComponent(cfg.sectionId || 'fitment-results') + '&q=' + encodeURIComponent(q) + this.filters;
      /* speed 2026-09-11: chunk 0's URL is cached with the resolved set, so the <head> script asks for
         it before fitment.js has even been downloaded. Adopt that response only when it is for exactly
         this query; anything else (a different vehicle, a filter, a stale record) just fetches, and a
         prefetch that failed resolves to null so it falls back instead of failing the grid. */
      /* 2026-09-11: ONE dropped connection or Cloudflare 429 used to leave the shopper on the
         "Vehicle search is temporarily unavailable" panel with a RETRY button to press. Two automatic
         retries, 600 ms then 1500 ms, clear every transient one; a real failure still falls through
         to fail(), which puts the server grid back. An aborted run (a new vehicle, a new sort) never
         retries: the signal is checked first. */
      var pre = cfg.pre, p, sig = this.ctrl.signal;
      var once = () => fetch(url, { signal: sig }).then(r => { if (!r.ok) throw new Error('results ' + r.status); return r.text(); });
      var real = n => once().catch(e => {
        n = n || 0;
        if (sig.aborted || seq !== this.seq || n >= 2) throw e;
        return new Promise(ok => setTimeout(ok, n ? 1500 : 600)).then(() => real(n + 1));
      });
      if (i === 0) this.u0 = url;
      if (i === 0 && pre && pre.u === url && pre.p) { cfg.pre = null; p = pre.p.then(t => t == null ? real() : t); }
      else p = real();
      return p
        .then(text => {
          var doc;
          if (seq !== this.seq) return;
          doc = new DOMParser().parseFromString(text, 'text/html');
          /* every facet value the rail needs travels on the card itself, so nothing else is parsed out of the chunk */
          $$(doc, '[data-fitment-results] .fitment-card').forEach(card => {
            var pid = want.get((card.dataset.sku || '').trim().toLowerCase());
            if (pid != null && !this.cards.has(pid) && this.khit(card)) { card.dataset.kwhole = this.khit(card, true) ? '1' : ''; this.cards.set(pid, D.adoptNode(card)); }
          });
        });
    }
    /* ---------- facet rail ----------------------------------------------------------------
       Six groups, live's order: CATEGORY (collection membership) - BRAND (vendor) - PRICE (a fixed
       six-rung ladder plus Min/Max) - REVIEW (5 / 4+ / 3+) - STOCK (In-stock Only / Available / All)
       - FITMENT (index flags). Every count is computed here, from the cards that are ALREADY in
       memory: the chunked fetch pulls the whole matched set before the first paint, so a facet
       click costs no request at all.

       Two live rules, both measured against the tenant API (12/12 counts matched):
         1. a group's own values are counted with THAT group's own selection lifted, every other
            group applied (so BRAND keeps summing to the unfiltered total while a brand is picked);
         2. a value whose count would be 0 is REMOVED from the DOM - never greyed, never disabled.
       Within a group values OR, across groups they AND; review and stock are single-select. */
    facetCfg() { return (this.ftpl && this.ftpl.dataset) || {}; }
    /* live's BRAND order is a store-global vendor sequence snapshotted into data-vendor-order */
    vendorOrder() {
      var m;
      if (this._vord) return this._vord;
      m = new Map();
      String(this.facetCfg().vendorOrder || '').split('|').forEach((v, i) => { v = v.trim(); if (v) m.set(v.toLowerCase(), i); });
      return (this._vord = m);
    }
    priceRungs() {
      return String(this.facetCfg().priceRungs || '').split('|').filter(Boolean).map((s, i) => {
        var p = s.split('~'), r = PRUNG[i] || [0, Infinity];
        return { k: p[0], t: p[1] || p[0], lo: r[0], hi: r[1] };
      });
    }
    readFacets() {
      var q = this.url().searchParams, list = k => q.getAll(FPARAM[k]).filter(Boolean);
      return { cat: list('cat'), br: list('br'), pr: list('pr'), ft: list('ft'),
               rv: q.get(FPARAM.rv) || '', st: q.get(FPARAM.st) || '', min: q.get('fmin') || '', max: q.get('fmax') || '' };
    }
    clearFacets() { this.fsel = blankSel(); }
    /* the default STOCK rung ("Available") is not a filter the shopper set, so it never counts as "on" */
    facetsOn() {
      var s = this.fsel;
      return !!(s.cat.length || s.br.length || s.pr.length || s.ft.length || s.rv || (s.st && s.st !== this.stockDefault()) || s.min || s.max);
    }
    writeFacets(replace) {
      var u = this.url(), q = u.searchParams, s = this.fsel;
      FKEYS.forEach(k => q.delete(FPARAM[k]));
      q.delete('fmin'); q.delete('fmax'); q.delete('page');
      ['cat', 'br', 'pr', 'ft'].forEach(k => s[k].forEach(v => q.append(FPARAM[k], v)));
      if (s.rv) q.set(FPARAM.rv, s.rv);
      if (s.st) q.set(FPARAM.st, s.st);
      if (s.min) q.set('fmin', s.min);
      if (s.max) q.set('fmax', s.max);
      this.go(u, !!replace);
    }
    cardMeta(pid) {
      var m = this.cmeta.get(pid), c = this.cards.get(pid), d, p, vs;
      if (m || !c) return m || null;
      d = c.dataset;
      p = (this.ix && this.ix.data && this.ix.data.products[pid]) || [0, 0, -1];
      /* a master carries no vehicle rows of its own and its children need not even be ACTIVE, so
         a lookup among the group's INDEXED members is not enough: live types every product that
         carries a convermax_product_group as Vehicle Specific (store-wide on the tenant API, 0 of
         507 "No Fitment Data" and 0 of 209 "Universal Fit" rows have a group). */
      vs = (p[1] & 8) || p[2] !== -1;
      m = { vendor: decode(d.vendor || ''), vslug: slugModel(d.vendor || ''),
            names: (d.catnames || '').split('|').filter(Boolean),
            price: parseInt(d.price, 10) || 0, avail: d.available === 'true', qty: parseInt(d.qty, 10) || 0,
            rating: parseFloat(d.rating) || 0, reviews: parseInt(d.reviews, 10) || 0,
            ft: vs ? FITV[0] : (p[1] & 2) ? FITV[2] : FITV[1] };
      m.cats = m.names.map(slugModel);   /* live's Category values are titles, so the title keys the facet */
      this.cmeta.set(pid, m);
      return m;
    }
    priceHit(m) {
      var s = this.fsel, p = m.price, ok = false, lo, hi;
      if (!s.pr.length && !s.min && !s.max) return true;
      this.rungs.forEach(r => { if (s.pr.indexOf(r.k) >= 0 && p >= r.lo && p <= r.hi) ok = true; });
      if (!ok && (s.min || s.max)) {
        lo = s.min ? Math.round(parseFloat(s.min) * 100) : 0;
        hi = s.max ? Math.round(parseFloat(s.max) * 100) : Infinity;
        ok = p >= lo && p <= hi;
      }
      return ok;
    }
    /* live's STOCK default is "Available", but only while something IS available: on a set where
       every product is sold out (/collections/decked, /collections/truck-bed-mats) the tenant API
       returns no stock facet at all and no stock filter, so live shows all 56 / all 8. Without this
       the implicit default emptied the page and then hid the control that would undo it. */
    stockDefault() {
      if (this.stdef) return this.stdef;
      if (!this.pids || !this.done()) return 'avail';
      return (this.stdef = this.pids.some(pid => { var m = this.cardMeta(pid); return !!(m && m.avail); }) ? 'avail' : 'all');
    }
    stockHit(m) { var v = this.fsel.st || this.stockDefault(); return v === 'all' || (v === 'in' ? m.qty > 0 : m.avail); }
    fhit(pid, skip) {
      var m = this.cardMeta(pid), s = this.fsel;
      if (!m) return false;
      if (skip !== 'cat' && s.cat.length && !s.cat.some(h => m.cats.indexOf(h) >= 0)) return false;
      if (skip !== 'br' && s.br.length && s.br.indexOf(m.vslug) < 0) return false;
      if (skip !== 'pr' && !this.priceHit(m)) return false;
      if (skip !== 'rv' && s.rv && (!m.rating || m.rating < RVMIN(+s.rv))) return false;
      if (skip !== 'st' && !this.stockHit(m)) return false;
      if (skip !== 'ft' && s.ft.length && s.ft.indexOf(m.ft) < 0) return false;
      return true;
    }
    /* [{key, title, values:[{v,label,count,on,chip}]}] in live's order; an empty group is dropped whole
       (live: no reviewed product -> no REVIEW group, one brand -> no BRAND group) */
    facetGroups() {
      var C = this.facetCfg(), s = this.fsel, out = [], rank = new Map();
      var pids = (this.pids || []).filter(pid => this.cards.has(pid));
      var cat = new Map(), br = new Map(), ft = new Map(), pr = new Map(), rv = [0, 0, 0], st = [0, 0, 0], brands = {};
      var ftLabel = { 'vehicle-specific': C.fitVehicle || 'Vehicle Specific',
                      'no-fitment-data': C.fitNone || 'No Fitment Data',
                      'non-vehicle-products': C.fitUniversal || 'Non-Vehicle Products' };
      this.orderNow(true).forEach((pid, i) => rank.set(pid, i));
      var bump = (map, key, label, pid) => {
        var e = map.get(key), r = rank.has(pid) ? rank.get(pid) : 1e9;
        if (e) { e.count++; if (r < e.rank) e.rank = r; } else map.set(key, { v: key, label: label, count: 1, rank: r });
      };
      /* live's Category never lists a value that IS a brand (no "BAK Industries" row, but
         "Weather Guard Tool Boxes" stays), so the brand collections drop out here */
      pids.forEach(pid => { var v = this.cardMeta(pid); if (v && v.vendor) brands[v.vslug] = 1; });
      pids.forEach(pid => {
        var m = this.cardMeta(pid);
        if (this.fhit(pid, 'cat')) m.cats.forEach((h, j) => { if (!brands[h]) bump(cat, h, m.names[j] || h, pid); });
        if (this.fhit(pid, 'br') && m.vendor) bump(br, m.vslug, m.vendor, pid);
        if (this.fhit(pid, 'ft')) bump(ft, m.ft, ftLabel[m.ft], pid);
        if (this.fhit(pid, 'pr')) this.rungs.forEach(r => { if (m.price >= r.lo && m.price <= r.hi) bump(pr, r.k, r.t, pid); });
        if (this.fhit(pid, 'rv') && m.rating) RVRUNG.forEach((k, j) => { if (m.rating >= RVMIN(k)) rv[j]++; });
        if (this.fhit(pid, 'st')) { st[2]++; if (m.avail) st[1]++; if (m.qty > 0) st[0]++; }
      });
      var on = (k, v) => FMULTI[k] ? s[k].indexOf(v) >= 0 : (k === 'st' ? (s.st || this.stockDefault()) : s[k]) === v;
      var mark = k => e => { e.on = on(k, e.v); return e; };
      var add = (k, title, values) => { if (values.length) out.push({ key: k, title: title || k, values: values }); };
      /* CATEGORY: ordinal by title, exactly like the tenant API ("UWS Tool Boxes" before "Underbed") */
      add('cat', C.titleCategory, Array.from(cat.values()).sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0).map(mark('cat')));
      /* BRAND: live orders this group by a store-global vendor sequence - not alphabetical, not by
         count (catalogue-wide it runs Weather Guard 246, BAK Industries 7, ARB 33, Warn 49, B&W 121,
         BEDSLIDE 67, Extang 8, Fill-Rite 5, Prestige Truck 5, Retrax 9, UWS 38). It is snapshotted
         into the facet template's data-vendor-order; an unknown vendor sorts after the known ones,
         by title, and the ranked-list position stays as the final tie-break. */
      var vord = this.vendorOrder(), vpos = e => { var i = vord.get(String(e.label || '').toLowerCase()); return i === undefined ? 1e6 : i; };
      var brv = Array.from(br.values()).sort((a, b) => vpos(a) - vpos(b) || cmpTitle(a.label, b.label) || a.rank - b.rank).map(mark('br'));
      /* live drops the vendor facet whole as soon as ONE vendor is left (the tenant API returns no
         `vendor` facet at all on a single-brand result set) while it still returns a one-value
         CATEGORY or FITMENT group, so this is a vendor rule, not a general single-value rule. */
      add('br', C.titleVendor, brv.length > 1 ? brv : []);
      /* PRICE: the fixed six-rung ladder, empty rungs hidden, then the custom range as an extra checked row with no count */
      var prv = this.rungs.filter(r => pr.has(r.k)).map(r => mark('pr')(pr.get(r.k)));
      if (s.min || s.max) prv.push({ v: 'custom', label: (s.min ? this.money(s.min) : this.money(0)) + ' - ' + (s.max ? this.money(s.max) : (C.any || '*')), count: null, on: true });
      if (prv.length || pids.length) out.push({ key: 'pr', title: C.titlePrice || 'Price', values: prv, inputs: true });
      /* REVIEW: 5 stars, then "4 and up", "3 and up" */
      add('rv', C.titleReview, RVRUNG.map((k, j) => ({ v: String(k), label: String(k), count: rv[j], on: on('rv', String(k)), chip: k + (k < 5 ? '+ ' : ' ') + 'stars' })).filter(e => e.count > 0));
      /* STOCK: In-stock Only / Available / All - "Available" is live's default. An empty rung is
         dropped, and when that leaves "All" on its own (nothing available anywhere in the set) live
         drops the group whole rather than offering a choice of one. */
      var stv = STV.map((v, j) => ({ v: v, label: [C.stockIn || 'In-stock Only', C.stockAvail || 'Available', C.stockAll || 'All'][j], count: st[j], on: on('st', v) })).filter(e => e.count > 0);
      add('st', C.titleStock, (stv.length === 1 && stv[0].v === 'all') ? [] : stv);
      /* FITMENT */
      add('ft', C.titleFitment, FITV.filter(v => ft.has(v)).map(v => mark('ft')(ft.get(v))));
      this.chipsFor(out, C, s);
      return out;
    }
    /* chips describe the SELECTION, which outlives the rows: a value whose count another group drove
       to 0 is removed from its own group (live rule 2) but its filter is still applied */
    chipsFor(groups, C, s) {
      var titles = { cat: C.titleCategory, br: C.titleVendor, pr: C.titlePrice, rv: C.titleReview, st: C.titleStock, ft: C.titleFitment };
      groups.forEach(g => g.values.forEach(v => { if (v.v !== 'custom') this.flabels.set(g.key + ':' + v.v, v.chip || v.label); }));
      this.fchips = [];
      FKEYS.forEach(k => {
        var vals = FMULTI[k] ? s[k] : (s[k] ? [s[k]] : []);
        vals.forEach(v => this.fchips.push({ key: k, v: v, title: titles[k] || k, label: this.flabels.get(k + ':' + v) || v }));
        if (k === 'pr' && (s.min || s.max)) this.fchips.push({ key: 'pr', v: 'custom', title: titles.pr,
          label: (s.min ? this.money(s.min) : this.money(0)) + ' - ' + (s.max ? this.money(s.max) : (C.any || '*')) });
      });
    }
    money(dollars) { var v = Math.round(parseFloat(dollars) || 0); return (T.currencySymbol || '$') + String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    renderRail() {
      var groups;
      if (!this.ftpl || !this.rails.length || !this.pids || !this.done()) return;
      groups = this.facetGroups();
      this.rails.forEach(r => this.paintRail(r, groups));
    }
    paintRail(rail, groups) {
      var C = this.facetCfg(), F = this.ftpl.content, box = $(rail.root, '[data-facet-groups]');
      var gtpl = $(F, 'template[data-facet-group]'), rtpl = $(F, 'template[data-facet-row]');
      var ptpl = $(F, 'template[data-facet-price]'), stpl = $(F, 'template[data-facet-star]');
      var limit = rail.dialog ? Infinity : FLIMIT, state = rail.state;   /* live's drawer has no Show More */
      if (!box || !gtpl || !rtpl) return;
      $$(box, 'details[data-facet-field]').forEach(d => { state[d.dataset.facetField] = { open: d.open, more: d.dataset.more === '1' }; });
      clear(box);
      groups.forEach(g => {
        var frag = D.importNode(gtpl.content, true), det = $(frag, 'details'), ul = $(frag, '[data-facet-values]');
        var more = $(frag, '[data-facet-show-more]'), st = state[g.key], extras = 0, pf;
        det.dataset.facetField = g.key;
        det.open = st ? st.open : !rail.dialog;                          /* live: desktop open, drawer collapsed */
        if (st && st.more) det.dataset.more = '1';
        setText(det, '[data-facet-title]', g.title);
        g.values.forEach((v, i) => {
          var li = D.importNode(rtpl.content, true), row = $(li, 'li'), inp = $(li, 'input'), lab = $(li, '[data-facet-label]'), cnt = $(li, '[data-facet-count]');
          inp.checked = !!v.on; inp.value = v.v; inp.dataset.facetKey = g.key;
          if (g.key === 'rv') this.stars(lab, +v.v, stpl, C); else lab.textContent = v.label;
          cnt.textContent = v.count == null ? '' : String(v.count);
          if (i >= limit && !v.on) { row.className = this.P + '__filter-extra'; row.hidden = !(st && st.more); extras++; }
          ul.appendChild(li);
        });
        if (more) {
          more.hidden = !extras;
          more.setAttribute('aria-expanded', String(!!(st && st.more)));
          more.textContent = (st && st.more) ? (more.dataset.less || 'Show Less') : (more.dataset.more || 'Show More');
        }
        if (g.inputs && ptpl) {
          pf = D.importNode(ptpl.content, true);
          $(pf, '[data-facet-price-min]').value = this.fsel.min;
          $(pf, '[data-facet-price-max]').value = this.fsel.max;
          ul.parentNode.insertBefore(pf, more || null);
        }
        box.appendChild(frag);
      });
      this.paintChips(rail);
    }
    stars(host, n, stpl, C) {
      var wrap = D.createElement('span'), up, i, s, svg;
      clear(host);
      wrap.className = this.P + '__stars';
      for (i = 1; i <= 5; i++) {
        if (!stpl) break;
        s = D.importNode(stpl.content, true); svg = $(s, 'svg');
        svg.classList.add(this.P + '__star--' + (i <= n ? 'on' : 'off'));
        wrap.appendChild(s);
      }
      host.appendChild(wrap);
      if (n < 5) { up = D.createElement('span'); up.className = this.P + '__and-up'; up.textContent = ' ' + (C.andUp || 'and up'); host.appendChild(up); }
    }
    /* live: chips sit inside the rail above every group, in RAIL order (not click order), with a Start over button */
    paintChips(rail) {
      var C = this.facetCfg(), box = $(rail.root, '[data-facet-chips]'), list = $(rail.root, '[data-facet-chip-list]');
      var ctpl = $(this.ftpl.content, 'template[data-facet-chip]');
      if (!box || !list || !ctpl) return;
      clear(list);
      this.fchips.forEach(c => {
        var frag = D.importNode(ctpl.content, true), b = $(frag, '[data-facet-chip]');
        b.dataset.chipField = c.key; b.dataset.chipTerm = c.v;   /* NOT chipValue: it would shadow the [data-chip-value] span */
        b.setAttribute('aria-label', (C.remove || 'Remove filter') + ': ' + c.title + ' ' + c.label);
        setText(frag, '[data-chip-name]', c.title + ':');
        setText(frag, '[data-chip-value]', c.label);
        list.appendChild(frag);
      });
      box.hidden = !this.fchips.length;
    }
    facetToggle(inp) {
      var k = inp.dataset.facetKey, v = inp.value, s = this.fsel, i;
      if (!k) return;
      if (k === 'st') s.st = v;                                   /* radio: the checked rung cannot be un-checked */
      else if (k === 'rv') s.rv = inp.checked ? v : '';
      else if (v === 'custom') { s.min = ''; s.max = ''; }
      else { i = s[k].indexOf(v); if (inp.checked) { if (i < 0) s[k].push(v); } else if (i >= 0) s[k].splice(i, 1); }
      this.facetApply();
    }
    chipOff(chip) {
      var k = chip.dataset.chipField, v = chip.dataset.chipTerm, s = this.fsel, i;
      if (v === 'custom') { s.min = ''; s.max = ''; }
      else if (k === 'rv' || k === 'st') s[k] = '';
      else if (s[k]) { i = s[k].indexOf(v); if (i >= 0) s[k].splice(i, 1); }
      this.facetApply();
    }
    priceGo(btn) {
      var wrap = btn && btn.parentNode, mn = $(wrap, '[data-facet-price-min]'), mx = $(wrap, '[data-facet-price-max]'), num = el => el && el.value !== '' ? String(Math.max(0, parseFloat(el.value) || 0)) : '';
      if (!wrap) return;
      this.fsel.min = num(mn); this.fsel.max = num(mx);
      this.facetApply();
    }
    /* a facet click never refetches: the whole matched set is already in memory */
    facetApply(replace) {
      this.writeFacets(replace);
      this.page = 1; this.painted = 0; this.shown = 0;
      if (!this.pids || !this.done()) return;
      this.order = this.orderNow();
      if (this.order.length) this.paint(false); else this.empty();
    }
    /* Best Match score: F + base + review_score/10 + popularity (see the SORTS block). F is one
       constant per Fitment class, so in browse mode - where it is 0 for every row - it cancels out. */
    bmScore(pid) {
      var m = this.cardMeta(pid), c;
      if (!m) return 0;
      if (m.bm == null) {
        c = this.cards.get(pid);
        m.bm = (this.browse ? 0 : (FTERM[m.ft] != null ? FTERM[m.ft] : FTERM['vehicle-specific']))
          + (m.avail ? 0.7 : 0.1)
          + reviewScore(m.rating, m.reviews) / 10
          + boosts.of((c && (c.dataset.sku || '').trim()) || '');
      }
      return m.bm;
    }
    /* the keywords as words, for title scoring. One-letter tokens are dropped: they match
       everything and would flatten the ranking they are meant to sharpen. */
    tokens() { if (!this._tok) this._tok = this.terms().toLowerCase().split(' ').filter(w => w.length > 1); return this._tok; }
    /* SEARCH SYNONYMS 2026-10-13: the typed words with the store's synonym groups applied (theme.searchSyn, built
       by theme.js from the search_tools.synonyms metafield). null = no group matched, so nothing changes. */
    syn() {
      var api = W.theme && W.theme.searchSyn, t = this.dataset.scope === 'search' ? this.terms() : '', r;
      if (!api || !t) return null;
      if (!this._syn || this._syn.t !== t) { r = api.expand(t); this._syn = { t: t, r: r.slots.length ? r : null }; }
      return this._syn.r;
    }
    /* how much of what the shopper typed is in the TITLE: one point per word, one more for the whole
       phrase. Cached on the card's meta record, which is rebuilt with every run. */
    tscore(pid) {
      var m = this.cardMeta(pid), sy, sets, t;
      if (!m) return 0;
      if (m.ts == null) {
        t = ' ' + this.ctitle(pid).toLowerCase() + ' ';
        sy = this.syn(); sets = [this.tokens()];
        if (sy && sy.rewritten) sets.push(sy.rewritten.split(' ').filter(x => x.length > 1));   /* SEARCH SYNONYMS 2026-10-13 */
        m.ts = Math.max.apply(null, sets.map(w => w.reduce((n, x) => n + (t.indexOf(x) >= 0 ? 1 : 0), 0) + (w.length > 1 && t.indexOf(w.join(' ')) >= 0 ? 1 : 0)));
      }
      return m.ts;
    }
    /* LIGHT IS NOT LIGHTNING 2026-10-16: 1 = the card matched the typed words only as the START of a longer word
       ("light" in "F-150 Lightning", "150" in "1500"). Best Match puts those after every whole-word match. */
    kpart(pid) { var c = this.cards.get(pid); return c && !c.dataset.kwhole ? 1 : 0; }
    /* SEARCH 2026-10-10: Shopify's storefront search ignores AND - "(sku list) AND (winch)" comes
       back as the whole sku list, only re-ranked - so the words are applied here. A card is kept
       only when its title, brand and category names hold EVERY word typed, matched at the start of
       a word with a trailing s / es ignored ("covers" finds "Tonneau Cover", "lift" does not
       find "ReadyLIFT"). No words (a collection page) keeps every card. */
    khit(card, whole) {
      var sy = this.syn(), keep = x => x.length > 1 && KSTOP.indexOf(x) < 0, d = card.dataset, hay, hit;
      var w = (sy ? sy.words : this.tokens()).filter(keep);
      if (!w.length && !sy) return true;
      /* hyphens dropped on both sides, so "f150" finds "F-150" and "f-150" finds "F150" */
      hay = decode([d.title, d.vendor, (d.catnames || '').replace(/\|/g, ' ')].join(' ')).toLowerCase();
      /* whole (2026-10-16) also reads each hyphen as a space, so "roll up" is two whole words in "Roll-Up" */
      hay = ' ' + hay.replace(/-/g, '') + ' ' + (whole ? hay.replace(/-/g, ' ') + ' ' : '');
      hit = x => {
        var st = x.replace(/-/g, '');
        if (st.length > 3) st = st.replace(/(?:es|s)$/, '');
        /* whole (2026-10-16): the word has to END there too, a plural / -ing / -ed ending aside: "light" is light, lights,
           lighting or lighted, never "Lightning". Only ranks (kpart), never filters. */
        return new RegExp('(^|[^a-z0-9])' + st.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + (whole ? '(?:e|s|es|ing|ed)?(?![a-z0-9])' : '')).test(hay);
      };
      /* a synonym slot is satisfied by ANY of its alternatives having all of its own words (an alternative
         left with no usable word, e.g. "b and w", never counts) */
      return w.every(hit) && (!sy || sy.slots.every(s => s.alts.some(a => (a = a.filter(keep)).length && a.every(hit))));
    }
    cnum(pid, attr) { var c = this.cards.get(pid); return c ? (parseInt(c.dataset[attr], 10) || 0) : 0; }
    /* live rounds published_at DOWN to the UTC hour - every value the API returns ends :00:00 - so
       two products published in the same hour TIE and fall through to product id ASC, in both
       directions. Comparing full-second epochs orders those pairs by publish second instead. */
    cdate(pid) { return Math.floor(this.cnum(pid, 'published') / 3600); }
    ctitle(pid) { var c = this.cards.get(pid); return c ? decode(c.dataset.title || '') : ''; }
    /* Every live sort key falls back to _docid ASC, which is Shopify product id ASC (0 inversions in
       1,208 products). The index's own pid is a BUILD-ORDER position, not the product id (812
       inversions against it), so the tie-break - and "Featured", which is nothing but the tie-break -
       has to read data-pid off the card. */
    tie(a, b) { return this.cnum(a, 'pid') - this.cnum(b, 'pid') || a - b; }
    orderNow(raw) {
      var s = this.sort, all = this.done(), pids = this.pids.slice(), dir, P = this.ix && this.ix.data && this.ix.data.products,
        lone = pid => { var f = this.browse && P && P[pid] ? P[pid][1] : 0; return (f & 8) && !(f & 3) ? 1 : 0; };
      /* raw = the same order with NO facet applied; the rail uses it to order BRAND by first appearance */
      if (all) pids = pids.filter(pid => this.cards.has(pid) && (raw || this.fhit(pid)));
      if (!all) return pids.sort(numAsc);                      /* no cards yet: index order is all there is */
      if (FEATURED(s)) return pids.sort((a, b) => this.tie(a, b));
      if (BESTMATCH(s)) return this.tokens().length
        ? pids.sort((a, b) => lone(a) - lone(b) || this.kpart(a) - this.kpart(b) || this.tscore(b) - this.tscore(a) || this.bmScore(b) - this.bmScore(a) || this.tie(a, b))
        : pids.sort((a, b) => lone(a) - lone(b) || this.bmScore(b) - this.bmScore(a) || this.tie(a, b));
      if (s.indexOf('title') === 0) {
        dir = s === 'title-descending' ? -1 : 1;
        return pids.sort((a, b) => dir * cmpTitle(this.ctitle(a), this.ctitle(b)) || this.tie(a, b));
      }
      dir = /descending$/.test(s) ? -1 : 1;
      if (s.indexOf('price') === 0) return pids.sort((a, b) => dir * (this.cnum(a, 'priceFirst') - this.cnum(b, 'priceFirst')) || this.tie(a, b));
      return pids.sort((a, b) => dir * (this.cdate(a) - this.cdate(b)) || this.tie(a, b));
    }
    /* EVERY live sort key reads the cards - "Featured" included, because the index's pid is a build
       position and not the product id - so there is no correct partial order to paint. The first
       paint waits for the last chunk; the skeleton covers the gap. */
    afterChunk() {
      if (!this.done()) return;
      this.order = this.orderNow();
      return this.order.length ? this.paint(false) : this.empty();
    }
    /* live renders the brand line as <span class="productitem--vendor"><a href="/collections/bak-industries">.
       The card snippet can only emit a plain span, so the anchor is added at paint time: same text and
       same underline, but a real link - an href in the status bar, a keyboard focus stop, open-in-new-tab.
       The href follows the same rule as Grid.vendor(): the brand collection when the index knows the
       handle, else Shopify's automatic /collections/vendors?q= page. */
    vendorLink(card) {
      var span = $(card, '.product-card__vendor'), name, a, h, base;
      if (!span || span.firstElementChild) return;
      name = span.textContent.trim();
      if (!name) return;
      base = R.collections || '/collections';
      h = slugModel(name);
      a = D.createElement('a');
      a.href = (this.ix && this.ix.collIdxByHandle && this.ix.collIdxByHandle.has(h)) ? base + '/' + h : base + '/vendors?q=' + encodeURIComponent(name);
      a.textContent = name;
      span.textContent = '';
      span.appendChild(a);
    }
    property(card, pid, ix, v) {
      var form = $(card, 'form[action*="/cart/add"]'), q;
      v = v || this.matches.get(pid);
      ix = ix || this.ix;
      if (this.browse || this.partial) return;
      if (!form) return;
      if ((((ix && ix.data.products[pid]) || [0, 0])[1] & 2) || !v) return inject(form, T.propertyUniversal);
      /* CAB-ENGINE 2026-10-21 (order #1060): a card that fits the truck only on some cabs / engines never claims "Fits"
         for a truck that has not named them; the order line says which detail is unconfirmed */
      q = ix && typeof ix.needs === 'function' ? ix.needs(pid, v) : [];
      inject(form, q.length ? fmt(T.propertyUnconfirmed || 'Not confirmed for your __VEHICLE__ (__FIELDS__ not selected)', { __VEHICLE__: label(v), __FIELDS__: q.join(', ') }) : fmt(T.propertyFits, { __VEHICLE__: label(v) }));
    }
    /* SEARCH SYNONYMS 2026-10-13: say when a synonym changed what was searched (one line under the toolbar) */
    synNote(n) {
      var sy = n ? this.syn() : null, el = D.querySelector('[data-search-synonym-note]'), bar;
      if (!el && sy && sy.note && (bar = D.querySelector('.main-search__toolbar'))) {
        el = D.createElement('p'); el.className = 'main-search__synonym'; el.setAttribute('data-search-synonym-note', ''); el.setAttribute('role', 'status');
        bar.parentNode.insertBefore(el, bar.nextSibling);
      }
      if (!el) return;
      el.hidden = !(sy && sy.note);
      if (!el.hidden) el.textContent = (sy.note.oneWay ? 'Showing results for \u201c' : 'Including results for \u201c') + sy.note.to + '\u201d';
    }
    results(n, pages, page, text) {
      this.dataset.count = n; this.dataset.pages = pages; this.dataset.page = page; this.dataset.sort = this.sort;
      this.count(text); this.pills(); this.synNote(n);
      setText(this, '[data-facet-dialog-count]', fmt(T.resultsTitle || '__COUNT__ Results', { __COUNT__: n }));
      emit('fitment:results', { scope: this.dataset.scope, count: n, pages: pages, page: page, sort: this.sort, terms: this.dataset.terms || '', vehicles: store.ids() });
    }
    /* live: "{n} results" (never a vehicle name or page suffix); pages accumulate ("Next N" appends), the URL's page = pages shown */
    /* true while a keyword browse is still resolving: leave the server grid alone, it is a
       usable answer and the client one is seconds away, not milliseconds. */
    holdServer() { return !!this.browse && this.dataset.scope === 'search'; }
    paint(append) {
      /* held the server grid: take it out now, in the same frame as the swap. loading() never
         ran, so the chrome's sort select is still on its default and has to be told the order. */
      if (!this.chrome) { this.enter(); var sel0 = this.m(H('sort')); if (sel0) sel0.value = this.sort; }
      var order = this.order, pp = this.perPage, n = order.length, items = this.m(H('grid-items'));
      var pages = Math.max(1, Math.ceil(n / pp)), page = this.page = Math.min(Math.max(1, this.page), pages), from = append ? this.shown : 0, to = page * pp;
      var text = fmt(T.resultsCount || '__COUNT__ results', { __COUNT__: n });
      if (!append) clear(items);
      order.slice(from, to).forEach(pid => { var c = this.cards.get(pid); if (c) { this.property(c, pid); this.vendorLink(c); items.appendChild(c); } });
      this.shown = Math.min(to, n); this.painted = page;
      this.view('results'); this.loadMore(n); this.setState(this.browse ? 'browse-list' : this.partial ? 'partial' : 'vehicle');
      this.results(n, pages, page, text); this.renderRail();
    }
    loadMore(n) {
      var wrap = this.m(H('load-more-wrap')), btn = this.m(H('load-more')), left = n - this.shown,
          empty = left <= 0;
      if (!wrap || !btn) return;
      /* Live's .cm_loadMore never leaves the flow: with nothing left to load it is a 0 px tall box
         that still spends its 34 px top margin under the last row, and only the button goes. That
         34 px is a third of the height the collection page was short of live's. Scoped to the
         collection page - /search has not been measured against live for this yet. */
      if (this.dataset.scope === 'search') { wrap.hidden = empty; } else {
        wrap.hidden = false;
        wrap.classList.toggle('fitment-load-more--empty', empty);
        btn.hidden = empty;
      }
      btn.textContent = fmt(T.loadMore || 'Next __COUNT__', { __COUNT__: Math.min(this.perPage, Math.max(0, left)) });
      btn.dataset.page = String(this.painted + 1);
    }
    empty() {
      var vl = curLabel(), tm = this.dataset.terms || '', srch = this.dataset.scope === 'search', text;
      /* four cases, in the order they can happen: a keyword search with a vehicle, a keyword search
         without one, a browse list with nothing in it, a collection with nothing for this truck. */
      /* a keyword search whose collapsed set comes back empty falls back to the server's own
         results instead of telling the shopper there is nothing. A part number that only a child
         variant carries is the case that matters: the browse set holds masters only, so we would
         miss it and Shopify would not. Never with a vehicle - there "nothing fits your truck" is
         the true answer - and never once a facet is on, which the shopper can undo themselves. */
      if (srch && this.browse && tm && !this.facetsOn()) { this.fellBack = true; return this.leave(); }
      if (srch && !this.browse) text = fmt(T.resultsEmptySearch, { __VEHICLE__: vl, __TERMS__: tm });
      else if (srch && tm) text = fmt(T.resultsEmptyTerms || 'No products match "__TERMS__"', { __TERMS__: tm });
      else if (this.browse) text = T.resultsBrowseEmpty || 'No products found';
      else text = T.noResults || 'No results found.';
      this.enter();
      clear(this.m(H('grid-items')));
      setText(this.main, H('empty-text'), text);
      hide(this.main, '.fitment-results__reset', this.browse);
      this.view('empty'); this.setState('empty');
      this.results(0, 1, 1, fmt(T.resultsCount || '__COUNT__ results', { __COUNT__: 0 })); this.renderRail();
    }
    fail() {
      this.enter(); this.view('error');
      if (!this.origIn) { this.orig.forEach(n => this.main.appendChild(n)); this.origIn = true; }
      this.setState('error');
    }
    pills() {
      var box = this.m(H('vehicles')), sel = this.vsel(), act = store.active();
      if (!box) return;
      clear(box);
      sel.forEach(v => {
        var b = D.createElement('button'), on = !!act && act.id === v.id;
        b.type = 'button'; b.className = 'fitment-results__pill' + (on ? ' fitment-results__pill--active' : ''); b.dataset.vehicleId = v.id; b.textContent = label(v);
        if (on) b.setAttribute('aria-current', 'true');
        box.appendChild(b);
      });
      box.hidden = this.browse || !!this.partial || sel.length < 2;
    }
  }

  /* ---------- <pt-fitment-verify data-role="master|child|standalone|universal"> ---------- */
  /* PDP parity 2026-09-10 (live #cm-verify-fitment): the header is collapsed on load and toggles the selector; the vehicle
     applies on the last select (no GO click); "(Change)" re-opens the selector inline, prefilled; Clear never touches the
     store; a child that does not fit but has a fitting sibling is location.replace()d there (no query string) and a master
     routes the same way; the red panel appears only when nothing in the group fits. */
  class Verify extends Base {
    bind() {
      var role = this.dataset.role, sc = this.$('script[data-fitment-rows]');
      this.form = D.querySelector('form.main-product__form') || D.querySelector('form[action*="/cart/add"]');
      this.selector = this.$('pt-vehicle-select');
      this.expanded = true; this.editing = false; /* 2026-09-14 (owner, action C): the selector is open on load */
      try { this.rows = sc ? JSON.parse(sc.textContent) : null; } catch (e) { this.rows = null; }
      /* the group's routing table, embedded by fitment-verify.liquid (head copy as the fallback). With it, a
         child / master routes with no index download - the second half of the 2026-09-10 PDP speed fix. */
      try {
        var sb = this.$('script[data-fitment-siblings]') || D.getElementById('fitment-route-data');
        var sj = sb ? JSON.parse(sb.textContent) : null;
        this.sibs = sj && (sj.p ? sj : sj.s) || null;
        if (this.sibs && !(this.sibs.p instanceof Array)) this.sibs = null;
      } catch (e) { this.sibs = null; }
      /* 2026-10-28: a version picked from another version keeps its page for the truck active now (fromVersion) */
      this.pickedV = role === 'child' && fromVersion(this.sibs, this.dataset.handle || '') ? (store.active() || {}).id || null : null;
      /* no fitment data at all: nothing renders (live's CSS net hides the block) but the empty cart property is live's */
      if (role === 'none') return inject(this.form, '');
      if (role === 'universal') { if (this.dataset.showUniversal === 'false') this.hidden = true; else inject(this.form, T.propertyUniversal); return; }
      if (role !== 'master' && !(this.rows && Array.isArray(this.rows.r))) return this.show('unknown');
      this.listen(this, 'click', e => {
        var t = e.target;
        if (t.closest(H('toggle'))) this.expand(!this.expanded);
        else if (t.closest(H('change'))) this.edit();
        else if (t.closest(H('route'))) { this.forceRoute = true; this.update('select', true); }
      });
      /* live: the cart property follows an incomplete selection the moment that selection already rules the product
         out ("Doesn't fit your 2019 Ford" after the Make, in a fresh selection as well as in change mode), and an
         incomplete Year/Make/Model that rules it out swaps the page for the fitting sibling without storing anything */
      this.listen(this, 'fitment:partial', e => {
        var d = e.detail || {};
        if (!d.y || d.complete || !this.rows || !Array.isArray(this.rows.r) || !misses(this.rows.r, d)) return;
        inject(this.form, fmt(T.propertyNoFit, { __VEHICLE__: label(d) }));
        /* 2026-09-18 (owner): no page swap on an INCOMPLETE selection - it threw the shopper to a new page mid-entry and lost the picks. Routing waits for a complete vehicle. */
      });
      /* CAB-ENGINE 2026-10-23 (owner: "picked the engine, nothing happened"): while this selector waits on a Cab or an
         Engine, the line above it says which ones ("Please specify Cab for your 2018 GMC Sierra 2500 HD 6.6L V8 Duramax") */
      this.listen(this, 'fitment:partial', e => {
        var d = e.detail || {}, n = this.$(H('verify-hint')), miss;
        if (!n || !this.selector || d.element !== this.selector) return;
        miss = d.complete ? [] : this.selector.missing();
        /* only a Cab / Engine question is this listener's: a bed hint (action A) behaves exactly as before */
        if (miss.indexOf(F_CAB) < 0 && miss.indexOf(F_ENG) < 0) { if (n.dataset.ask) { n.hidden = true; n.textContent = ''; delete n.dataset.ask; } return; }
        n.hidden = false; n.dataset.ask = '1';
        n.textContent = fmt(T.inexact, { __FIELDS__: miss.join(', '), __VEHICLE__: label({ y: d.y, mk: d.mk, md: d.md, sub: d.sub, cab: d.cab, eng: d.eng, bed: d.bed }) });
      });
      /* FIT OPTIONS 2026-10-28: the Body Style and Option questions under the verdict (fitment-verify.liquid) */
      this.askBody = this.$('[data-fitment-ask-field="body"] select');
      this.askOpt = this.$('[data-fitment-ask-field="option"] select');
      this.listen(this.askBody, 'change', () => this.pickBody(this.askBody.value));
      this.listen(this.askOpt, 'change', () => this.pickOpt(this.askOpt.value));
      this.listen(this.$(H('gf-btn')), 'click', () => { var b = this.$(H('gf-btn')), t = this.$(H('gf-tip')), open = !!t && t.hidden; if (t) t.hidden = !open; if (b) b.setAttribute('aria-expanded', String(open)); });
      this.onChange(d => this.update(d.reason));
      this.update('restore');
      /* action C: an open selector needs its Year list before the first tap (a native picker opened by the tap that
         starts the index download shows only the placeholder), so the index is pulled once the page has settled */
      if (this.selector && this.dataset.state === 'idle') {
        var pull = () => { if (this.isConnected && this.dataset.state === 'idle' && !this.hidden) this.selector.ensure(); };
        var settle = () => { if (W.requestIdleCallback) W.requestIdleCallback(pull, { timeout: 3000 }); else W.setTimeout(pull, 1500); };
        if (D.readyState === 'complete') settle(); else W.addEventListener('load', settle, { once: true });
      }
    }
    flag(b) { var h = this.$(H('toggle')); this.expanded = !!b; this.dataset.expanded = String(this.expanded); if (h) h.setAttribute('aria-expanded', String(this.expanded)); }
    expand(b) {
      this.flag(b);
      if (this.dataset.state === 'idle') this.hide(H('verify-body'), !this.expanded);
      if (this.expanded && this.selector) this.selector.ensure(); /* live: Year is populated the moment the body opens */
    }
    show(state) {
      var idle = state === 'idle', blank = state === 'routing' || state === 'unknown', n;
      this.dataset.state = state;
      Array.from(this.classList).forEach(c => { if (/^fitment-verify--/.test(c) && c !== 'fitment-verify--' + this.dataset.role) this.classList.remove(c); });
      this.classList.add('fitment-verify--' + state);
      /* FIT OPTIONS (owner 10-28, realtruck.com): an open question shows the same green panel as a fit, the question sits
         under it as its own field; data-state stays 'ask' so Add to Cart still waits for the answer */
      if (state === 'ask') this.classList.add('fitment-verify--fits');
      this.hidden = state === 'unknown'; /* live nets cmTemplate_unknown store-wide: nothing renders */
      if (state === 'unknown') inject(this.form, ''); /* ...but it still carries the empty cart property */
      this.flag(idle); this.hide(H('verify-hint'), true); /* action C: an idle widget is open; a locked panel replaces the header */
      this.hide(H('verify-body'), !(idle && this.expanded)); this.hide(H('verify-result'), idle || blank);
      this.hide(H('verify-link-wrap'), true); this.hide(H('route'), true);
      if ((n = this.hide(H('verify-note'), true))) n.textContent = '';
      this.set(H('verdict-label'), ''); this.set(H('vehicle'), '');
      /* FIT OPTIONS 2026-10-28: each state paints its own questions; a state that is not 'ask' drops the cart warning */
      this.hide(H('ask'), true); $$(this, '[data-fitment-ask-field]').forEach(f => { f.hidden = true; });
      this.hide(H('gf-btn'), true); this.hide(H('gf-tip'), true); if ((n = this.$(H('gf-btn')))) n.setAttribute('aria-expanded', 'false');
      if (state !== 'ask') this.atcMsg('');
    }
    /* action A: a vehicle this product (or its group) cannot answer without a missing field - open the selector
       prefilled with that vehicle and name the field, instead of guessing a product or showing a dead-end panel */
    askBed(v, fields) {
      var n;
      this.show('idle'); this.expand(true);
      if (this.selector) this.selector.setValue(v);
      if ((n = this.hide(H('verify-hint'), false))) {
        n.textContent = fmt(T.inexact, { __FIELDS__: (fields && fields.length ? fields : [T.bed]).join(', '), __VEHICLE__: label(v) });
        if (fields && (fields.indexOf(F_CAB) >= 0 || fields.indexOf(F_ENG) >= 0)) n.dataset.ask = '1'; else delete n.dataset.ask; /* CAB-ENGINE: the partial listener keeps it current */
      }
    }
    link(href) { var l = this.$(H('verify-link')); this.hide(H('verify-link-wrap'), false); if (l) l.setAttribute('href', href); }
    current(v) { var a = store.active(); return !!a && a.id === v.id; }
    /* index twin of sibBedAmbiguous(), for a page without the embedded group table */
    ixBedAmbiguous(ix, v, sku) {
      var gi = ix.groupIdxByName.get(this.dataset.group), mi = ix.modelIdx(v.mk, v.md), P = ix.data.products, beds = new Set();
      if (v.bed || gi == null || mi == null) return false;
      ix.runs(mi).forEach(r => { var q = P[r[0]]; if (r[3] !== -1 && inRun(r, v.y) && q[2] === gi && q[0] && q[0] !== sku && !(q[1] & 1)) beds.add(r[3]); });
      return bedGroups(Array.from(beds).map(i => slugBed(ix.data.beds[i]))) > 1;
    }
    handleFor(ix, v, sku) { var gi = ix.groupIdxByName.get(this.dataset.group); return gi == null ? null : ix.routeSibling(gi, v, sku); }
    /* CAB-ENGINE 2026-10-21: index twin of sibQualNeed() for a page without the embedded group table */
    ixQualNeed(ix, v, sku) { var gi = ix.groupIdxByName.get(this.dataset.group); return gi == null ? [] : ix.qualNeed(gi, v, sku); }
    /* every field the group needs before it can route v: the bed (action A) and the cab / engine */
    sibAsk(v, sku) { var S = this.sibs, f = sibQualNeed(S, v, sku, this.dataset.handle || ''); if (sibBedAmbiguous(S, v, sku, this.dataset.handle || '')) f.unshift(T.bed); return f; }
    ixAsk(ix, v, sku) { var f = this.ixQualNeed(ix, v, sku); if (this.ixBedAmbiguous(ix, v, sku)) f.unshift(T.bed); return f; }
    /* the red panel: "This Product DOES NOT Fit Your / <vehicle> (Change) / Click here for products that do fit your vehicle" (child with no fitting sibling, or a master nothing fits) */
    noFit(state, lb) {
      this.show(state); this.set(H('verdict-label'), T.noFit); this.set(H('vehicle'), lb); this.link(withVehicle(R.all)); this.catLink();
      /* FIT OPTIONS 2026-10-28: it fits the other body of this two-body year: the Body Style stays on screen to change */
      if (this.fc && this.fc.tw && this.fc.only && state === 'nofit') this.bodyField(store.active(), this.fc);
    }
    /* 2026-10-03 owner: "Click here for products that do fit" should open what the shopper came for (other tonneau
       covers, not random parts). R.fitCat = this product's category page (fitment-boot.liquid). The link is upgraded only
       once the index proves that category holds something for the active vehicle, so it can never open an empty page. */
    catLink() { var v = store.active(), h = R.fitCat && R.fitCat.split('/').pop(); if (!v || !h) return;
      index.load().then(ix => { var ci = ix.data.collections.findIndex(c => c && c.h === h);
        if (ci >= 0 && ix.match([v], { collIdx: ci, strictGroups: S.strictGroups }).size) this.link(withVehicle(R.fitCat)); }).catch(() => {}); }
    /* "(Change)": the panel gives way to the header + the selector prefilled with the stored vehicle (placeholders stripped, GO + Clear enabled);
       store, pill and cart property stay as they are until a complete vehicle is picked; Clear only resets the selects */
    edit() {
      var v = store.active();
      if (!v || !this.selector) return;
      this.editing = true;
      this.show('idle'); this.expand(true);
      this.selector.setValue(v);
    }
    /* a vehicle picked somewhere else: an idle widget does not move at all; a locked / red / master panel gives way to
       the idle widget with its selector prefilled with the vehicle it had verified, exactly like Convermax's
       cmTemplate_active. The body is left collapsed, i.e. the widget looks the way it does on a load with no vehicle. */
    detach() {
      var prev = this.shown;
      if (this.dataset.state === 'idle' || this.hidden) return;
      this.editing = false;
      this.show('idle');
      if (this.selector && prev) this.selector.setValue(prev);
    }
    /* live parity 2026-09-10 (measured on prestigetruck.com): this widget verdicts - and routes - ONLY for its
       own selector and for a page load. A vehicle picked in the header pill, a garage row or a band leaves an
       idle widget completely untouched and drops a locked panel back to the selector prefilled with the vehicle
       it had verified. It never navigates off the product page. */
    update(reason, forced) {
      var v = store.active(), role = this.dataset.role, lb = label(v), r, n;
      if (!forced && !LOADR.test(reason || '') && !(origin && this.contains(origin))) return this.detach();
      this.editing = false; /* any store change ends change mode: a new vehicle re-locks the panel, a clear shows the selector */
      this.shown = v;
      this.foSeq = (this.foSeq || 0) + 1; /* FIT OPTIONS: a versions fetch still in flight for an earlier truck is dropped */
      if (!v) { this.show('idle'); return removeProp(this.form); }
      if (role === 'master') return this.master(v);
      /* FIT OPTIONS 2026-10-28: fitCheck() = verdict() + the Body Style of a two-body year + the notes still to confirm */
      r = this.fc = fitCheck(this.rows.r, v, fitAns.body(v));
      if (r.state === 'body') return this.bodyAsk(v, lb, r);
      if (r.state === 'fits') return this.fitsNow(v, lb, r);
      if (r.state === 'inexact') {
        this.askBed(v, r.fields); /* action A: ask for the missing field in the open selector, never a dead-end panel */
        /* CAB-ENGINE 2026-10-21: a missing cab / engine is never "Fits your ..." on the order line */
        inject(this.form, r.fields.indexOf(F_CAB) >= 0 || r.fields.indexOf(F_ENG) >= 0
          ? fmt(T.propertyUnconfirmed || 'Not confirmed for your __VEHICLE__ (__FIELDS__ not selected)', { __VEHICLE__: lb, __FIELDS__: r.fields.join(', ') })
          : fmt(T.propertyInexact, { __VEHICLE__: lb }));
      } else {
        inject(this.form, fmt(T.propertyNoFit, { __VEHICLE__: lb }));
        if (role === 'child' && this.dataset.group) { this.show('routing'); this.sibling(v, lb); } /* live paints NOTHING in the slot while the sibling is looked up, then replaces the page */
        else this.noFit('nofit', lb);
      }
    }
    /* ---------- FIT OPTIONS 2026-10-28: RealTruck's Option drill, and the Body Style of a two-body year ---------- */
    /* the truck fits on its year / make / model / bed / cab / engine: confirm whatever else it depends on. A grouped child
       asks over every version that carries the truck (their rows fetched once per tab); until they arrive, a part with
       nothing of its own to confirm stays amber, never a "Fits" that a version's question could take back. */
    fitsNow(v, lb, r) {
      var h = this.dataset.handle || '', seq = this.foSeq, me = { h: h, d: r }, c = [];
      if (this.dataset.role === 'child' && this.sibs) c = sibCands(this.sibs, v, this.dataset.sku || '', h).map(x => x.h).filter((x, i, a) => x && x !== h && a.indexOf(x) === i).slice(0, 10);
      if (!c.length) return this.offer(v, lb, [me]);
      if (r.sure) this.pending(v, lb); else this.offer(v, lb, [me], true);
      Promise.all(c.map(x => fetchRows(x).then(j => j && Array.isArray(j.r) && !j.u ? { h: x, d: fitCheck(j.r, v, fitAns.body(v)) } : null)))
        .then(list => { if (seq === this.foSeq && this.current(v)) this.offer(v, lb, [me].concat(list)); });
    }
    /* members = [this page, ...versions]; `early` = this page's own list while the versions are still loading */
    offer(v, lb, ms, early) {
      var me = this.dataset.handle || '', o = fitOptions(ms), a = fitAns.opt(v, me), d = ms[0].d, pick;
      this.fo = { v: v, list: o.list, none: o.none };
      if (!o.list.length) return this.fitsPaint(v, lb, d, '');
      pick = a === NONE ? { k: NONE, h: o.none } : o.list.find(x => x.k === a) || null;
      if (pick && pick.h === me) return this.fitsPaint(v, lb, d, pick.k === NONE ? fmt(T.noneDetail || 'none of: __LIST__', { __LIST__: o.list.map(x => x.t).join('; ') }) : pick.t, pick.k);
      if (pick && pick.k === NONE && !pick.h && !early) return this.noneFits(v, lb);
      this.show('ask'); this.okLabel(); this.set(H('vehicle'), lb);
      this.bodyField(v, d);
      this.optField(o.list, '');
      inject(this.form, fmt(T.propertyUnconfirmed, { __VEHICLE__: lb, __FIELDS__: T.option }));
      ss(FROM, null);   /* settled here, as a "Fits" does: a later route back to the page we came from is not a bounce */
    }
    /* the panel while the versions load (Add to Cart waits until it is known whether a question follows) */
    pending(v, lb) { this.show('ask'); this.okLabel(); this.set(H('vehicle'), lb); inject(this.form, fmt(T.propertyUnconfirmed, { __VEHICLE__: lb, __FIELDS__: T.option })); ss(FROM, null); }
    /* RealTruck: "Guaranteed Fit" + its info button (theme setting, on by default), else "Fits Your Vehicle" */
    okLabel() { var g = !!(S.guaranteedFit && T.guaranteedFit); this.set(H('verdict-label'), g ? T.guaranteedFit : T.fits); this.hide(H('gf-btn'), !g); }
    fitsPaint(v, lb, d, detail, key) {
      var n, parts = [];
      this.show('fits'); this.set(H('vehicle'), lb);
      this.okLabel();
      var shown = this.bodyField(v, d), info = d.info.filter(x => !(shown && FO_GEN.test(String(x).trim())));   /* the select says it */
      if (info.length && (n = this.hide(H('verify-note'), false))) n.textContent = info.join('; ');
      if (shown) parts.push(this.bodyLabel(v, d));
      if (key && this.fo && this.fo.list.length) this.optField(this.fo.list, key);   /* RealTruck keeps the answered drill on screen */
      if (detail) parts.push(detail);
      inject(this.form, fmt(T.propertyFits, { __VEHICLE__: lb }) + (parts.length ? ' (' + parts.join('; ') + ')' : ''));
      ss(FROM, null);
    }
    /* "None of these" and nothing in the product line fits without one of them */
    noneFits(v, lb) {
      inject(this.form, fmt(T.propertyNoFit, { __VEHICLE__: lb }));
      this.noFit('nofit', lb);
      if (this.fo && this.fo.list.length) this.optField(this.fo.list, NONE);
    }
    /* a two-body year and this product fits one of them: which body is the truck? */
    bodyAsk(v, lb, r) {
      this.show('ask'); this.okLabel(); this.set(H('vehicle'), lb);
      this.bodyField(v, r, true);
      inject(this.form, fmt(T.propertyUnconfirmed, { __VEHICLE__: lb, __FIELDS__: T.bodyStyle }));
      ss(FROM, null);
    }
    /* the Body Style select: shown while the body decides this product (it fits one of the two), with the truck's body
       picked when it is known; true when shown */
    bodyField(v, d, force) {
      var s = this.askBody, f = s && s.closest('[data-fitment-ask-field]'), e = d && d.tw, b, help;
      if (!f || !e || !(force || d.only)) return false;
      b = vBody(e, v, fitAns.body(v)) || '';
      this.fillAsk(s, [['new', e[5]], ['old', e[6]]], T.selectBodyStyle || T.bodyStyle, b);
      if ((help = f.querySelector(H('ask-help')))) { help.textContent = e[9] || ''; help.hidden = !e[9] || !!b; }
      f.hidden = false; this.hide(H('ask'), false);
      return true;
    }
    /* the order line's body words ("Legacy, 2018 Body Style"): the Model list's hint, so no bracket inside the line's own */
    bodyLabel(v, d) { var e = d.tw, b = vBody(e, v, fitAns.body(v)); return b === 'old' ? e[11] : e[10]; }
    optField(list, cur) {
      var s = this.askOpt, f = s && s.closest('[data-fitment-ask-field]');
      if (!f) return;
      this.fillAsk(s, list.map(x => [x.k, x.t]).concat([[NONE, T.noneOfThese]]), T.selectOption || T.option, cur);
      f.hidden = false; this.hide(H('ask'), false);
    }
    fillAsk(s, pairs, ph, cur) {
      var o;
      while (s.options.length) s.remove(0);
      o = D.createElement('option'); o.value = ''; o.textContent = ph; s.appendChild(o);
      pairs.forEach(p => { o = D.createElement('option'); o.value = p[0]; o.textContent = p[1]; s.appendChild(o); });
      s.value = cur && pairs.some(p => p[0] === cur) ? cur : '';
      if (s.value) s.options[0].remove();
      s.disabled = false;
      s.classList.toggle('is-needed', !s.value);
    }
    pickOpt(k) {
      var fo = this.fo, v = fo && fo.v, me = this.dataset.handle || '', t;
      if (!v || !k || !this.current(v)) return;
      t = k === NONE ? { k: NONE, h: fo.none } : fo.list.find(x => x.k === k);
      if (!t) return;
      fitAns.setOpt(v, t.h || me, k);
      if (!t.h || t.h === me) return this.update('select', true);
      /* another version of this product carries that option: go there, as RealTruck's drill lands on that SKU */
      this.show('routing'); ss(FROM, me); W.location.replace(root + 'products/' + t.h);
    }
    pickBody(b) {
      var v = store.active(), e = twinFor(v), md, want, nv;
      if (!v || !e || (b !== 'new' && b !== 'old')) return;
      md = slugModel(v.md); want = b === 'old' ? e[2] : e[1];
      /* Jeep's plain "Wrangler" covers both bodies: the answer is kept with the truck. Anywhere else each body has its own
         model, so the garage entry becomes that model (and every grid then shows that truck's parts). */
      if ((e[8] && md === slugModel(e[8])) || slugModel(want) === md) { fitAns.setBody(v, b); return this.update('select', true); }
      nv = Object.assign({}, v, { md: want, t: Date.now() }); nv.id = vehicleId(nv);
      fitAns.setBody(nv, b);
      origin = this;
      try { store.swap(v.id, nv, 'select'); } finally { origin = null; }
    }
    /* ---------- FIT OPTIONS 2026-10-28: Add to Cart ----------
       realtruck.com greys Add to Cart out until the truck and every option are chosen. GMC needs a button that works
       (feedback 2026-09-01), so ours stays clickable and a click that would add an unconfirmed part shows the question
       instead (settings.fitment_atc_guard: full = also with no truck chosen, answers = only once a truck is chosen, off). */
    blocker() {
      var st = this.dataset.state, role = this.dataset.role, v = store.active(), g = S.atcGuard || 'full';
      if (g === 'off' || this.hidden || role === 'none' || role === 'universal' || st === 'fits' || st === 'unknown') return null;
      if (!v || st === 'idle' || st === 'master-locked') return g === 'full' || v ? 'vehicle' : null;
      if (st === 'ask') return 'option';
      if (st === 'nofit' || st === 'master-nofit') return 'nofit';
      return st === 'routing' ? 'wait' : null;
    }
    nudge(k) {
      var v = store.active(), t, rm = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (k === 'wait') return;
      if (k === 'vehicle' && this.dataset.state !== 'idle') this.edit();
      if (k === 'vehicle' && this.dataset.state === 'idle') this.expand(true);
      this.atcMsg(k === 'option' ? T.atcOption : k === 'nofit' ? fmt(T.atcNoFit, { __VEHICLE__: label(v) }) : T.atcVehicle);
      t = k === 'option' ? this.$('[data-fitment-ask] select.is-needed') || this.$('[data-fitment-ask] select')
        : k === 'vehicle' ? $$(this, 'pt-vehicle-select select').find(s => !s.disabled && !s.value && !s.closest('[hidden]')) || this
        : this.$(H('verify-result')) || this;
      this.scrollIntoView({ block: 'center', behavior: rm ? 'auto' : 'smooth' });
      if (t) { t.classList.remove('fitment-flash'); void t.offsetWidth; t.classList.add('fitment-flash'); W.setTimeout(() => t.classList.remove('fitment-flash'), 1400); }
    }
    /* the one line under Add to Cart that says why nothing was added ('' removes it) */
    atcMsg(text) {
      var f = this.form, m = f && f.querySelector('[data-fitment-atc-msg]'), row;
      if (!f) return;
      if (!text) { if (m) m.remove(); return; }
      if (!m) {
        m = D.createElement('p'); m.className = 'fitment-atc-msg'; m.setAttribute('role', 'alert'); m.setAttribute('data-fitment-atc-msg', '');
        row = f.querySelector('.main-product__buy-row');
        if (row) row.insertAdjacentElement('afterend', m); else f.appendChild(m);
      }
      m.textContent = text;
    }
    /* judge item 14: an incomplete Year/Make/Model that rules this child out lands on the sibling that carries it,
       with the bed the shopper is already on, WITHOUT storing a vehicle - the sibling then opens idle and collapsed */
    partialRoute(d) {
      if (this.routing) return;
      var beds = new Set(), part = { y: +d.y, mk: d.mk, md: d.md }, sku = this.dataset.sku || '', hd = this.dataset.handle || '';
      (this.rows.r || []).forEach(r => { if (r[4]) beds.add(r[4]); });
      var bed = beds.size === 1 ? Array.from(beds)[0] : null;
      var jump = h => { if (!h || h === this.dataset.handle || this.routing) return; this.routing = true; ss(FROM, null); W.location.replace(root + 'products/' + h); };
      if (this.sibs) return jump(sibRoutePartial(this.sibs, part, sku, hd, bed));
      index.load().then(ix => {
        var gi = ix.groupIdxByName.get(this.dataset.group);
        if (gi == null || this.routing) return;
        jump(ix.routeSiblingPartial(gi, part, sku, bed));
      }, noop);
    }
    /* child nofit: location.replace() to the fitting sibling (no query string; sessionStorage bounce guard), else the red panel */
    sibling(v, lb) {
      /* 2026-10-28: the shopper opened this version from another one: its own verdict for that truck, no route back.
         A truck chosen here afterwards routes as before. */
      if (this.pickedV && v.id === this.pickedV) { ss(FROM, null); return this.noFit('nofit', lb); }
      var land = h => {
        if (h === false) return;
        if (h && ss(FROM) !== h) { ss(FROM, this.dataset.handle || ''); W.location.replace(root + 'products/' + h); return; }
        ss(FROM, null);
        if (this.current(v)) this.noFit('nofit', lb);
      };
      /* the embedded group table decides synchronously; the index stays the fallback for a page that has none */
      var ask;
      if (this.sibs) {
        if (this.current(v) && (ask = this.sibAsk(v, this.dataset.sku || '')).length) return this.askBed(v, ask); /* action A + CAB-ENGINE */
        return land(this.current(v) ? sibRoute(this.sibs, v, this.dataset.sku || '', this.dataset.handle || '') : false);
      }
      index.load().then(ix => { if (this.current(v) && (ask = this.ixAsk(ix, v, this.dataset.sku || '')).length) return this.askBed(v, ask); land(this.current(v) ? this.handleFor(ix, v, this.dataset.sku || '') : false); },
        () => { if (this.current(v)) this.noFit('nofit', lb); });
    }
    master(v) {
      var lb = label(v), rb;
      if (this.dataset.autoRoute === 'false' && !this.forceRoute) {
        this.show('master-locked'); this.set(H('vehicle'), lb);
        if ((rb = this.hide(H('route'), false))) rb.textContent = fmt(T.findVersion, { __VEHICLE__: lb });
        return;
      }
      if (this.routed === v.id) return;
      var ask;
      if (this.sibs && (ask = this.sibAsk(v, '')).length) return this.askBed(v, ask); /* action A + CAB-ENGINE */
      this.show('routing'); /* live paints nothing in the slot while the decision is made, then replaces the page (no query string) */
      var land = h => {
        if (h === false) return;
        if (!h) { inject(this.form, fmt(T.propertyNoFit, { __VEHICLE__: lb })); return this.noFit('master-nofit', lb); }
        this.routed = v.id;
        ss(FROM, this.dataset.handle || '');
        W.location.replace(root + 'products/' + h);
      };
      if (this.sibs) return land(this.current(v) ? sibRoute(this.sibs, v, '', this.dataset.handle || '') : false);
      index.load().then(ix => { if (this.current(v) && (ask = this.ixAsk(ix, v, '')).length) return this.askBed(v, ask); land(this.current(v) ? this.handleFor(ix, v, '') : false); }, () => this.show('idle'));
    }
  }

  /* ---------- boot (§3.1): store.load() -> index trigger -> listeners -> define elements LAST -> fitment:change ---------- */
  var mode = store.load(), dialogEl = null;
  var define = (name, cls) => { if (!W.customElements.get(name)) W.customElements.define(name, cls); };
  /* speed 2026-09-10 / 2026-09-11: the index is fetched only by a page that actually resolves a
     vehicle against it. A product page never does (the verdict comes from the embedded rows and the
     routing from the embedded group table), and neither do the home page, the cart, a blog post or a
     policy page - which were all still pulling 103 KB just because a vehicle was stored. A grid page
     pulls it itself, inside Grid.run(), and only when its resolved-set cache misses. Everywhere else
     the vehicle selector's ensure() pulls it on the first pointerenter / focusin / touchstart.
     A URL vehicle id we cannot resolve locally still needs it up front. */
  /* search parity 2026-09-11: the search grid never resolves a vehicle (the query owns that page),
     so it never calls Grid.run() and never pulls the index. /search falls back to the idle prefetch,
     like any page with no grid, or to the selector's own ensure() on first interaction. */
  var hasGrid = !!D.querySelector('pt-fitment-grid:not([data-scope="search"])');
  if (mode === 'pending') index.load().catch(noop);
  else if (hasGrid) noop();
  else if (S.prefetch && !store.selected().length) {
    /* an idle prefetch must not compete with the page's own first paint */
    var idle = () => { var f = () => index.load().catch(noop); if (W.requestIdleCallback) W.requestIdleCallback(f, { timeout: 6000 }); else W.setTimeout(f, 1200); };
    if (D.readyState === 'complete') idle(); else W.addEventListener('load', idle);
  }
  W.addEventListener('storage', e => { if (e.key === KEY) store.reload('storage'); });
  D.addEventListener('fitment:open', e => {
    var t = D.getElementById('FitmentDialogTemplate'), frag;
    index.load().catch(noop);
    if (!dialogEl && t) { frag = D.importNode(t.content, true); dialogEl = $(frag, 'pt-vehicle-dialog'); D.body.appendChild(frag); }
    if (dialogEl && typeof dialogEl.open === 'function') dialogEl.open(e.detail || {});
  });
  /* TRUCK PAGE 2026-10: a [data-fitment-open-page] button (truck-finder banner) opens the dialog locked to the page truck */
  D.addEventListener('click', e => { var b = e.target && e.target.closest ? e.target.closest('[data-fitment-open-page]') : null; if (!b) return; e.preventDefault(); openDialog('select', b, undefined, !!pageLock()); });
  D.addEventListener('fitment:change', e => {
    var d = e.detail, v = d.active, k = W.klaviyo;
    if (!S.klaviyo || USER.indexOf(d.reason) < 0 || !v || !k || typeof k.push !== 'function') return;
    if (cfg.customer) k.push(['identify', { $email: cfg.customer }]);
    k.push(['track', 'Vehicle Selected', { Year: v.y, Make: v.mk, Model: v.md, Bed: v.bed || '', VehicleId: v.id, Garage: d.vehicles.length }]);
  });
  /* FIT OPTIONS 2026-10-28: Add to Cart on a product page adds only a part confirmed for the shopper's truck (Verify.blocker).
     Capture phase on window, so it runs before theme.js's ajax add, the free-gift add (pt-pdp-modes.js) and the bundle
     button (pt-bundle.js), which all listen further down. Every other form (a card's quick add, the cart) is untouched. */
  var atcGate = (e, viaForm) => {
    var ver = D.querySelector('pt-fitment-verify'), k;
    if (!ver || typeof ver.blocker !== 'function' || (viaForm && ver.form !== e.target) || !(k = ver.blocker())) return;
    e.preventDefault(); e.stopImmediatePropagation();
    ver.nudge(k);
  };
  W.addEventListener('submit', e => { if (e.target instanceof HTMLFormElement) atcGate(e, true); }, true);
  W.addEventListener('click', e => { if (e.target && e.target.closest && e.target.closest('[data-bundle-add]')) atcGate(e, false); }, true);
  define('pt-vehicle-select', VehicleSelect); define('pt-vehicle-dialog', VehicleDialog); define('pt-garage', Garage);
  define('pt-fitment-band', Band); define('pt-facet-dialog', FacetDialog); define('pt-fitment-grid', Grid); define('pt-fitment-verify', Verify);
  if (mode === 'pending') store.applyIds(store.pending, 'url'); else store.emit(mode);
  if (!D.querySelector('pt-fitment-grid')) html.classList.remove('fitment-pending');
})(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this);
